window.evertestAnimation2 = {
    "nm": "Animation",
    "ddd": 0,
    "h": 732,
    "w": 764,
    "meta": {
        "g": "@lottiefiles/toolkit-js 0.76.0"
    },
    "layers": [
        {
            "ty": 0,
            "nm": "Popup ",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "17",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "1",
            "ind": 1
        },
        {
            "ty": 0,
            "nm": "Dot Line",
            "sr": 1,
            "st": 94,
            "op": 18095,
            "ip": 94,
            "ln": "18",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "9",
            "ind": 2
        },
        {
            "ty": 0,
            "nm": "Text field",
            "sr": 1,
            "st": -47,
            "op": 17954,
            "ip": 0,
            "ln": "19",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "10",
            "ind": 3
        },
        {
            "ty": 0,
            "nm": "Register.svg",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "20",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        133.5,
                        158.5
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        110,
                        110
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        196
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 267,
            "h": 317,
            "refId": "11",
            "ind": 4
        },
        {
            "ty": 0,
            "nm": "isometric",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "21",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        358,
                        368
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "13",
            "ind": 5
        }
    ],
    "v": "5.7.0",
    "fr": 30,
    "op": 10705,
    "ip": 0,
    "fonts": {
        "list": [
            {
                "ascent": null,
                "fClass": "",
                "fFamily": "BDO Grotesk",
                "fStyle": "Regular",
                "fName": "BDOGrotesk-Regular",
                "fPath": "",
                "fWeight": "",
                "origin": 0
            }
        ]
    },
    "chars": [
        {
            "ch": "L",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 58.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                59.3,
                                                0
                                            ],
                                            [
                                                8.6,
                                                0
                                            ],
                                            [
                                                8.6,
                                                -72.9
                                            ],
                                            [
                                                19,
                                                -72.9
                                            ],
                                            [
                                                19,
                                                -7.5
                                            ],
                                            [
                                                17.3,
                                                -9.2
                                            ],
                                            [
                                                59.3,
                                                -9.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "o",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 61.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.033333333333334,
                                                2.433333333333333
                                            ],
                                            [
                                                2.1999999999999993,
                                                4.333333333333334
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                -2.233333333333334,
                                                4.36666666666667
                                            ],
                                            [
                                                -4.033333333333334,
                                                2.4333333333333322
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -2.199999999999998,
                                                -4.3666666666666645
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2.200000000000003,
                                                -4.366666666666667
                                            ],
                                            [
                                                4,
                                                -2.4
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.033333333333334,
                                                -2.433333333333333
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -4.333333333333333
                                            ],
                                            [
                                                0,
                                                -5.933333333333333
                                            ],
                                            [
                                                2.233333333333334,
                                                -4.3666666666666645
                                            ],
                                            [
                                                4.033333333333331,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ],
                                            [
                                                4,
                                                2.4333333333333322
                                            ],
                                            [
                                                2.200000000000003,
                                                4.36666666666667
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ],
                                            [
                                                -2.199999999999998,
                                                4.366666666666666
                                            ],
                                            [
                                                -4,
                                                2.4
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31,
                                                1
                                            ],
                                            [
                                                16.75,
                                                -2.65
                                            ],
                                            [
                                                7.4,
                                                -12.8
                                            ],
                                            [
                                                4.1,
                                                -28
                                            ],
                                            [
                                                7.45,
                                                -43.45
                                            ],
                                            [
                                                16.85,
                                                -53.65
                                            ],
                                            [
                                                31,
                                                -57.3
                                            ],
                                            [
                                                45.1,
                                                -53.65
                                            ],
                                            [
                                                54.4,
                                                -43.45
                                            ],
                                            [
                                                57.7,
                                                -28.1
                                            ],
                                            [
                                                54.4,
                                                -12.75
                                            ],
                                            [
                                                45.1,
                                                -2.6
                                            ],
                                            [
                                                31,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999964,
                                                3.5999999999999996
                                            ],
                                            [
                                                0,
                                                6.399999999999999
                                            ],
                                            [
                                                2.900000000000001,
                                                3.5333333333333363
                                            ],
                                            [
                                                5.1333333333333355,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.633333333333335
                                            ],
                                            [
                                                0,
                                                -6.333333333333333
                                            ],
                                            [
                                                -2.9,
                                                -3.5666666666666664
                                            ],
                                            [
                                                -5.199999999999998,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                5.200000000000003,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.6000000000000014
                                            ],
                                            [
                                                0,
                                                -6.466666666666666
                                            ],
                                            [
                                                -2.8999999999999964,
                                                -3.5333333333333314
                                            ],
                                            [
                                                -5.266666666666666,
                                                0
                                            ],
                                            [
                                                -2.9,
                                                3.6333333333333306
                                            ],
                                            [
                                                0,
                                                6.400000000000001
                                            ],
                                            [
                                                2.900000000000001,
                                                3.566666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.9,
                                                -7.8
                                            ],
                                            [
                                                43.05,
                                                -13.2
                                            ],
                                            [
                                                47.4,
                                                -28.2
                                            ],
                                            [
                                                43.05,
                                                -43.2
                                            ],
                                            [
                                                31,
                                                -48.5
                                            ],
                                            [
                                                18.75,
                                                -43.05
                                            ],
                                            [
                                                14.4,
                                                -28.1
                                            ],
                                            [
                                                18.75,
                                                -13.15
                                            ],
                                            [
                                                30.9,
                                                -7.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "g",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.9,
                                                2.866666666666667
                                            ],
                                            [
                                                0.5333333333333332,
                                                4.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.2333333333333343,
                                                -1.4666666666666668
                                            ],
                                            [
                                                -2,
                                                -0.6333333333333329
                                            ],
                                            [
                                                -2.3333333333333335,
                                                0
                                            ],
                                            [
                                                -2.800000000000002,
                                                2.1666666666666674
                                            ],
                                            [
                                                0,
                                                4.933333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3,
                                                -1.366666666666666
                                            ],
                                            [
                                                3.999999999999998,
                                                0
                                            ],
                                            [
                                                3.5,
                                                2.133333333333334
                                            ],
                                            [
                                                1.866666666666666,
                                                3.8333333333333335
                                            ],
                                            [
                                                0,
                                                5.133333333333333
                                            ],
                                            [
                                                -1.8333333333333333,
                                                3.933333333333337
                                            ],
                                            [
                                                -3.4,
                                                2.2333333333333343
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.2333333333333343,
                                                -1.8333333333333333
                                            ],
                                            [
                                                -1.466666666666664,
                                                -3.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666647,
                                                -3.3000000000000003
                                            ],
                                            [
                                                3.8333333333333335,
                                                -1.8333333333333333
                                            ],
                                            [
                                                5.8666666666666645,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.600000000000001,
                                                0
                                            ],
                                            [
                                                -3.9,
                                                -2.866666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.2666666666666657,
                                                2.466666666666667
                                            ],
                                            [
                                                1.2333333333333343,
                                                1.4666666666666668
                                            ],
                                            [
                                                2,
                                                0.6333333333333341
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.799999999999997,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333343,
                                                3.0666666666666678
                                            ],
                                            [
                                                -3,
                                                1.3666666666666671
                                            ],
                                            [
                                                -4.733333333333334,
                                                0
                                            ],
                                            [
                                                -3.5,
                                                -2.133333333333333
                                            ],
                                            [
                                                -1.8666666666666671,
                                                -3.8333333333333335
                                            ],
                                            [
                                                0,
                                                -5.0666666666666655
                                            ],
                                            [
                                                1.8333333333333333,
                                                -3.9333333333333322
                                            ],
                                            [
                                                3.400000000000001,
                                                -2.2333333333333294
                                            ],
                                            [
                                                4.133333333333333,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.8333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.333333333333333
                                            ],
                                            [
                                                -1.8666666666666696,
                                                3.2999999999999994
                                            ],
                                            [
                                                -3.8333333333333335,
                                                1.8333333333333346
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.1,
                                                17.6
                                            ],
                                            [
                                                13.35,
                                                13.3
                                            ],
                                            [
                                                6.7,
                                                2
                                            ],
                                            [
                                                16,
                                                -0.2
                                            ],
                                            [
                                                18.25,
                                                5.7
                                            ],
                                            [
                                                23.1,
                                                8.85
                                            ],
                                            [
                                                29.6,
                                                9.8
                                            ],
                                            [
                                                40.7,
                                                6.55
                                            ],
                                            [
                                                44.9,
                                                -4.1
                                            ],
                                            [
                                                44.9,
                                                -14.3
                                            ],
                                            [
                                                37.8,
                                                -7.65
                                            ],
                                            [
                                                27.3,
                                                -5.6
                                            ],
                                            [
                                                14.95,
                                                -8.8
                                            ],
                                            [
                                                6.9,
                                                -17.75
                                            ],
                                            [
                                                4.1,
                                                -31.2
                                            ],
                                            [
                                                6.85,
                                                -44.7
                                            ],
                                            [
                                                14.7,
                                                -53.95
                                            ],
                                            [
                                                26.8,
                                                -57.3
                                            ],
                                            [
                                                37.85,
                                                -54.55
                                            ],
                                            [
                                                44.9,
                                                -47
                                            ],
                                            [
                                                45.5,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -56.3
                                            ],
                                            [
                                                55,
                                                -4.3
                                            ],
                                            [
                                                52.2,
                                                7.15
                                            ],
                                            [
                                                43.65,
                                                14.85
                                            ],
                                            [
                                                29.1,
                                                17.6
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.299999999999997,
                                                1.4333333333333336
                                            ],
                                            [
                                                -1.3000000000000018,
                                                2.433333333333335
                                            ],
                                            [
                                                0,
                                                3.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.3333333333333335
                                            ],
                                            [
                                                2.3333333333333335,
                                                1.3666666666666647
                                            ],
                                            [
                                                3.133333333333333,
                                                0
                                            ],
                                            [
                                                2.5333333333333337,
                                                -3.2333333333333294
                                            ],
                                            [
                                                0,
                                                -5.333333333333333
                                            ],
                                            [
                                                -2.5333333333333328,
                                                -3.366666666666667
                                            ],
                                            [
                                                -4.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.0666666666666678,
                                                0
                                            ],
                                            [
                                                2.300000000000002,
                                                -1.4333333333333325
                                            ],
                                            [
                                                1.2999999999999972,
                                                -2.4333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -1.3666666666666647
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -2.5333333333333328,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                5.266666666666668
                                            ],
                                            [
                                                2.5333333333333337,
                                                3.366666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.5,
                                                -13.1
                                            ],
                                            [
                                                37.55,
                                                -15.25
                                            ],
                                            [
                                                42.95,
                                                -21.05
                                            ],
                                            [
                                                44.9,
                                                -29.3
                                            ],
                                            [
                                                44.9,
                                                -33.1
                                            ],
                                            [
                                                42.9,
                                                -41.2
                                            ],
                                            [
                                                37.4,
                                                -46.75
                                            ],
                                            [
                                                29.2,
                                                -48.8
                                            ],
                                            [
                                                18.4,
                                                -43.95
                                            ],
                                            [
                                                14.6,
                                                -31.1
                                            ],
                                            [
                                                18.4,
                                                -18.15
                                            ],
                                            [
                                                29.5,
                                                -13.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "i",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 24.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -78.6
                                            ],
                                            [
                                                17,
                                                -78.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "n",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3,
                                                1.5333333333333314
                                            ],
                                            [
                                                -3.866666666666667,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -3.2333333333333294
                                            ],
                                            [
                                                0,
                                                -6.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                2.0666666666666678
                                            ],
                                            [
                                                4.066666666666667,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.200000000000003
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3999999999999986,
                                                -3.2666666666666706
                                            ],
                                            [
                                                3,
                                                -1.5333333333333314
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333314
                                            ],
                                            [
                                                -2,
                                                -2.0666666666666678
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.5,
                                                -56.3
                                            ],
                                            [
                                                17.1,
                                                -47.8
                                            ],
                                            [
                                                25.2,
                                                -55
                                            ],
                                            [
                                                35.5,
                                                -57.3
                                            ],
                                            [
                                                49.45,
                                                -52.45
                                            ],
                                            [
                                                54.9,
                                                -37.6
                                            ],
                                            [
                                                54.9,
                                                0
                                            ],
                                            [
                                                44.7,
                                                0
                                            ],
                                            [
                                                44.7,
                                                -36.6
                                            ],
                                            [
                                                41.7,
                                                -45
                                            ],
                                            [
                                                32.6,
                                                -48.1
                                            ],
                                            [
                                                25,
                                                -46.35
                                            ],
                                            [
                                                19.45,
                                                -41.3
                                            ],
                                            [
                                                17.4,
                                                -33.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": " ",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 24,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": []
                    }
                ]
            }
        },
        {
            "ch": "r",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 35.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.2999999999999994,
                                                1.533333333333336
                                            ],
                                            [
                                                -3,
                                                0
                                            ],
                                            [
                                                -1,
                                                -0.40000000000000097
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7000000000000028,
                                                0.09999999999999905
                                            ],
                                            [
                                                0.6666666666666666,
                                                0
                                            ],
                                            [
                                                2.2999999999999994,
                                                -2.3333333333333335
                                            ],
                                            [
                                                0.3333333333333333,
                                                -3.933333333333337
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4666666666666686,
                                                -2.866666666666665
                                            ],
                                            [
                                                2.2999999999999994,
                                                -1.5333333333333314
                                            ],
                                            [
                                                2.0666666666666678,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333314,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.6999999999999981,
                                                -0.1000000000000038
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0
                                            ],
                                            [
                                                -2.300000000000002,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.3,
                                                -56.3
                                            ],
                                            [
                                                16.9,
                                                -48
                                            ],
                                            [
                                                22.55,
                                                -54.6
                                            ],
                                            [
                                                30.5,
                                                -56.9
                                            ],
                                            [
                                                35.1,
                                                -56.3
                                            ],
                                            [
                                                35.1,
                                                -46.6
                                            ],
                                            [
                                                34.4,
                                                -46.6
                                            ],
                                            [
                                                32.55,
                                                -47.05
                                            ],
                                            [
                                                30.5,
                                                -47.2
                                            ],
                                            [
                                                21.35,
                                                -43.7
                                            ],
                                            [
                                                17.4,
                                                -34.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "e",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 58.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.033333333333331,
                                                2.3000000000000003
                                            ],
                                            [
                                                2.233333333333334,
                                                4.333333333333333
                                            ],
                                            [
                                                0,
                                                6.1333333333333355
                                            ],
                                            [
                                                -2.1,
                                                4.36666666666667
                                            ],
                                            [
                                                -3.9333333333333336,
                                                2.4333333333333322
                                            ],
                                            [
                                                -5.600000000000001,
                                                0
                                            ],
                                            [
                                                -3.900000000000001,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2,
                                                -4.699999999999998
                                            ],
                                            [
                                                0.46666666666666384,
                                                -7.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.5666666666666678,
                                                3.599999999999999
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                3.066666666666665,
                                                -3.2666666666666706
                                            ],
                                            [
                                                0,
                                                -7.399999999999999
                                            ],
                                            [
                                                -2.933333333333335,
                                                -3.4333333333333336
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.5333333333333363,
                                                1.8666666666666671
                                            ],
                                            [
                                                -0.5999999999999991,
                                                3.3333333333333344
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.1333333333333306,
                                                -2.5333333333333337
                                            ],
                                            [
                                                3.3333333333333335,
                                                -1.4333333333333333
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4.033333333333334,
                                                -2.3000000000000003
                                            ],
                                            [
                                                -2.233333333333334,
                                                -4.333333333333332
                                            ],
                                            [
                                                0,
                                                -5.8666666666666645
                                            ],
                                            [
                                                2.1,
                                                -4.3666666666666645
                                            ],
                                            [
                                                3.9333333333333322,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                3.8999999999999964,
                                                2.3333333333333335
                                            ],
                                            [
                                                2,
                                                4.699999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.8666666666666695,
                                                -5.8
                                            ],
                                            [
                                                -2.5666666666666678,
                                                -3.6000000000000036
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.0666666666666678,
                                                3.2666666666666657
                                            ],
                                            [
                                                0,
                                                7
                                            ],
                                            [
                                                2.9333333333333322,
                                                3.4333333333333336
                                            ],
                                            [
                                                4.13333333333333,
                                                0
                                            ],
                                            [
                                                2.5333333333333314,
                                                -1.866666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                3.4
                                            ],
                                            [
                                                -2.133333333333335,
                                                2.533333333333333
                                            ],
                                            [
                                                -3.3333333333333335,
                                                1.4333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31,
                                                1
                                            ],
                                            [
                                                16.85,
                                                -2.45
                                            ],
                                            [
                                                7.45,
                                                -12.4
                                            ],
                                            [
                                                4.1,
                                                -28.1
                                            ],
                                            [
                                                7.25,
                                                -43.45
                                            ],
                                            [
                                                16.3,
                                                -53.65
                                            ],
                                            [
                                                30.6,
                                                -57.3
                                            ],
                                            [
                                                44.45,
                                                -53.8
                                            ],
                                            [
                                                53.3,
                                                -43.25
                                            ],
                                            [
                                                55.6,
                                                -25.6
                                            ],
                                            [
                                                13,
                                                -25.6
                                            ],
                                            [
                                                13,
                                                -33.3
                                            ],
                                            [
                                                49.5,
                                                -33.3
                                            ],
                                            [
                                                44.8,
                                                -29.7
                                            ],
                                            [
                                                42.25,
                                                -43.8
                                            ],
                                            [
                                                30.4,
                                                -49.2
                                            ],
                                            [
                                                18.8,
                                                -44.3
                                            ],
                                            [
                                                14.2,
                                                -28.3
                                            ],
                                            [
                                                18.6,
                                                -12.65
                                            ],
                                            [
                                                31.1,
                                                -7.5
                                            ],
                                            [
                                                41.1,
                                                -10.3
                                            ],
                                            [
                                                45.8,
                                                -18.1
                                            ],
                                            [
                                                54.9,
                                                -16
                                            ],
                                            [
                                                50.7,
                                                -7.1
                                            ],
                                            [
                                                42.5,
                                                -1.15
                                            ],
                                            [
                                                31,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "d",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 64.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2,
                                                4.433333333333337
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.400000000000001
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.133333333333335,
                                                -1.7333333333333296
                                            ],
                                            [
                                                -1.8000000000000018,
                                                -3.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.300000000000002,
                                                -1.9000000000000001
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.633333333333334,
                                                2.3666666666666667
                                            ],
                                            [
                                                1.9333333333333336,
                                                4.300000000000001
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                -5.999999999999997
                                            ],
                                            [
                                                2,
                                                -4.433333333333333
                                            ],
                                            [
                                                3.666666666666668,
                                                -2.3999999999999964
                                            ],
                                            [
                                                4.266666666666666,
                                                0
                                            ],
                                            [
                                                3.1333333333333306,
                                                1.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.599999999999999,
                                                3.266666666666666
                                            ],
                                            [
                                                -3.299999999999997,
                                                1.9000000000000001
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.633333333333333,
                                                -2.3666666666666667
                                            ],
                                            [
                                                -1.9333333333333336,
                                                -4.3
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                4.1,
                                                -27.8
                                            ],
                                            [
                                                7.1,
                                                -43.45
                                            ],
                                            [
                                                15.6,
                                                -53.7
                                            ],
                                            [
                                                28.5,
                                                -57.3
                                            ],
                                            [
                                                39.6,
                                                -54.7
                                            ],
                                            [
                                                47,
                                                -47.2
                                            ],
                                            [
                                                47,
                                                -79
                                            ],
                                            [
                                                57.2,
                                                -79
                                            ],
                                            [
                                                57.2,
                                                0
                                            ],
                                            [
                                                47.7,
                                                0
                                            ],
                                            [
                                                47,
                                                -9.6
                                            ],
                                            [
                                                39.65,
                                                -1.85
                                            ],
                                            [
                                                28.2,
                                                1
                                            ],
                                            [
                                                15.35,
                                                -2.55
                                            ],
                                            [
                                                7,
                                                -12.55
                                            ],
                                            [
                                                4.1,
                                                -27.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.733333333333333,
                                                -3.4666666666666663
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.433333333333333
                                            ],
                                            [
                                                -1.3666666666666696,
                                                2.5666666666666664
                                            ],
                                            [
                                                0,
                                                3.3999999999999986
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2.633333333333335
                                            ],
                                            [
                                                2.4666666666666686,
                                                1.4333333333333325
                                            ],
                                            [
                                                3.400000000000001,
                                                0
                                            ],
                                            [
                                                2.7666666666666657,
                                                -3.599999999999999
                                            ],
                                            [
                                                0,
                                                -6.600000000000001
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                6.400000000000001
                                            ],
                                            [
                                                2.7333333333333343,
                                                3.466666666666667
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -1.4333333333333336
                                            ],
                                            [
                                                1.3666666666666647,
                                                -2.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                -2.4666666666666637,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -5.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.766666666666667,
                                                3.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14.6,
                                                -27.8
                                            ],
                                            [
                                                18.7,
                                                -13
                                            ],
                                            [
                                                30.4,
                                                -7.8
                                            ],
                                            [
                                                39.15,
                                                -9.95
                                            ],
                                            [
                                                44.95,
                                                -15.95
                                            ],
                                            [
                                                47,
                                                -24.9
                                            ],
                                            [
                                                47,
                                                -30.9
                                            ],
                                            [
                                                45,
                                                -40.25
                                            ],
                                            [
                                                39.3,
                                                -46.35
                                            ],
                                            [
                                                30.5,
                                                -48.5
                                            ],
                                            [
                                                18.75,
                                                -43.1
                                            ],
                                            [
                                                14.6,
                                                -27.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "c",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 58.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4,
                                                2.433333333333333
                                            ],
                                            [
                                                2.1999999999999993,
                                                4.366666666666666
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                -2.233333333333334,
                                                4.3666666666666645
                                            ],
                                            [
                                                -4.033333333333334,
                                                2.400000000000001
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4.166666666666667,
                                                -3.566666666666663
                                            ],
                                            [
                                                -0.7333333333333295,
                                                -5.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.5333333333333363,
                                                1.9333333333333325
                                            ],
                                            [
                                                3.933333333333335,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -3.5666666666666678
                                            ],
                                            [
                                                0,
                                                -6.333333333333336
                                            ],
                                            [
                                                -2.866666666666666,
                                                -3.6
                                            ],
                                            [
                                                -5,
                                                0
                                            ],
                                            [
                                                -2.5333333333333314,
                                                2
                                            ],
                                            [
                                                -0.3999999999999962,
                                                3.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -2.866666666666666
                                            ],
                                            [
                                                3.400000000000001,
                                                -1.5
                                            ],
                                            [
                                                4.333333333333331,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.4333333333333336
                                            ],
                                            [
                                                -2.2000000000000006,
                                                -4.366666666666667
                                            ],
                                            [
                                                0,
                                                -5.866666666666667
                                            ],
                                            [
                                                2.233333333333334,
                                                -4.36666666666667
                                            ],
                                            [
                                                4.033333333333331,
                                                -2.3999999999999964
                                            ],
                                            [
                                                6.800000000000002,
                                                0
                                            ],
                                            [
                                                4.166666666666667,
                                                3.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.3999999999999962,
                                                -3.9333333333333322
                                            ],
                                            [
                                                -2.5333333333333314,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -4.933333333333333,
                                                0
                                            ],
                                            [
                                                -2.9,
                                                3.566666666666663
                                            ],
                                            [
                                                0,
                                                6.266666666666666
                                            ],
                                            [
                                                2.866666666666667,
                                                3.6
                                            ],
                                            [
                                                3.933333333333335,
                                                0
                                            ],
                                            [
                                                2.5333333333333363,
                                                -2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333314,
                                                4.066666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                2.866666666666667
                                            ],
                                            [
                                                -3.400000000000001,
                                                1.5
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.8,
                                                0.9
                                            ],
                                            [
                                                16.7,
                                                -2.75
                                            ],
                                            [
                                                7.4,
                                                -12.95
                                            ],
                                            [
                                                4.1,
                                                -28.2
                                            ],
                                            [
                                                7.45,
                                                -43.55
                                            ],
                                            [
                                                16.85,
                                                -53.7
                                            ],
                                            [
                                                31,
                                                -57.3
                                            ],
                                            [
                                                47.45,
                                                -51.95
                                            ],
                                            [
                                                54.8,
                                                -37.9
                                            ],
                                            [
                                                44.8,
                                                -36.7
                                            ],
                                            [
                                                40.4,
                                                -45.5
                                            ],
                                            [
                                                30.7,
                                                -48.4
                                            ],
                                            [
                                                18.95,
                                                -43.05
                                            ],
                                            [
                                                14.6,
                                                -28.2
                                            ],
                                            [
                                                18.9,
                                                -13.4
                                            ],
                                            [
                                                30.7,
                                                -8
                                            ],
                                            [
                                                40.4,
                                                -11
                                            ],
                                            [
                                                44.8,
                                                -19.5
                                            ],
                                            [
                                                54.8,
                                                -18.3
                                            ],
                                            [
                                                50.75,
                                                -7.9
                                            ],
                                            [
                                                42.4,
                                                -1.35
                                            ],
                                            [
                                                30.8,
                                                0.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "t",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 31.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9666666666666661,
                                                1.6333333333333335
                                            ],
                                            [
                                                0,
                                                3.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333329,
                                                -0.6666666666666666
                                            ],
                                            [
                                                -1.8666666666666671,
                                                0
                                            ],
                                            [
                                                -0.7000000000000005,
                                                0.06666666666666643
                                            ],
                                            [
                                                -0.5333333333333314,
                                                0.13333333333333405
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2666666666666657,
                                                -0.13333333333333333
                                            ],
                                            [
                                                1.0666666666666653,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.7333333333333343,
                                                0
                                            ],
                                            [
                                                -1.9666666666666661,
                                                -1.6333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2.0666666666666664
                                            ],
                                            [
                                                0.6333333333333329,
                                                0.6666666666666666
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                0.7000000000000005,
                                                -0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.4666666666666661,
                                                0.26666666666666666
                                            ],
                                            [
                                                -1.2666666666666682,
                                                0.1333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.3,
                                                0.7
                                            ],
                                            [
                                                12.75,
                                                -1.75
                                            ],
                                            [
                                                9.8,
                                                -8.8
                                            ],
                                            [
                                                9.8,
                                                -72
                                            ],
                                            [
                                                19.8,
                                                -73
                                            ],
                                            [
                                                19.8,
                                                -13
                                            ],
                                            [
                                                20.75,
                                                -8.9
                                            ],
                                            [
                                                24.5,
                                                -7.9
                                            ],
                                            [
                                                27.05,
                                                -8
                                            ],
                                            [
                                                28.9,
                                                -8.3
                                            ],
                                            [
                                                28.9,
                                                -0.1
                                            ],
                                            [
                                                24.8,
                                                0.5
                                            ],
                                            [
                                                21.3,
                                                0.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14.8,
                                                -48.3
                                            ],
                                            [
                                                2.3,
                                                -48.3
                                            ],
                                            [
                                                2.3,
                                                -56.3
                                            ],
                                            [
                                                14.8,
                                                -56.3
                                            ],
                                            [
                                                14.8,
                                                -48.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                28.9,
                                                -56.3
                                            ],
                                            [
                                                28.9,
                                                -48.3
                                            ],
                                            [
                                                14.8,
                                                -48.3
                                            ],
                                            [
                                                14.8,
                                                -56.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "s",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 54.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.266666666666668,
                                                3.266666666666667
                                            ],
                                            [
                                                0.19999999999999987,
                                                5.733333333333332
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.5333333333333337,
                                                -2.2000000000000006
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.3
                                            ],
                                            [
                                                0,
                                                3.0666666666666664
                                            ],
                                            [
                                                0.8666666666666695,
                                                1.0666666666666675
                                            ],
                                            [
                                                1.5666666666666675,
                                                0.6333333333333329
                                            ],
                                            [
                                                2.066666666666665,
                                                0.3999999999999986
                                            ],
                                            [
                                                2.3999999999999986,
                                                0.5333333333333338
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.400000000000001
                                            ],
                                            [
                                                1.2,
                                                2.099999999999999
                                            ],
                                            [
                                                0,
                                                2.8666666666666694
                                            ],
                                            [
                                                -1.7333333333333332,
                                                2.400000000000001
                                            ],
                                            [
                                                -3.2000000000000006,
                                                1.3333333333333333
                                            ],
                                            [
                                                -4.333333333333333,
                                                0
                                            ],
                                            [
                                                -3.2666666666666657,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -1.900000000000001,
                                                -2.5333333333333314
                                            ],
                                            [
                                                -0.1999999999999981,
                                                -3.866666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                2
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                1.8333333333333333,
                                                -1.4333333333333371
                                            ],
                                            [
                                                0,
                                                -2.2666666666666657
                                            ],
                                            [
                                                -1.099999999999999,
                                                -1.1666666666666667
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -3.6666666666666665,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -2.2666666666666706,
                                                -0.7666666666666657
                                            ],
                                            [
                                                -1.5666666666666675,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -1.8999999999999986
                                            ],
                                            [
                                                0,
                                                -2.7999999999999994
                                            ],
                                            [
                                                3.7666666666666657,
                                                -3.033333333333333
                                            ],
                                            [
                                                7.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.0666666666666655,
                                                0
                                            ],
                                            [
                                                -4.266666666666667,
                                                -3.266666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.4666666666666663
                                            ],
                                            [
                                                2.5333333333333337,
                                                2.1999999999999997
                                            ],
                                            [
                                                3.6666666666666665,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -1.2999999999999996
                                            ],
                                            [
                                                0,
                                                -1.8666666666666671
                                            ],
                                            [
                                                -0.8666666666666648,
                                                -1.0666666666666653
                                            ],
                                            [
                                                -1.5666666666666675,
                                                -0.6333333333333352
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -0.40000000000000097
                                            ],
                                            [
                                                -3.800000000000002,
                                                -0.8666666666666648
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -1.400000000000001
                                            ],
                                            [
                                                -1.2,
                                                -2.099999999999999
                                            ],
                                            [
                                                0,
                                                -3.2666666666666657
                                            ],
                                            [
                                                1.7333333333333332,
                                                -2.3999999999999964
                                            ],
                                            [
                                                3.1999999999999993,
                                                -1.3333333333333333
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.2666666666666657,
                                                1.2666666666666657
                                            ],
                                            [
                                                1.900000000000001,
                                                2.5333333333333363
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.2666666666666706
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -2
                                            ],
                                            [
                                                -3.3999999999999986,
                                                0
                                            ],
                                            [
                                                -1.8333333333333333,
                                                1.4333333333333325
                                            ],
                                            [
                                                0,
                                                1.9333333333333325
                                            ],
                                            [
                                                1.1000000000000014,
                                                1.1666666666666667
                                            ],
                                            [
                                                2.3333333333333335,
                                                0.7333333333333343
                                            ],
                                            [
                                                2.799999999999997,
                                                0.5333333333333314
                                            ],
                                            [
                                                2.2666666666666657,
                                                0.766666666666668
                                            ],
                                            [
                                                1.5666666666666629,
                                                1.2666666666666682
                                            ],
                                            [
                                                0.8333333333333334,
                                                1.900000000000001
                                            ],
                                            [
                                                0,
                                                4.933333333333334
                                            ],
                                            [
                                                -3.7666666666666657,
                                                3.033333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.2,
                                                1
                                            ],
                                            [
                                                10.2,
                                                -3.9
                                            ],
                                            [
                                                3.5,
                                                -17.4
                                            ],
                                            [
                                                13.5,
                                                -18.5
                                            ],
                                            [
                                                17.3,
                                                -10
                                            ],
                                            [
                                                27.5,
                                                -6.7
                                            ],
                                            [
                                                36.35,
                                                -8.65
                                            ],
                                            [
                                                39.7,
                                                -15.2
                                            ],
                                            [
                                                38.4,
                                                -19.6
                                            ],
                                            [
                                                34.75,
                                                -22.15
                                            ],
                                            [
                                                29.3,
                                                -23.7
                                            ],
                                            [
                                                22.6,
                                                -25.1
                                            ],
                                            [
                                                13.2,
                                                -28.5
                                            ],
                                            [
                                                7.7,
                                                -33.75
                                            ],
                                            [
                                                5.9,
                                                -41.2
                                            ],
                                            [
                                                8.5,
                                                -49.7
                                            ],
                                            [
                                                15.9,
                                                -55.3
                                            ],
                                            [
                                                27.2,
                                                -57.3
                                            ],
                                            [
                                                38.6,
                                                -55.4
                                            ],
                                            [
                                                46.35,
                                                -49.7
                                            ],
                                            [
                                                49.5,
                                                -40.1
                                            ],
                                            [
                                                39.6,
                                                -38.8
                                            ],
                                            [
                                                36.5,
                                                -46.7
                                            ],
                                            [
                                                26.9,
                                                -49.7
                                            ],
                                            [
                                                19.05,
                                                -47.55
                                            ],
                                            [
                                                16.3,
                                                -42
                                            ],
                                            [
                                                17.95,
                                                -37.35
                                            ],
                                            [
                                                23.1,
                                                -34.5
                                            ],
                                            [
                                                32.1,
                                                -32.3
                                            ],
                                            [
                                                39.7,
                                                -30.35
                                            ],
                                            [
                                                45.45,
                                                -27.3
                                            ],
                                            [
                                                49.05,
                                                -22.55
                                            ],
                                            [
                                                50.3,
                                                -15.5
                                            ],
                                            [
                                                44.65,
                                                -3.55
                                            ],
                                            [
                                                27.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "a",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 58,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.233333333333333,
                                                2.9
                                            ],
                                            [
                                                0,
                                                4.666666666666666
                                            ],
                                            [
                                                -1.7,
                                                2.3333333333333335
                                            ],
                                            [
                                                -2.733333333333333,
                                                1.2999999999999996
                                            ],
                                            [
                                                -3.2000000000000006,
                                                0.6000000000000014
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9333333333333323,
                                                1.099999999999999
                                            ],
                                            [
                                                0,
                                                1.8000000000000018
                                            ],
                                            [
                                                1.6666666666666667,
                                                1.5666666666666675
                                            ],
                                            [
                                                4.399999999999999,
                                                0
                                            ],
                                            [
                                                2.5333333333333314,
                                                -1.6666666666666667
                                            ],
                                            [
                                                -0.06666666666666643,
                                                -3.4666666666666637
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.3,
                                                2.9666666666666686
                                            ],
                                            [
                                                -7,
                                                0
                                            ],
                                            [
                                                -3.2333333333333343,
                                                -1.2333333333333296
                                            ],
                                            [
                                                -1.6999999999999982,
                                                -2.5333333333333363
                                            ],
                                            [
                                                0,
                                                -3.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -0.6000000000000002
                                            ],
                                            [
                                                -0.8666666666666695,
                                                0
                                            ],
                                            [
                                                -0.2666666666666657,
                                                0.033333333333333805
                                            ],
                                            [
                                                -0.06666666666666288,
                                                0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.099999999999999,
                                                -0.1333333333333333
                                            ],
                                            [
                                                0.5333333333333362,
                                                0
                                            ],
                                            [
                                                1.7666666666666657,
                                                1.4000000000000001
                                            ],
                                            [
                                                0,
                                                2.866666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.6666666666666665,
                                                -1.9333333333333333
                                            ],
                                            [
                                                4.600000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.866666666666666,
                                                0
                                            ],
                                            [
                                                -3.233333333333334,
                                                -2.9
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                1.7000000000000004,
                                                -2.3333333333333335
                                            ],
                                            [
                                                2.733333333333333,
                                                -1.2999999999999996
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3,
                                                -0.5333333333333362
                                            ],
                                            [
                                                0.9333333333333323,
                                                -1.099999999999999
                                            ],
                                            [
                                                0,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -1.6666666666666667,
                                                -1.5666666666666629
                                            ],
                                            [
                                                -4.266666666666668,
                                                0
                                            ],
                                            [
                                                -2.5333333333333337,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.13333333333333344,
                                                -5.533333333333331
                                            ],
                                            [
                                                4.300000000000001,
                                                -2.9666666666666637
                                            ],
                                            [
                                                4.666666666666664,
                                                0
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.2333333333333343
                                            ],
                                            [
                                                1.7000000000000028,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2
                                            ],
                                            [
                                                0.7333333333333295,
                                                0.6000000000000002
                                            ],
                                            [
                                                0.5333333333333314,
                                                0
                                            ],
                                            [
                                                0.26666666666667044,
                                                -0.033333333333333215
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0.26666666666666666
                                            ],
                                            [
                                                -1.099999999999999,
                                                0.1333333333333334
                                            ],
                                            [
                                                -2.866666666666665,
                                                0
                                            ],
                                            [
                                                -1.7666666666666657,
                                                -1.3999999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.400000000000001,
                                                3.1333333333333333
                                            ],
                                            [
                                                -3.6666666666666665,
                                                1.9333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                22.7,
                                                1
                                            ],
                                            [
                                                9.05,
                                                -3.35
                                            ],
                                            [
                                                4.2,
                                                -14.7
                                            ],
                                            [
                                                6.75,
                                                -23.8
                                            ],
                                            [
                                                13.4,
                                                -29.25
                                            ],
                                            [
                                                22.3,
                                                -32.1
                                            ],
                                            [
                                                34.1,
                                                -34.3
                                            ],
                                            [
                                                40,
                                                -36.75
                                            ],
                                            [
                                                41.4,
                                                -41.1
                                            ],
                                            [
                                                38.9,
                                                -46.95
                                            ],
                                            [
                                                29.8,
                                                -49.3
                                            ],
                                            [
                                                19.6,
                                                -46.8
                                            ],
                                            [
                                                15.9,
                                                -39.1
                                            ],
                                            [
                                                6.2,
                                                -40.1
                                            ],
                                            [
                                                12.85,
                                                -52.85
                                            ],
                                            [
                                                29.8,
                                                -57.3
                                            ],
                                            [
                                                41.65,
                                                -55.45
                                            ],
                                            [
                                                49.05,
                                                -49.8
                                            ],
                                            [
                                                51.6,
                                                -40.3
                                            ],
                                            [
                                                51.6,
                                                -11.9
                                            ],
                                            [
                                                52.7,
                                                -8
                                            ],
                                            [
                                                55.1,
                                                -7.1
                                            ],
                                            [
                                                56.3,
                                                -7.15
                                            ],
                                            [
                                                56.8,
                                                -7.3
                                            ],
                                            [
                                                57.4,
                                                -7.3
                                            ],
                                            [
                                                57.4,
                                                0
                                            ],
                                            [
                                                54.75,
                                                0.6
                                            ],
                                            [
                                                52.3,
                                                0.8
                                            ],
                                            [
                                                45.35,
                                                -1.3
                                            ],
                                            [
                                                42.7,
                                                -7.7
                                            ],
                                            [
                                                42.7,
                                                -9.5
                                            ],
                                            [
                                                35.1,
                                                -1.9
                                            ],
                                            [
                                                22.7,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999986,
                                                1.7
                                            ],
                                            [
                                                -1,
                                                3.066666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4333333333333325,
                                                -0.3999999999999986
                                            ],
                                            [
                                                2.599999999999999,
                                                -0.5333333333333338
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3666666666666671,
                                                -1.6666666666666667
                                            ],
                                            [
                                                0,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2,
                                                -1.3333333333333333
                                            ],
                                            [
                                                -3.0666666666666678,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4,
                                                0
                                            ],
                                            [
                                                2.900000000000001,
                                                -1.7000000000000004
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0.6666666666666666
                                            ],
                                            [
                                                -1.4333333333333371,
                                                0.40000000000000097
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.2,
                                                0.8666666666666671
                                            ],
                                            [
                                                -1.3666666666666671,
                                                1.6666666666666667
                                            ],
                                            [
                                                0,
                                                2.866666666666667
                                            ],
                                            [
                                                2,
                                                1.3333333333333328
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                25.3,
                                                -7.2
                                            ],
                                            [
                                                35.65,
                                                -9.75
                                            ],
                                            [
                                                41.5,
                                                -16.9
                                            ],
                                            [
                                                41.5,
                                                -29.8
                                            ],
                                            [
                                                42.6,
                                                -29.4
                                            ],
                                            [
                                                39.45,
                                                -27.8
                                            ],
                                            [
                                                33.4,
                                                -26.4
                                            ],
                                            [
                                                25.1,
                                                -24.7
                                            ],
                                            [
                                                16.75,
                                                -20.9
                                            ],
                                            [
                                                14.7,
                                                -15.5
                                            ],
                                            [
                                                17.7,
                                                -9.2
                                            ],
                                            [
                                                25.3,
                                                -7.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "h",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.9666666666666686,
                                                1.466666666666664
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -3.2333333333333343
                                            ],
                                            [
                                                0,
                                                -6.666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2,
                                                2.0666666666666678
                                            ],
                                            [
                                                4.066666666666667,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.199999999999998
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -3.133333333333335
                                            ],
                                            [
                                                2.9666666666666663,
                                                -1.4666666666666686
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                3.2333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333363
                                            ],
                                            [
                                                -2,
                                                -2.066666666666663
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -79
                                            ],
                                            [
                                                17.4,
                                                -48.4
                                            ],
                                            [
                                                25.35,
                                                -55.3
                                            ],
                                            [
                                                35.5,
                                                -57.5
                                            ],
                                            [
                                                49.45,
                                                -52.65
                                            ],
                                            [
                                                54.9,
                                                -37.8
                                            ],
                                            [
                                                54.9,
                                                0
                                            ],
                                            [
                                                44.7,
                                                0
                                            ],
                                            [
                                                44.7,
                                                -36.8
                                            ],
                                            [
                                                41.7,
                                                -45.2
                                            ],
                                            [
                                                32.6,
                                                -48.3
                                            ],
                                            [
                                                25,
                                                -46.55
                                            ],
                                            [
                                                19.45,
                                                -41.5
                                            ],
                                            [
                                                17.4,
                                                -33.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "b",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 64.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.1666666666666665,
                                                1.6666666666666667
                                            ],
                                            [
                                                -4.0666666666666655,
                                                0
                                            ],
                                            [
                                                -3.6666666666666665,
                                                -2.3999999999999964
                                            ],
                                            [
                                                -2,
                                                -4.433333333333333
                                            ],
                                            [
                                                0,
                                                -5.999999999999997
                                            ],
                                            [
                                                1.9666666666666686,
                                                -4.3
                                            ],
                                            [
                                                3.599999999999999,
                                                -2.3666666666666667
                                            ],
                                            [
                                                5,
                                                0
                                            ],
                                            [
                                                3.3333333333333335,
                                                1.9000000000000001
                                            ],
                                            [
                                                1.6000000000000014,
                                                3.266666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9333333333333325,
                                                -3.3999999999999964
                                            ],
                                            [
                                                3.1666666666666665,
                                                -1.6666666666666667
                                            ],
                                            [
                                                4.933333333333337,
                                                0
                                            ],
                                            [
                                                3.6666666666666665,
                                                2.400000000000001
                                            ],
                                            [
                                                2,
                                                4.433333333333337
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ],
                                            [
                                                -1.9666666666666686,
                                                4.300000000000001
                                            ],
                                            [
                                                -3.599999999999999,
                                                2.3666666666666667
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ],
                                            [
                                                -3.3333333333333335,
                                                -1.9000000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                16.5,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.3,
                                                -79
                                            ],
                                            [
                                                17.3,
                                                -47.2
                                            ],
                                            [
                                                24.95,
                                                -54.8
                                            ],
                                            [
                                                35.8,
                                                -57.3
                                            ],
                                            [
                                                48.7,
                                                -53.7
                                            ],
                                            [
                                                57.2,
                                                -43.45
                                            ],
                                            [
                                                60.2,
                                                -27.8
                                            ],
                                            [
                                                57.25,
                                                -12.55
                                            ],
                                            [
                                                48.9,
                                                -2.55
                                            ],
                                            [
                                                36,
                                                1
                                            ],
                                            [
                                                24.6,
                                                -1.85
                                            ],
                                            [
                                                17.2,
                                                -9.6
                                            ],
                                            [
                                                16.5,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.3999999999999986,
                                                -2.4999999999999987
                                            ],
                                            [
                                                -2.4666666666666663,
                                                -1.3666666666666671
                                            ],
                                            [
                                                -3.2666666666666657,
                                                0
                                            ],
                                            [
                                                -2.7666666666666657,
                                                3.5000000000000004
                                            ],
                                            [
                                                0,
                                                6.333333333333333
                                            ],
                                            [
                                                2.7666666666666706,
                                                3.599999999999999
                                            ],
                                            [
                                                5.13333333333333,
                                                0
                                            ],
                                            [
                                                2.4666666666666663,
                                                -1.4333333333333325
                                            ],
                                            [
                                                1.3333333333333333,
                                                -2.633333333333335
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.266666666666668
                                            ],
                                            [
                                                1.400000000000001,
                                                2.5
                                            ],
                                            [
                                                2.4666666666666663,
                                                1.3666666666666665
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                2.7666666666666706,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                -6.600000000000001
                                            ],
                                            [
                                                -2.7666666666666657,
                                                -3.599999999999999
                                            ],
                                            [
                                                -3.3333333333333357,
                                                0
                                            ],
                                            [
                                                -2.4666666666666663,
                                                1.4333333333333325
                                            ],
                                            [
                                                -1.3333333333333333,
                                                2.633333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                -30.9
                                            ],
                                            [
                                                17.3,
                                                -24.3
                                            ],
                                            [
                                                19.4,
                                                -15.65
                                            ],
                                            [
                                                25.2,
                                                -9.85
                                            ],
                                            [
                                                33.8,
                                                -7.8
                                            ],
                                            [
                                                45.55,
                                                -13.05
                                            ],
                                            [
                                                49.7,
                                                -27.8
                                            ],
                                            [
                                                45.55,
                                                -43.1
                                            ],
                                            [
                                                33.7,
                                                -48.5
                                            ],
                                            [
                                                25,
                                                -46.35
                                            ],
                                            [
                                                19.3,
                                                -40.25
                                            ],
                                            [
                                                17.3,
                                                -30.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "A",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 73.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7333333333333343,
                                                2
                                            ],
                                            [
                                                0.7999999999999972,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7333333333333343,
                                                -2
                                            ],
                                            [
                                                0.7333333333333343,
                                                -1.9333333333333325
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.8000000000000019,
                                                2.3333333333333335
                                            ],
                                            [
                                                -0.7333333333333295,
                                                2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                12.3,
                                                0
                                            ],
                                            [
                                                1.4,
                                                0
                                            ],
                                            [
                                                30.8,
                                                -72.9
                                            ],
                                            [
                                                43.1,
                                                -72.9
                                            ],
                                            [
                                                72.5,
                                                0
                                            ],
                                            [
                                                61.4,
                                                0
                                            ],
                                            [
                                                40.7,
                                                -52.4
                                            ],
                                            [
                                                38.5,
                                                -58.3
                                            ],
                                            [
                                                36.2,
                                                -64.8
                                            ],
                                            [
                                                37.6,
                                                -64.8
                                            ],
                                            [
                                                35.3,
                                                -58.3
                                            ],
                                            [
                                                33.1,
                                                -52.4
                                            ],
                                            [
                                                12.3,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                55.4,
                                                -18.6
                                            ],
                                            [
                                                18.2,
                                                -18.6
                                            ],
                                            [
                                                21.8,
                                                -27.7
                                            ],
                                            [
                                                51.9,
                                                -27.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "u",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 61.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.400000000000001,
                                                3.5
                                            ],
                                            [
                                                0,
                                                5.8
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.133333333333335,
                                                -1.8999999999999997
                                            ],
                                            [
                                                -3.5333333333333337,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                1.2000000000000004
                                            ],
                                            [
                                                -1.2333333333333343,
                                                2.099999999999999
                                            ],
                                            [
                                                0,
                                                2.7999999999999994
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.1000000000000036,
                                                -1.7
                                            ],
                                            [
                                                3.599999999999999,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.466666666666666,
                                                0
                                            ],
                                            [
                                                -3.4,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.4666666666666672
                                            ],
                                            [
                                                2.133333333333333,
                                                1.900000000000001
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                2.2333333333333294,
                                                -1.2000000000000004
                                            ],
                                            [
                                                1.2333333333333343,
                                                -2.1000000000000014
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333296,
                                                2.9333333333333336
                                            ],
                                            [
                                                -3.099999999999999,
                                                1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27,
                                                1
                                            ],
                                            [
                                                12.2,
                                                -4.25
                                            ],
                                            [
                                                7.1,
                                                -18.2
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -56.3
                                            ],
                                            [
                                                17.4,
                                                -19.1
                                            ],
                                            [
                                                20.6,
                                                -11.05
                                            ],
                                            [
                                                29.1,
                                                -8.2
                                            ],
                                            [
                                                36.95,
                                                -10
                                            ],
                                            [
                                                42.15,
                                                -14.95
                                            ],
                                            [
                                                44,
                                                -22.3
                                            ],
                                            [
                                                44,
                                                -56.3
                                            ],
                                            [
                                                54.3,
                                                -56.3
                                            ],
                                            [
                                                54.3,
                                                0
                                            ],
                                            [
                                                44.8,
                                                0
                                            ],
                                            [
                                                44.3,
                                                -8.5
                                            ],
                                            [
                                                37.05,
                                                -1.55
                                            ],
                                            [
                                                27,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "f",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 32.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.6999999999999993,
                                                2.6666666666666665
                                            ],
                                            [
                                                -5.400000000000001,
                                                0
                                            ],
                                            [
                                                -1,
                                                -0.1000000000000038
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -0.1999999999999981
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.6000000000000014,
                                                0.1000000000000038
                                            ],
                                            [
                                                0.7333333333333343,
                                                0
                                            ],
                                            [
                                                1.2666666666666682,
                                                -1.0999999999999943
                                            ],
                                            [
                                                0,
                                                -2.9333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -4.533333333333331
                                            ],
                                            [
                                                2.7000000000000006,
                                                -2.6666666666666665
                                            ],
                                            [
                                                0.9333333333333323,
                                                0
                                            ],
                                            [
                                                1,
                                                0.09999999999999432
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.3999999999999986,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.5999999999999991,
                                                -0.09999999999999432
                                            ],
                                            [
                                                -2.3999999999999986,
                                                0
                                            ],
                                            [
                                                -1.2666666666666657,
                                                1.1000000000000039
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19,
                                                0
                                            ],
                                            [
                                                8.9,
                                                0
                                            ],
                                            [
                                                8.9,
                                                -64.7
                                            ],
                                            [
                                                12.95,
                                                -75.5
                                            ],
                                            [
                                                25.1,
                                                -79.5
                                            ],
                                            [
                                                28,
                                                -79.35
                                            ],
                                            [
                                                30.5,
                                                -78.9
                                            ],
                                            [
                                                30.5,
                                                -70.2
                                            ],
                                            [
                                                29.9,
                                                -70.2
                                            ],
                                            [
                                                28.4,
                                                -70.65
                                            ],
                                            [
                                                26.4,
                                                -70.8
                                            ],
                                            [
                                                20.9,
                                                -69.15
                                            ],
                                            [
                                                19,
                                                -63.1
                                            ],
                                            [
                                                19,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                14,
                                                -48.3
                                            ],
                                            [
                                                0.7,
                                                -48.3
                                            ],
                                            [
                                                0.7,
                                                -56.3
                                            ],
                                            [
                                                14,
                                                -56.3
                                            ],
                                            [
                                                14,
                                                -48.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.7,
                                                -48.3
                                            ],
                                            [
                                                14,
                                                -48.3
                                            ],
                                            [
                                                14,
                                                -56.3
                                            ],
                                            [
                                                30.7,
                                                -56.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "l",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 24.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.3,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -79
                                            ],
                                            [
                                                17.3,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "y",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 51.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2666666666666657,
                                                0.20000000000000048
                                            ],
                                            [
                                                0.8000000000000002,
                                                0.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333334,
                                                -0.13333333333333286
                                            ],
                                            [
                                                -0.7333333333333331,
                                                0
                                            ],
                                            [
                                                -1.4333333333333325,
                                                1.0000000000000007
                                            ],
                                            [
                                                -0.7999999999999995,
                                                2.0666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.733333333333332,
                                                -2.099999999999999
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -2.5666666666666678
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.5333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6000000000000014,
                                                2
                                            ],
                                            [
                                                -0.7000000000000005,
                                                1.9333333333333325
                                            ],
                                            [
                                                -0.8666666666666671,
                                                2.4666666666666663
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6666666666666667,
                                                -1.8333333333333333
                                            ],
                                            [
                                                2.066666666666665,
                                                -0.733333333333332
                                            ],
                                            [
                                                2.5333333333333337,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1,
                                                0
                                            ],
                                            [
                                                -1.2666666666666668,
                                                -0.20000000000000048
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.4666666666666668,
                                                0.20000000000000048
                                            ],
                                            [
                                                0.6333333333333329,
                                                0.13333333333333405
                                            ],
                                            [
                                                2.400000000000001,
                                                0
                                            ],
                                            [
                                                1.4333333333333347,
                                                -1
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.40000000000000097,
                                                1.0666666666666675
                                            ],
                                            [
                                                0.7333333333333343,
                                                2.099999999999999
                                            ],
                                            [
                                                0.8333333333333334,
                                                2.5666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7999999999999995,
                                                -2.6
                                            ],
                                            [
                                                0.5999999999999991,
                                                -2
                                            ],
                                            [
                                                0.7000000000000005,
                                                -1.9333333333333347
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.2000000000000004,
                                                3.266666666666667
                                            ],
                                            [
                                                -1.6666666666666667,
                                                1.8333333333333333
                                            ],
                                            [
                                                -2.0666666666666678,
                                                0.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                11.7,
                                                17.5
                                            ],
                                            [
                                                8.3,
                                                17.2
                                            ],
                                            [
                                                5.2,
                                                16.5
                                            ],
                                            [
                                                5.2,
                                                8.1
                                            ],
                                            [
                                                6,
                                                8.1
                                            ],
                                            [
                                                7.65,
                                                8.6
                                            ],
                                            [
                                                9.7,
                                                8.8
                                            ],
                                            [
                                                15.45,
                                                7.3
                                            ],
                                            [
                                                18.8,
                                                2.7
                                            ],
                                            [
                                                20.7,
                                                -2.1
                                            ],
                                            [
                                                -0.5,
                                                -56.3
                                            ],
                                            [
                                                10.6,
                                                -56.3
                                            ],
                                            [
                                                20,
                                                -30
                                            ],
                                            [
                                                21.7,
                                                -25.25
                                            ],
                                            [
                                                24.05,
                                                -18.25
                                            ],
                                            [
                                                26.3,
                                                -10.6
                                            ],
                                            [
                                                25.7,
                                                -10.6
                                            ],
                                            [
                                                27.8,
                                                -17.5
                                            ],
                                            [
                                                29.75,
                                                -23.4
                                            ],
                                            [
                                                32.1,
                                                -30
                                            ],
                                            [
                                                41.6,
                                                -56.3
                                            ],
                                            [
                                                51.8,
                                                -56.3
                                            ],
                                            [
                                                28.5,
                                                4.9
                                            ],
                                            [
                                                24.2,
                                                12.55
                                            ],
                                            [
                                                18.6,
                                                16.4
                                            ],
                                            [
                                                11.7,
                                                17.5
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "j",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 20.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.9666666666666668,
                                                0.13333333333333286
                                            ],
                                            [
                                                0.7333333333333337,
                                                0.1999999999999981
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333331,
                                                -0.06666666666666643
                                            ],
                                            [
                                                -0.6666666666666666,
                                                0
                                            ],
                                            [
                                                -1.1666666666666667,
                                                1.3
                                            ],
                                            [
                                                0,
                                                2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.6999999999999993,
                                                -2.4
                                            ],
                                            [
                                                4.933333333333334,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.2000000000000002,
                                                0
                                            ],
                                            [
                                                -0.9666666666666662,
                                                -0.13333333333333522
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.4666666666666668,
                                                0.13333333333333405
                                            ],
                                            [
                                                0.7333333333333337,
                                                0.06666666666666643
                                            ],
                                            [
                                                2.533333333333333,
                                                0
                                            ],
                                            [
                                                1.1666666666666667,
                                                -1.3
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.8
                                            ],
                                            [
                                                -2.7000000000000006,
                                                2.400000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                -1.9,
                                                17.3
                                            ],
                                            [
                                                -5.15,
                                                17.1
                                            ],
                                            [
                                                -7.7,
                                                16.6
                                            ],
                                            [
                                                -7.7,
                                                8.6
                                            ],
                                            [
                                                -5.9,
                                                8.9
                                            ],
                                            [
                                                -3.8,
                                                9
                                            ],
                                            [
                                                1.75,
                                                7.05
                                            ],
                                            [
                                                3.5,
                                                1.1
                                            ],
                                            [
                                                3.5,
                                                -56.3
                                            ],
                                            [
                                                13.6,
                                                -56.3
                                            ],
                                            [
                                                13.6,
                                                2.9
                                            ],
                                            [
                                                9.55,
                                                13.7
                                            ],
                                            [
                                                -1.9,
                                                17.3
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                13.7,
                                                -66.2
                                            ],
                                            [
                                                3.5,
                                                -66.2
                                            ],
                                            [
                                                3.5,
                                                -79
                                            ],
                                            [
                                                13.7,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "E",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 66.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                63.6,
                                                0
                                            ],
                                            [
                                                8.6,
                                                0
                                            ],
                                            [
                                                8.6,
                                                -72.9
                                            ],
                                            [
                                                60.6,
                                                -72.9
                                            ],
                                            [
                                                60.6,
                                                -63.8
                                            ],
                                            [
                                                19,
                                                -63.8
                                            ],
                                            [
                                                19,
                                                -9.2
                                            ],
                                            [
                                                63.6,
                                                -9.2
                                            ],
                                            [
                                                63.6,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                56.5,
                                                -32.9
                                            ],
                                            [
                                                17.4,
                                                -32.9
                                            ],
                                            [
                                                17.4,
                                                -41.7
                                            ],
                                            [
                                                56.5,
                                                -41.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "m",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 95.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3,
                                                1.6333333333333353
                                            ],
                                            [
                                                -3.4666666666666686,
                                                0
                                            ],
                                            [
                                                -3,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -1.400000000000001,
                                                -3.800000000000002
                                            ],
                                            [
                                                -3.299999999999997,
                                                1.9666666666666686
                                            ],
                                            [
                                                -3.933333333333337,
                                                0
                                            ],
                                            [
                                                -3.199999999999998,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                -5.799999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8000000000000018,
                                                2.0333333333333314
                                            ],
                                            [
                                                3.4666666666666686,
                                                0
                                            ],
                                            [
                                                2.199999999999998,
                                                -1.2666666666666657
                                            ],
                                            [
                                                1.2333333333333296,
                                                -2.366666666666665
                                            ],
                                            [
                                                0,
                                                -3.2666666666666706
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                2.3333333333333335
                                            ],
                                            [
                                                3.7333333333333343,
                                                0
                                            ],
                                            [
                                                2.133333333333333,
                                                -1.3333333333333333
                                            ],
                                            [
                                                1.2000000000000004,
                                                -2.300000000000002
                                            ],
                                            [
                                                0,
                                                -2.933333333333337
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666647,
                                                -3.400000000000001
                                            ],
                                            [
                                                3,
                                                -1.6333333333333304
                                            ],
                                            [
                                                3.866666666666665,
                                                0
                                            ],
                                            [
                                                3,
                                                1.9333333333333325
                                            ],
                                            [
                                                1.7333333333333343,
                                                -3.7333333333333343
                                            ],
                                            [
                                                3.300000000000002,
                                                -1.966666666666664
                                            ],
                                            [
                                                6,
                                                0
                                            ],
                                            [
                                                3.199999999999998,
                                                3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -1.8000000000000018,
                                                -2.0333333333333363
                                            ],
                                            [
                                                -2.799999999999997,
                                                0
                                            ],
                                            [
                                                -2.200000000000003,
                                                1.2666666666666704
                                            ],
                                            [
                                                -1.2333333333333343,
                                                2.366666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -1.7333333333333296,
                                                -2.3333333333333335
                                            ],
                                            [
                                                -2.800000000000002,
                                                0
                                            ],
                                            [
                                                -2.133333333333333,
                                                1.3333333333333333
                                            ],
                                            [
                                                -1.2000000000000004,
                                                2.299999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.4,
                                                0
                                            ],
                                            [
                                                7.1,
                                                0
                                            ],
                                            [
                                                7.1,
                                                -56.3
                                            ],
                                            [
                                                16.4,
                                                -56.3
                                            ],
                                            [
                                                17.1,
                                                -47.3
                                            ],
                                            [
                                                24.4,
                                                -54.85
                                            ],
                                            [
                                                34.1,
                                                -57.3
                                            ],
                                            [
                                                44.4,
                                                -54.4
                                            ],
                                            [
                                                51,
                                                -45.8
                                            ],
                                            [
                                                58.55,
                                                -54.35
                                            ],
                                            [
                                                69.4,
                                                -57.3
                                            ],
                                            [
                                                83.2,
                                                -52.05
                                            ],
                                            [
                                                88,
                                                -38.1
                                            ],
                                            [
                                                88,
                                                0
                                            ],
                                            [
                                                77.7,
                                                0
                                            ],
                                            [
                                                77.7,
                                                -36.4
                                            ],
                                            [
                                                75,
                                                -45.05
                                            ],
                                            [
                                                67.1,
                                                -48.1
                                            ],
                                            [
                                                59.6,
                                                -46.2
                                            ],
                                            [
                                                54.45,
                                                -40.75
                                            ],
                                            [
                                                52.6,
                                                -32.3
                                            ],
                                            [
                                                52.6,
                                                0
                                            ],
                                            [
                                                42.4,
                                                0
                                            ],
                                            [
                                                42.4,
                                                -35.5
                                            ],
                                            [
                                                39.8,
                                                -44.6
                                            ],
                                            [
                                                31.6,
                                                -48.1
                                            ],
                                            [
                                                24.2,
                                                -46.1
                                            ],
                                            [
                                                19.2,
                                                -40.65
                                            ],
                                            [
                                                17.4,
                                                -32.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ".",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 21.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                16.1,
                                                0
                                            ],
                                            [
                                                5.6,
                                                0
                                            ],
                                            [
                                                5.6,
                                                -11.4
                                            ],
                                            [
                                                16.1,
                                                -11.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "@",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 98.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                1.4666666666666668
                                            ],
                                            [
                                                0.46666666666666856,
                                                3.5333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.633333333333335,
                                                -1.7666666666666668
                                            ],
                                            [
                                                3.5333333333333363,
                                                0
                                            ],
                                            [
                                                2.633333333333333,
                                                3.233333333333333
                                            ],
                                            [
                                                0.06666666666666761,
                                                5
                                            ],
                                            [
                                                -1.0333333333333339,
                                                3.400000000000001
                                            ],
                                            [
                                                -1.9333333333333325,
                                                2.6333333333333306
                                            ],
                                            [
                                                -2.7666666666666657,
                                                1.5333333333333314
                                            ],
                                            [
                                                -3.4666666666666637,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -0.6666666666666666,
                                                -2.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9333333333333277,
                                                -1.8999999999999997
                                            ],
                                            [
                                                -2.933333333333337,
                                                0
                                            ],
                                            [
                                                -1.7333333333333296,
                                                0.7999999999999995
                                            ],
                                            [
                                                -1.4666666666666686,
                                                1.7999999999999996
                                            ],
                                            [
                                                -0.8999999999999962,
                                                2.866666666666665
                                            ],
                                            [
                                                0,
                                                4.133333333333333
                                            ],
                                            [
                                                1.7666666666666704,
                                                4.13333333333333
                                            ],
                                            [
                                                3.233333333333339,
                                                3.099999999999999
                                            ],
                                            [
                                                4.5,
                                                1.7000000000000028
                                            ],
                                            [
                                                5.533333333333336,
                                                0
                                            ],
                                            [
                                                4.833333333333333,
                                                -2.133333333333335
                                            ],
                                            [
                                                3.599999999999999,
                                                -3.8333333333333335
                                            ],
                                            [
                                                2.0333333333333337,
                                                -5.099999999999999
                                            ],
                                            [
                                                0,
                                                -5.933333333333333
                                            ],
                                            [
                                                -3.233333333333333,
                                                -5.866666666666667
                                            ],
                                            [
                                                -5.666666666666667,
                                                -3.1999999999999997
                                            ],
                                            [
                                                -7.266666666666666,
                                                0
                                            ],
                                            [
                                                -4.566666666666667,
                                                1.7000000000000004
                                            ],
                                            [
                                                -3,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.099999999999994,
                                                -1.900000000000001
                                            ],
                                            [
                                                6.666666666666667,
                                                0
                                            ],
                                            [
                                                5.3666666666666645,
                                                2.133333333333333
                                            ],
                                            [
                                                3.900000000000001,
                                                3.966666666666667
                                            ],
                                            [
                                                2.1666666666666665,
                                                5.5
                                            ],
                                            [
                                                0,
                                                6.666666666666667
                                            ],
                                            [
                                                -2.4000000000000004,
                                                5.766666666666666
                                            ],
                                            [
                                                -4.266666666666666,
                                                4.266666666666666
                                            ],
                                            [
                                                -5.699999999999998,
                                                2.366666666666665
                                            ],
                                            [
                                                -6.599999999999999,
                                                0
                                            ],
                                            [
                                                -5.266666666666666,
                                                -1.8666666666666742
                                            ],
                                            [
                                                -3.866666666666665,
                                                -3.4666666666666637
                                            ],
                                            [
                                                -2.1000000000000036,
                                                -4.799999999999997
                                            ],
                                            [
                                                0,
                                                -5.800000000000002
                                            ],
                                            [
                                                1.4333333333333276,
                                                -3.7000000000000006
                                            ],
                                            [
                                                2.300000000000002,
                                                -2.266666666666667
                                            ],
                                            [
                                                2.699999999999998,
                                                -1.0000000000000007
                                            ],
                                            [
                                                2.5333333333333314,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.2666666666666706,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                -1.4666666666666661
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.6666666666666667,
                                                3.133333333333333
                                            ],
                                            [
                                                -2.6333333333333306,
                                                1.7666666666666668
                                            ],
                                            [
                                                -4.8666666666666645,
                                                0
                                            ],
                                            [
                                                -2.633333333333333,
                                                -3.233333333333333
                                            ],
                                            [
                                                0,
                                                -3.7999999999999994
                                            ],
                                            [
                                                1.0333333333333339,
                                                -3.400000000000001
                                            ],
                                            [
                                                1.9333333333333325,
                                                -2.633333333333335
                                            ],
                                            [
                                                2.7666666666666706,
                                                -1.533333333333336
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                1.5666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5999999999999943,
                                                2.9333333333333322
                                            ],
                                            [
                                                0.9333333333333371,
                                                1.8999999999999997
                                            ],
                                            [
                                                1.6666666666666667,
                                                0
                                            ],
                                            [
                                                1.7333333333333296,
                                                -0.7999999999999995
                                            ],
                                            [
                                                1.4666666666666686,
                                                -1.8000000000000018
                                            ],
                                            [
                                                0.9000000000000057,
                                                -2.866666666666667
                                            ],
                                            [
                                                0,
                                                -4.86666666666667
                                            ],
                                            [
                                                -1.766666666666661,
                                                -4.1333333333333355
                                            ],
                                            [
                                                -3.2333333333333294,
                                                -3.099999999999999
                                            ],
                                            [
                                                -4.5,
                                                -1.6999999999999982
                                            ],
                                            [
                                                -5.666666666666667,
                                                0
                                            ],
                                            [
                                                -4.833333333333333,
                                                2.1333333333333306
                                            ],
                                            [
                                                -3.599999999999999,
                                                3.8333333333333335
                                            ],
                                            [
                                                -2.0333333333333337,
                                                5.100000000000004
                                            ],
                                            [
                                                0,
                                                7.999999999999999
                                            ],
                                            [
                                                3.233333333333333,
                                                5.866666666666667
                                            ],
                                            [
                                                5.666666666666669,
                                                3.2000000000000006
                                            ],
                                            [
                                                5.666666666666667,
                                                0
                                            ],
                                            [
                                                4.566666666666663,
                                                -1.7
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.9333333333333322
                                            ],
                                            [
                                                -5.100000000000004,
                                                1.8999999999999986
                                            ],
                                            [
                                                -6.400000000000001,
                                                0
                                            ],
                                            [
                                                -5.366666666666667,
                                                -2.133333333333333
                                            ],
                                            [
                                                -3.9,
                                                -3.966666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -5.499999999999999
                                            ],
                                            [
                                                0,
                                                -6.86666666666667
                                            ],
                                            [
                                                2.4000000000000004,
                                                -5.766666666666666
                                            ],
                                            [
                                                4.266666666666668,
                                                -4.266666666666666
                                            ],
                                            [
                                                5.700000000000003,
                                                -2.3666666666666742
                                            ],
                                            [
                                                6.333333333333333,
                                                0
                                            ],
                                            [
                                                5.26666666666667,
                                                1.8666666666666647
                                            ],
                                            [
                                                3.866666666666665,
                                                3.4666666666666686
                                            ],
                                            [
                                                2.0999999999999943,
                                                4.800000000000002
                                            ],
                                            [
                                                0,
                                                5.399999999999999
                                            ],
                                            [
                                                -1.4333333333333371,
                                                3.6999999999999993
                                            ],
                                            [
                                                -2.300000000000002,
                                                2.2666666666666657
                                            ],
                                            [
                                                -2.699999999999998,
                                                1
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                71.2,
                                                -5.8
                                            ],
                                            [
                                                62.65,
                                                -8
                                            ],
                                            [
                                                58.3,
                                                -15.5
                                            ],
                                            [
                                                58,
                                                -15.5
                                            ],
                                            [
                                                51.55,
                                                -8.15
                                            ],
                                            [
                                                42.3,
                                                -5.5
                                            ],
                                            [
                                                31.05,
                                                -10.35
                                            ],
                                            [
                                                27,
                                                -22.7
                                            ],
                                            [
                                                28.55,
                                                -33.5
                                            ],
                                            [
                                                33,
                                                -42.55
                                            ],
                                            [
                                                40.05,
                                                -48.8
                                            ],
                                            [
                                                49.4,
                                                -51.1
                                            ],
                                            [
                                                57.5,
                                                -48.75
                                            ],
                                            [
                                                61.6,
                                                -43
                                            ],
                                            [
                                                61.9,
                                                -43
                                            ],
                                            [
                                                63.1,
                                                -49.5
                                            ],
                                            [
                                                72.2,
                                                -49.5
                                            ],
                                            [
                                                66.6,
                                                -21.9
                                            ],
                                            [
                                                67.1,
                                                -14.65
                                            ],
                                            [
                                                72.9,
                                                -11.8
                                            ],
                                            [
                                                78,
                                                -13
                                            ],
                                            [
                                                82.8,
                                                -16.9
                                            ],
                                            [
                                                86.35,
                                                -23.9
                                            ],
                                            [
                                                87.7,
                                                -34.4
                                            ],
                                            [
                                                85.05,
                                                -47.9
                                            ],
                                            [
                                                77.55,
                                                -58.75
                                            ],
                                            [
                                                65.95,
                                                -65.95
                                            ],
                                            [
                                                50.9,
                                                -68.5
                                            ],
                                            [
                                                35.15,
                                                -65.3
                                            ],
                                            [
                                                22.5,
                                                -56.35
                                            ],
                                            [
                                                14.05,
                                                -42.95
                                            ],
                                            [
                                                11,
                                                -26.4
                                            ],
                                            [
                                                15.85,
                                                -5.6
                                            ],
                                            [
                                                29.2,
                                                8
                                            ],
                                            [
                                                48.6,
                                                12.8
                                            ],
                                            [
                                                63.95,
                                                10.25
                                            ],
                                            [
                                                75.3,
                                                4.2
                                            ],
                                            [
                                                78.8,
                                                8.3
                                            ],
                                            [
                                                65.65,
                                                15.55
                                            ],
                                            [
                                                48,
                                                18.4
                                            ],
                                            [
                                                30.35,
                                                15.2
                                            ],
                                            [
                                                16.45,
                                                6.05
                                            ],
                                            [
                                                7.35,
                                                -8.15
                                            ],
                                            [
                                                4.1,
                                                -26.4
                                            ],
                                            [
                                                7.7,
                                                -45.35
                                            ],
                                            [
                                                17.7,
                                                -60.4
                                            ],
                                            [
                                                32.65,
                                                -70.35
                                            ],
                                            [
                                                51.1,
                                                -73.9
                                            ],
                                            [
                                                68.5,
                                                -71.1
                                            ],
                                            [
                                                82.2,
                                                -63.1
                                            ],
                                            [
                                                91.15,
                                                -50.7
                                            ],
                                            [
                                                94.3,
                                                -34.8
                                            ],
                                            [
                                                92.15,
                                                -21.15
                                            ],
                                            [
                                                86.55,
                                                -12.2
                                            ],
                                            [
                                                79.05,
                                                -7.3
                                            ],
                                            [
                                                71.2,
                                                -5.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                2.6666666666666665
                                            ],
                                            [
                                                -0.7999999999999972,
                                                4.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.3666666666666695,
                                                2.133333333333335
                                            ],
                                            [
                                                1.3333333333333333,
                                                1.4333333333333371
                                            ],
                                            [
                                                2.5333333333333363,
                                                0
                                            ],
                                            [
                                                1.7666666666666704,
                                                -1.2666666666666657
                                            ],
                                            [
                                                1.1333333333333304,
                                                -2.099999999999999
                                            ],
                                            [
                                                0.5666666666666677,
                                                -2.4333333333333322
                                            ],
                                            [
                                                0,
                                                -2.3999999999999986
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -1.8999999999999986
                                            ],
                                            [
                                                -2.8666666666666694,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.199999999999998,
                                                0
                                            ],
                                            [
                                                2.433333333333337,
                                                -2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.46666666666666856,
                                                -2.2666666666666657
                                            ],
                                            [
                                                -0.36666666666666475,
                                                -2.1333333333333306
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -1.4333333333333325
                                            ],
                                            [
                                                -2.3999999999999964,
                                                0
                                            ],
                                            [
                                                -1.7666666666666657,
                                                1.2666666666666704
                                            ],
                                            [
                                                -1.1333333333333353,
                                                2.099999999999999
                                            ],
                                            [
                                                -0.5666666666666677,
                                                2.433333333333335
                                            ],
                                            [
                                                0,
                                                3.133333333333335
                                            ],
                                            [
                                                1.3333333333333333,
                                                1.900000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                45.1,
                                                -12.7
                                            ],
                                            [
                                                53.55,
                                                -16.7
                                            ],
                                            [
                                                58.4,
                                                -26.9
                                            ],
                                            [
                                                59,
                                                -30
                                            ],
                                            [
                                                59.15,
                                                -36.6
                                            ],
                                            [
                                                56.6,
                                                -41.95
                                            ],
                                            [
                                                50.8,
                                                -44.1
                                            ],
                                            [
                                                44.55,
                                                -42.2
                                            ],
                                            [
                                                40.2,
                                                -37.15
                                            ],
                                            [
                                                37.65,
                                                -30.35
                                            ],
                                            [
                                                36.8,
                                                -23.1
                                            ],
                                            [
                                                38.8,
                                                -15.55
                                            ],
                                            [
                                                45.1,
                                                -12.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "*",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 47.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                23.5,
                                                -47.1
                                            ],
                                            [
                                                14.1,
                                                -34
                                            ],
                                            [
                                                8.6,
                                                -38.1
                                            ],
                                            [
                                                18.5,
                                                -50.7
                                            ],
                                            [
                                                3.2,
                                                -55.8
                                            ],
                                            [
                                                5.4,
                                                -62.1
                                            ],
                                            [
                                                20.3,
                                                -56.8
                                            ],
                                            [
                                                20.3,
                                                -72.9
                                            ],
                                            [
                                                26.9,
                                                -72.9
                                            ],
                                            [
                                                26.9,
                                                -56.8
                                            ],
                                            [
                                                41.9,
                                                -62.1
                                            ],
                                            [
                                                44.1,
                                                -55.8
                                            ],
                                            [
                                                29,
                                                -50.7
                                            ],
                                            [
                                                38.4,
                                                -38.1
                                            ],
                                            [
                                                33.2,
                                                -34
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "6",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 62.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.166666666666667,
                                                2.9
                                            ],
                                            [
                                                2,
                                                5.633333333333333
                                            ],
                                            [
                                                -0.06666666666666703,
                                                8.199999999999998
                                            ],
                                            [
                                                -1.1000000000000003,
                                                4.466666666666669
                                            ],
                                            [
                                                -2.3000000000000007,
                                                3.366666666666665
                                            ],
                                            [
                                                -3.633333333333333,
                                                1.8666666666666647
                                            ],
                                            [
                                                -5,
                                                0
                                            ],
                                            [
                                                -3.5333333333333314,
                                                -1.6333333333333353
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -3.0333333333333314
                                            ],
                                            [
                                                -0.5333333333333314,
                                                -4.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                2.300000000000002
                                            ],
                                            [
                                                4.666666666666667,
                                                0
                                            ],
                                            [
                                                2.8333333333333335,
                                                -2.200000000000003
                                            ],
                                            [
                                                1.2666666666666657,
                                                -4.299999999999997
                                            ],
                                            [
                                                -0.13333333333333405,
                                                -6.400000000000001
                                            ],
                                            [
                                                -3.4333333333333322,
                                                1.7666666666666657
                                            ],
                                            [
                                                -4.199999999999998,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -1.900000000000001
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -3.4333333333333322
                                            ],
                                            [
                                                0,
                                                -4.666666666666667
                                            ],
                                            [
                                                2.1333333333333306,
                                                -3.633333333333334
                                            ],
                                            [
                                                3.8333333333333335,
                                                -2.066666666666667
                                            ],
                                            [
                                                5.1333333333333355,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.466666666666664,
                                                0
                                            ],
                                            [
                                                -4.166666666666668,
                                                -2.9
                                            ],
                                            [
                                                -2,
                                                -5.6333333333333355
                                            ],
                                            [
                                                0.06666666666666643,
                                                -5.266666666666666
                                            ],
                                            [
                                                1.0999999999999996,
                                                -4.466666666666669
                                            ],
                                            [
                                                2.2999999999999994,
                                                -3.366666666666665
                                            ],
                                            [
                                                3.633333333333333,
                                                -1.8666666666666742
                                            ],
                                            [
                                                4.733333333333334,
                                                0
                                            ],
                                            [
                                                3.5333333333333363,
                                                1.6333333333333353
                                            ],
                                            [
                                                2.1666666666666665,
                                                3.0333333333333363
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.40000000000000097,
                                                -3.800000000000002
                                            ],
                                            [
                                                -2.4333333333333322,
                                                -2.300000000000002
                                            ],
                                            [
                                                -4.533333333333336,
                                                0
                                            ],
                                            [
                                                -2.8333333333333335,
                                                2.200000000000003
                                            ],
                                            [
                                                -1.2666666666666668,
                                                4.300000000000002
                                            ],
                                            [
                                                2,
                                                -3.400000000000001
                                            ],
                                            [
                                                3.433333333333335,
                                                -1.7666666666666704
                                            ],
                                            [
                                                4.400000000000001,
                                                0
                                            ],
                                            [
                                                3.6333333333333306,
                                                1.900000000000001
                                            ],
                                            [
                                                2.1666666666666665,
                                                3.433333333333335
                                            ],
                                            [
                                                0,
                                                4.733333333333332
                                            ],
                                            [
                                                -2.133333333333335,
                                                3.6333333333333333
                                            ],
                                            [
                                                -3.8333333333333335,
                                                2.066666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.8,
                                                1
                                            ],
                                            [
                                                16.85,
                                                -3.35
                                            ],
                                            [
                                                7.6,
                                                -16.15
                                            ],
                                            [
                                                4.7,
                                                -36.9
                                            ],
                                            [
                                                6.45,
                                                -51.5
                                            ],
                                            [
                                                11.55,
                                                -63.25
                                            ],
                                            [
                                                20.45,
                                                -71.1
                                            ],
                                            [
                                                33.4,
                                                -73.9
                                            ],
                                            [
                                                45.8,
                                                -71.45
                                            ],
                                            [
                                                54.35,
                                                -64.45
                                            ],
                                            [
                                                58.4,
                                                -53.6
                                            ],
                                            [
                                                48.6,
                                                -52.3
                                            ],
                                            [
                                                44.35,
                                                -61.45
                                            ],
                                            [
                                                33.7,
                                                -64.9
                                            ],
                                            [
                                                22.65,
                                                -61.6
                                            ],
                                            [
                                                16.5,
                                                -51.85
                                            ],
                                            [
                                                14.8,
                                                -35.8
                                            ],
                                            [
                                                22.95,
                                                -43.55
                                            ],
                                            [
                                                34.4,
                                                -46.2
                                            ],
                                            [
                                                46.45,
                                                -43.35
                                            ],
                                            [
                                                55.15,
                                                -35.35
                                            ],
                                            [
                                                58.4,
                                                -23.2
                                            ],
                                            [
                                                55.2,
                                                -10.65
                                            ],
                                            [
                                                46.25,
                                                -2.1
                                            ],
                                            [
                                                32.8,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.800000000000002,
                                                2.733333333333333
                                            ],
                                            [
                                                0,
                                                4.466666666666666
                                            ],
                                            [
                                                2.799999999999997,
                                                2.599999999999999
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.8333333333333335,
                                                -2.7333333333333294
                                            ],
                                            [
                                                0,
                                                -4.466666666666669
                                            ],
                                            [
                                                -2.7999999999999994,
                                                -2.6
                                            ],
                                            [
                                                -4.600000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.799999999999997,
                                                -2.733333333333333
                                            ],
                                            [
                                                0,
                                                -4.733333333333334
                                            ],
                                            [
                                                -2.800000000000002,
                                                -2.599999999999999
                                            ],
                                            [
                                                -4.533333333333334,
                                                0
                                            ],
                                            [
                                                -2.8333333333333335,
                                                2.7333333333333343
                                            ],
                                            [
                                                0,
                                                4.733333333333332
                                            ],
                                            [
                                                2.7999999999999994,
                                                2.6
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.6,
                                                -8
                                            ],
                                            [
                                                43.7,
                                                -12.1
                                            ],
                                            [
                                                47.9,
                                                -22.9
                                            ],
                                            [
                                                43.7,
                                                -33.9
                                            ],
                                            [
                                                32.6,
                                                -37.8
                                            ],
                                            [
                                                21.55,
                                                -33.7
                                            ],
                                            [
                                                17.3,
                                                -22.9
                                            ],
                                            [
                                                21.5,
                                                -11.9
                                            ],
                                            [
                                                32.6,
                                                -8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "+",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Regular",
            "w": 60.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                56.3,
                                                -30.4
                                            ],
                                            [
                                                34.7,
                                                -30.4
                                            ],
                                            [
                                                34.8,
                                                -7.4
                                            ],
                                            [
                                                25.3,
                                                -7.4
                                            ],
                                            [
                                                25.2,
                                                -30.4
                                            ],
                                            [
                                                3.8,
                                                -30.4
                                            ],
                                            [
                                                3.8,
                                                -38.8
                                            ],
                                            [
                                                25.2,
                                                -38.8
                                            ],
                                            [
                                                25.3,
                                                -60.8
                                            ],
                                            [
                                                34.8,
                                                -60.8
                                            ],
                                            [
                                                34.7,
                                                -38.8
                                            ],
                                            [
                                                56.3,
                                                -38.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ],
    "assets": [
        {
            "nm": "Popup ",
            "id": "1",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Pop up 4",
                    "sr": 1,
                    "st": 145,
                    "op": 18146,
                    "ip": 145,
                    "ln": "262",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "2",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "popup 1",
                    "sr": 1,
                    "st": 145,
                    "op": 18146,
                    "ip": 145,
                    "ln": "265",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "8",
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Pop up 4",
            "id": "2",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "247",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                675.129,
                                559.995
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 19,
                    "h": 19,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "User Request",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "248",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                39.468,
                                -3.097
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                530.351,
                                560.179
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "Login redirects to dashboard",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "249",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                263.747,
                                197.538
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                632.143,
                                559.242
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            217.276,
                                            31.025
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            219.01,
                                            197.732
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Tick.svg",
            "id": "3",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "163",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.222,
                                                    -2.903
                                                ],
                                                [
                                                    -1.583,
                                                    2.903
                                                ],
                                                [
                                                    -4.222,
                                                    0.264
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.826
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.5,
                                            9.237
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.247
                                                ],
                                                [
                                                    5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.247
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    5.247
                                                ],
                                                [
                                                    -5.247,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -5.247
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -9.5
                                                ],
                                                [
                                                    9.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.5
                                                ],
                                                [
                                                    -9.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.2941,
                                            0.6784,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            9.5,
                                            9.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "popup 1",
            "id": "8",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Tick.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "278",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                9.5,
                                9.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                230.086,
                                556.772
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 19,
                    "h": 19,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "Recording workflow...",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "279",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                62.463,
                                -3.405
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                106.226,
                                557.326
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "Account created successfully",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "280",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                359.447,
                                364
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            221.14,
                                            28.063
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -219.299,
                                            192.897
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Dot Line",
            "id": "9",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 5",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "50",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -135.772,
                                95.167
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                -98.362,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                505.548,
                                461.167
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.081,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.081,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.176,
                                                    2.661
                                                ],
                                                [
                                                    -5.176,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    187.672
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 0,
                                                "k": 0
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": -2
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 45
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "51",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -135.772,
                                95.167
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                246.228,
                                461.167
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.081,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.081,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.176,
                                                    2.661
                                                ],
                                                [
                                                    -5.176,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    57.076
                                                ],
                                                [
                                                    -266.368,
                                                    187.672
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 0,
                                                "k": 0
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": -2
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 45
                                    }
                                ]
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 0,
                                "k": 0
                            },
                            "m": 1
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Text field",
            "id": "10",
            "fr": 30,
            "layers": [
                {
                    "ty": 5,
                    "nm": "Harsh Sharma",
                    "sr": 1,
                    "st": 18,
                    "op": 18093,
                    "ip": 18,
                    "ln": "145",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                47.865,
                                -3.053
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                314.985,
                                126.653
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [
                            {
                                "s": {
                                    "t": 0,
                                    "xe": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ne": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "b": 1,
                                    "rn": 0,
                                    "sh": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "r": 1,
                                    "sm": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 47
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 74
                                            }
                                        ]
                                    },
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                "a": {
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "rx": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ry": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sw": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fh": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fs": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "fb": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "t": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            }
                        ],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "john doe",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 1
                },
                {
                    "ty": 5,
                    "nm": "Enter your name",
                    "sr": 1,
                    "st": 0,
                    "op": 47,
                    "ip": 0,
                    "ln": "146",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                47.865,
                                -3.053
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                314.985,
                                126.653
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "Enter your name",
                                        "fc": [
                                            0.6974,
                                            0.6974,
                                            0.6974
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 2
                },
                {
                    "ty": 5,
                    "nm": "john.doe@gmail.com",
                    "sr": 1,
                    "st": -47,
                    "op": 17954,
                    "ip": 71,
                    "ln": "147",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                75.609,
                                -3.333
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                342.838,
                                189.156
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [
                            {
                                "s": {
                                    "t": 0,
                                    "xe": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ne": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "b": 1,
                                    "rn": 0,
                                    "sh": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "r": 1,
                                    "sm": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 78.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 105.999
                                            }
                                        ]
                                    },
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                "a": {
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "rx": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ry": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sw": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fh": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fs": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "fb": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "t": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            }
                        ],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "john.doe@gmail.com",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 3
                },
                {
                    "ty": 5,
                    "nm": "name@gmail.com",
                    "sr": 1,
                    "st": 0,
                    "op": 78,
                    "ip": 0,
                    "ln": "148",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                47.865,
                                -3.053
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                314.985,
                                188.331
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "name@gmail.com",
                                        "fc": [
                                            0.6974,
                                            0.6974,
                                            0.6974
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 4
                },
                {
                    "ty": 5,
                    "nm": "******** 2",
                    "sr": 1,
                    "st": 5,
                    "op": 18006,
                    "ip": 80,
                    "ln": "149",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                23.007,
                                -5.879
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                292.741,
                                250.911
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [
                            {
                                "s": {
                                    "t": 0,
                                    "xe": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ne": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "b": 1,
                                    "rn": 0,
                                    "sh": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "r": 1,
                                    "sm": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 108.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 137.999
                                            }
                                        ]
                                    },
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                "a": {
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "rx": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "ry": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sw": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fh": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "fs": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "fb": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "t": {
                                        "a": 0,
                                        "k": 0
                                    }
                                }
                            }
                        ],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "********",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 5
                },
                {
                    "ty": 5,
                    "nm": "6+ characters",
                    "sr": 1,
                    "st": 0,
                    "op": 107,
                    "ip": 0,
                    "ln": "150",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                52.085,
                                -3.333
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                319.205,
                                251.089
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Regular",
                                        "s": 11,
                                        "t": "6+ characters",
                                        "fc": [
                                            0.6974,
                                            0.6974,
                                            0.6974
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 6
                }
            ]
        },
        {
            "nm": "Register.svg",
            "id": "11",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Button .svg",
                    "sr": 1,
                    "st": 0,
                    "op": 84,
                    "ip": 0,
                    "ln": "640",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                113,
                                19
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                102,
                                102
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                133.5,
                                279.163
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 226,
                    "h": 38,
                    "refId": "12",
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Register.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "79",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                133.5,
                                158.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                133.5,
                                158.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    -0.086
                                                ],
                                                [
                                                    -0.211,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.201
                                                ],
                                                [
                                                    0.085,
                                                    0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.38,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.524,
                                                    -0.729
                                                ],
                                                [
                                                    -38.524,
                                                    1.698
                                                ],
                                                [
                                                    -38.396,
                                                    2.127
                                                ],
                                                [
                                                    -37.952,
                                                    2.247
                                                ],
                                                [
                                                    -37.45,
                                                    2.247
                                                ],
                                                [
                                                    -37.45,
                                                    2.825
                                                ],
                                                [
                                                    -38.066,
                                                    2.825
                                                ],
                                                [
                                                    -38.922,
                                                    2.562
                                                ],
                                                [
                                                    -39.208,
                                                    1.698
                                                ],
                                                [
                                                    -39.208,
                                                    -0.729
                                                ],
                                                [
                                                    -39.741,
                                                    -0.729
                                                ],
                                                [
                                                    -39.741,
                                                    -1.292
                                                ],
                                                [
                                                    -39.208,
                                                    -1.292
                                                ],
                                                [
                                                    -39.208,
                                                    -2.329
                                                ],
                                                [
                                                    -38.524,
                                                    -2.329
                                                ],
                                                [
                                                    -38.524,
                                                    -1.292
                                                ],
                                                [
                                                    -37.45,
                                                    -1.292
                                                ],
                                                [
                                                    -37.45,
                                                    -0.729
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.376
                                                ],
                                                [
                                                    0.015,
                                                    -0.145
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.23
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.195,
                                                    0.135
                                                ],
                                                [
                                                    -0.08,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -0.251
                                                ],
                                                [
                                                    0.491,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.175
                                                ],
                                                [
                                                    0.176,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.17,
                                                    0.321
                                                ],
                                                [
                                                    -0.306,
                                                    0.17
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    -0.171
                                                ],
                                                [
                                                    -0.16,
                                                    -0.301
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.406
                                                ],
                                                [
                                                    0.256,
                                                    0.226
                                                ],
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.2,
                                                    -0.141
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.395
                                                ],
                                                [
                                                    -0.332,
                                                    0.245
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.306,
                                                    -0.175
                                                ],
                                                [
                                                    -0.175,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.17,
                                                    -0.32
                                                ],
                                                [
                                                    0.31,
                                                    -0.175
                                                ],
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.17
                                                ],
                                                [
                                                    0.164,
                                                    0.295
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -32.864,
                                                    0.609
                                                ],
                                                [
                                                    -32.887,
                                                    1.022
                                                ],
                                                [
                                                    -36.178,
                                                    1.022
                                                ],
                                                [
                                                    -35.764,
                                                    1.976
                                                ],
                                                [
                                                    -34.84,
                                                    2.314
                                                ],
                                                [
                                                    -34.104,
                                                    2.112
                                                ],
                                                [
                                                    -33.682,
                                                    1.556
                                                ],
                                                [
                                                    -32.947,
                                                    1.556
                                                ],
                                                [
                                                    -33.607,
                                                    2.525
                                                ],
                                                [
                                                    -34.84,
                                                    2.893
                                                ],
                                                [
                                                    -35.892,
                                                    2.63
                                                ],
                                                [
                                                    -36.614,
                                                    1.886
                                                ],
                                                [
                                                    -36.877,
                                                    0.759
                                                ],
                                                [
                                                    -36.621,
                                                    -0.361
                                                ],
                                                [
                                                    -35.907,
                                                    -1.097
                                                ],
                                                [
                                                    -34.84,
                                                    -1.36
                                                ],
                                                [
                                                    -33.803,
                                                    -1.104
                                                ],
                                                [
                                                    -33.111,
                                                    -0.398
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.115,
                                                    0.186
                                                ],
                                                [
                                                    0.2,
                                                    0.095
                                                ],
                                                [
                                                    0.239,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    -0.22
                                                ],
                                                [
                                                    0.035,
                                                    -0.391
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.26
                                                ],
                                                [
                                                    -0.114,
                                                    -0.19
                                                ],
                                                [
                                                    -0.195,
                                                    -0.1
                                                ],
                                                [
                                                    -0.346,
                                                    0
                                                ],
                                                [
                                                    -0.24,
                                                    0.221
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -33.57,
                                                    0.466
                                                ],
                                                [
                                                    -33.743,
                                                    -0.203
                                                ],
                                                [
                                                    -34.216,
                                                    -0.631
                                                ],
                                                [
                                                    -34.869,
                                                    -0.781
                                                ],
                                                [
                                                    -35.757,
                                                    -0.451
                                                ],
                                                [
                                                    -36.17,
                                                    0.466
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.219,
                                                    0.13
                                                ],
                                                [
                                                    -0.32,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.119,
                                                    -0.235
                                                ],
                                                [
                                                    0.227,
                                                    -0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.767,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.277,
                                                    -0.624
                                                ],
                                                [
                                                    -30.767,
                                                    -1.172
                                                ],
                                                [
                                                    -29.948,
                                                    -1.367
                                                ],
                                                [
                                                    -29.948,
                                                    -0.661
                                                ],
                                                [
                                                    -30.128,
                                                    -0.661
                                                ],
                                                [
                                                    -31.277,
                                                    0.586
                                                ],
                                                [
                                                    -31.277,
                                                    2.825
                                                ],
                                                [
                                                    -31.962,
                                                    2.825
                                                ],
                                                [
                                                    -31.962,
                                                    -1.292
                                                ],
                                                [
                                                    -31.277,
                                                    -1.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.326,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.135
                                                ],
                                                [
                                                    -0.145,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    -0.38
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.347,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.346,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.225,
                                                    0.116
                                                ],
                                                [
                                                    -0.276,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.156
                                                ],
                                                [
                                                    -0.132,
                                                    -0.3
                                                ],
                                                [
                                                    -0.267,
                                                    0.16
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.321,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.131
                                                ],
                                                [
                                                    0.146,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.2,
                                                    -0.221
                                                ],
                                                [
                                                    -0.356,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.225
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.2,
                                                    -0.221
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.225
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.215
                                                ],
                                                [
                                                    0.232,
                                                    -0.115
                                                ],
                                                [
                                                    0.345,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    0.155
                                                ],
                                                [
                                                    0.114,
                                                    -0.29
                                                ],
                                                [
                                                    0.265,
                                                    -0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.206,
                                                    -1.367
                                                ],
                                                [
                                                    -23.35,
                                                    -1.165
                                                ],
                                                [
                                                    -22.757,
                                                    -0.571
                                                ],
                                                [
                                                    -22.538,
                                                    0.398
                                                ],
                                                [
                                                    -22.538,
                                                    2.825
                                                ],
                                                [
                                                    -23.215,
                                                    2.825
                                                ],
                                                [
                                                    -23.215,
                                                    0.496
                                                ],
                                                [
                                                    -23.523,
                                                    -0.443
                                                ],
                                                [
                                                    -24.342,
                                                    -0.774
                                                ],
                                                [
                                                    -25.191,
                                                    -0.428
                                                ],
                                                [
                                                    -25.507,
                                                    0.556
                                                ],
                                                [
                                                    -25.507,
                                                    2.825
                                                ],
                                                [
                                                    -26.182,
                                                    2.825
                                                ],
                                                [
                                                    -26.182,
                                                    0.496
                                                ],
                                                [
                                                    -26.491,
                                                    -0.443
                                                ],
                                                [
                                                    -27.31,
                                                    -0.774
                                                ],
                                                [
                                                    -28.159,
                                                    -0.428
                                                ],
                                                [
                                                    -28.475,
                                                    0.556
                                                ],
                                                [
                                                    -28.475,
                                                    2.825
                                                ],
                                                [
                                                    -29.158,
                                                    2.825
                                                ],
                                                [
                                                    -29.158,
                                                    -1.292
                                                ],
                                                [
                                                    -28.475,
                                                    -1.292
                                                ],
                                                [
                                                    -28.475,
                                                    -0.699
                                                ],
                                                [
                                                    -27.934,
                                                    -1.195
                                                ],
                                                [
                                                    -27.174,
                                                    -1.367
                                                ],
                                                [
                                                    -26.258,
                                                    -1.134
                                                ],
                                                [
                                                    -25.663,
                                                    -0.451
                                                ],
                                                [
                                                    -25.092,
                                                    -1.127
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.105
                                                ],
                                                [
                                                    0.145,
                                                    0.191
                                                ],
                                                [
                                                    0.016,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.13
                                                ],
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.15,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.175
                                                ],
                                                [
                                                    0.162,
                                                    0.085
                                                ],
                                                [
                                                    0.336,
                                                    0.085
                                                ],
                                                [
                                                    0.196,
                                                    0.08
                                                ],
                                                [
                                                    0.14,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    -0.125,
                                                    0.175
                                                ],
                                                [
                                                    -0.23,
                                                    0.1
                                                ],
                                                [
                                                    -0.295,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.231
                                                ],
                                                [
                                                    -0.021,
                                                    -0.4
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    0.13
                                                ],
                                                [
                                                    0.267,
                                                    0
                                                ],
                                                [
                                                    0.146,
                                                    -0.105
                                                ],
                                                [
                                                    0,
                                                    -0.171
                                                ],
                                                [
                                                    -0.086,
                                                    -0.09
                                                ],
                                                [
                                                    -0.131,
                                                    -0.055
                                                ],
                                                [
                                                    -0.235,
                                                    -0.065
                                                ],
                                                [
                                                    -0.187,
                                                    -0.081
                                                ],
                                                [
                                                    -0.13,
                                                    -0.155
                                                ],
                                                [
                                                    -0.004,
                                                    -0.251
                                                ],
                                                [
                                                    0.125,
                                                    -0.18
                                                ],
                                                [
                                                    0.231,
                                                    -0.105
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.317,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    -0.11
                                                ],
                                                [
                                                    -0.145,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    0.205
                                                ],
                                                [
                                                    0.175,
                                                    0.13
                                                ],
                                                [
                                                    0.261,
                                                    0
                                                ],
                                                [
                                                    0.151,
                                                    -0.116
                                                ],
                                                [
                                                    0,
                                                    -0.181
                                                ],
                                                [
                                                    -0.159,
                                                    -0.091
                                                ],
                                                [
                                                    -0.306,
                                                    -0.081
                                                ],
                                                [
                                                    -0.19,
                                                    -0.085
                                                ],
                                                [
                                                    -0.135,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    -0.211
                                                ],
                                                [
                                                    0.125,
                                                    -0.175
                                                ],
                                                [
                                                    0.231,
                                                    -0.105
                                                ],
                                                [
                                                    0.455,
                                                    0
                                                ],
                                                [
                                                    0.282,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.015,
                                                    -0.215
                                                ],
                                                [
                                                    -0.155,
                                                    -0.13
                                                ],
                                                [
                                                    -0.244,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.106
                                                ],
                                                [
                                                    0,
                                                    0.135
                                                ],
                                                [
                                                    0.089,
                                                    0.085
                                                ],
                                                [
                                                    0.135,
                                                    0.05
                                                ],
                                                [
                                                    0.295,
                                                    0.08
                                                ],
                                                [
                                                    0.185,
                                                    0.075
                                                ],
                                                [
                                                    0.135,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0.225
                                                ],
                                                [
                                                    -0.126,
                                                    0.181
                                                ],
                                                [
                                                    -0.224,
                                                    0.1
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -19.958,
                                                    2.893
                                                ],
                                                [
                                                    -20.807,
                                                    2.735
                                                ],
                                                [
                                                    -21.402,
                                                    2.284
                                                ],
                                                [
                                                    -21.642,
                                                    1.616
                                                ],
                                                [
                                                    -20.936,
                                                    1.616
                                                ],
                                                [
                                                    -20.65,
                                                    2.119
                                                ],
                                                [
                                                    -19.967,
                                                    2.314
                                                ],
                                                [
                                                    -19.351,
                                                    2.142
                                                ],
                                                [
                                                    -19.124,
                                                    1.706
                                                ],
                                                [
                                                    -19.366,
                                                    1.308
                                                ],
                                                [
                                                    -20.109,
                                                    1.045
                                                ],
                                                [
                                                    -20.861,
                                                    0.804
                                                ],
                                                [
                                                    -21.357,
                                                    0.436
                                                ],
                                                [
                                                    -21.56,
                                                    -0.21
                                                ],
                                                [
                                                    -21.372,
                                                    -0.789
                                                ],
                                                [
                                                    -20.838,
                                                    -1.202
                                                ],
                                                [
                                                    -20.049,
                                                    -1.36
                                                ],
                                                [
                                                    -18.945,
                                                    -1.014
                                                ],
                                                [
                                                    -18.493,
                                                    -0.068
                                                ],
                                                [
                                                    -19.178,
                                                    -0.068
                                                ],
                                                [
                                                    -19.441,
                                                    -0.586
                                                ],
                                                [
                                                    -20.072,
                                                    -0.781
                                                ],
                                                [
                                                    -20.658,
                                                    -0.624
                                                ],
                                                [
                                                    -20.876,
                                                    -0.21
                                                ],
                                                [
                                                    -20.747,
                                                    0.128
                                                ],
                                                [
                                                    -20.417,
                                                    0.338
                                                ],
                                                [
                                                    -19.861,
                                                    0.511
                                                ],
                                                [
                                                    -19.139,
                                                    0.752
                                                ],
                                                [
                                                    -18.667,
                                                    1.097
                                                ],
                                                [
                                                    -18.456,
                                                    1.706
                                                ],
                                                [
                                                    -18.644,
                                                    2.314
                                                ],
                                                [
                                                    -19.178,
                                                    2.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.316
                                                ],
                                                [
                                                    -0.297,
                                                    0.175
                                                ],
                                                [
                                                    -0.364,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.272,
                                                    -0.16
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.295,
                                                    0.18
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.321
                                                ],
                                                [
                                                    0.299,
                                                    -0.175
                                                ],
                                                [
                                                    0.362,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.24
                                                ],
                                                [
                                                    -0.265,
                                                    0.155
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.297,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.743,
                                                    0.752
                                                ],
                                                [
                                                    -15.488,
                                                    -0.353
                                                ],
                                                [
                                                    -14.788,
                                                    -1.097
                                                ],
                                                [
                                                    -13.79,
                                                    -1.36
                                                ],
                                                [
                                                    -12.851,
                                                    -1.127
                                                ],
                                                [
                                                    -12.257,
                                                    -0.541
                                                ],
                                                [
                                                    -12.257,
                                                    -1.292
                                                ],
                                                [
                                                    -11.566,
                                                    -1.292
                                                ],
                                                [
                                                    -11.566,
                                                    2.825
                                                ],
                                                [
                                                    -12.257,
                                                    2.825
                                                ],
                                                [
                                                    -12.257,
                                                    2.059
                                                ],
                                                [
                                                    -12.866,
                                                    2.66
                                                ],
                                                [
                                                    -13.797,
                                                    2.893
                                                ],
                                                [
                                                    -14.788,
                                                    2.623
                                                ],
                                                [
                                                    -15.488,
                                                    1.864
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.311
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.12
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.209,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.315
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.21,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.126
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.257,
                                                    0.759
                                                ],
                                                [
                                                    -12.445,
                                                    -0.052
                                                ],
                                                [
                                                    -12.956,
                                                    -0.578
                                                ],
                                                [
                                                    -13.654,
                                                    -0.766
                                                ],
                                                [
                                                    -14.353,
                                                    -0.586
                                                ],
                                                [
                                                    -14.857,
                                                    -0.06
                                                ],
                                                [
                                                    -15.045,
                                                    0.752
                                                ],
                                                [
                                                    -14.857,
                                                    1.578
                                                ],
                                                [
                                                    -14.353,
                                                    2.112
                                                ],
                                                [
                                                    -13.654,
                                                    2.292
                                                ],
                                                [
                                                    -12.956,
                                                    2.112
                                                ],
                                                [
                                                    -12.445,
                                                    1.578
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.502,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.206,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.237,
                                                    -0.115
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.404,
                                                    -1.367
                                                ],
                                                [
                                                    -7.187,
                                                    -0.909
                                                ],
                                                [
                                                    -6.721,
                                                    0.398
                                                ],
                                                [
                                                    -6.721,
                                                    2.825
                                                ],
                                                [
                                                    -7.396,
                                                    2.825
                                                ],
                                                [
                                                    -7.396,
                                                    0.496
                                                ],
                                                [
                                                    -7.704,
                                                    -0.443
                                                ],
                                                [
                                                    -8.547,
                                                    -0.774
                                                ],
                                                [
                                                    -9.411,
                                                    -0.436
                                                ],
                                                [
                                                    -9.726,
                                                    0.549
                                                ],
                                                [
                                                    -9.726,
                                                    2.825
                                                ],
                                                [
                                                    -10.41,
                                                    2.825
                                                ],
                                                [
                                                    -10.41,
                                                    -1.292
                                                ],
                                                [
                                                    -9.726,
                                                    -1.292
                                                ],
                                                [
                                                    -9.726,
                                                    -0.706
                                                ],
                                                [
                                                    -9.178,
                                                    -1.195
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.169,
                                                    0.316
                                                ],
                                                [
                                                    -0.297,
                                                    0.175
                                                ],
                                                [
                                                    -0.371,
                                                    0
                                                ],
                                                [
                                                    -0.275,
                                                    -0.151
                                                ],
                                                [
                                                    -0.146,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    -0.16
                                                ],
                                                [
                                                    0.357,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.18
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.321
                                                ],
                                                [
                                                    0.3,
                                                    -0.175
                                                ],
                                                [
                                                    0.321,
                                                    0
                                                ],
                                                [
                                                    0.276,
                                                    0.145
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.136,
                                                    0.246
                                                ],
                                                [
                                                    -0.266,
                                                    0.155
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.297,
                                                    -0.181
                                                ],
                                                [
                                                    -0.169,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.859,
                                                    0.752
                                                ],
                                                [
                                                    -5.604,
                                                    -0.353
                                                ],
                                                [
                                                    -4.904,
                                                    -1.097
                                                ],
                                                [
                                                    -3.898,
                                                    -1.36
                                                ],
                                                [
                                                    -3.004,
                                                    -1.134
                                                ],
                                                [
                                                    -2.372,
                                                    -0.556
                                                ],
                                                [
                                                    -2.372,
                                                    -2.735
                                                ],
                                                [
                                                    -1.682,
                                                    -2.735
                                                ],
                                                [
                                                    -1.682,
                                                    2.825
                                                ],
                                                [
                                                    -2.372,
                                                    2.825
                                                ],
                                                [
                                                    -2.372,
                                                    2.051
                                                ],
                                                [
                                                    -2.973,
                                                    2.66
                                                ],
                                                [
                                                    -3.906,
                                                    2.893
                                                ],
                                                [
                                                    -4.904,
                                                    2.623
                                                ],
                                                [
                                                    -5.604,
                                                    1.864
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.311
                                                ],
                                                [
                                                    0.126,
                                                    0.23
                                                ],
                                                [
                                                    0.217,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.12
                                                ],
                                                [
                                                    0.127,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.315
                                                ],
                                                [
                                                    0.127,
                                                    0.23
                                                ],
                                                [
                                                    0.211,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.217,
                                                    -0.126
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.372,
                                                    0.759
                                                ],
                                                [
                                                    -2.561,
                                                    -0.052
                                                ],
                                                [
                                                    -3.072,
                                                    -0.578
                                                ],
                                                [
                                                    -3.77,
                                                    -0.766
                                                ],
                                                [
                                                    -4.469,
                                                    -0.586
                                                ],
                                                [
                                                    -4.973,
                                                    -0.06
                                                ],
                                                [
                                                    -5.161,
                                                    0.752
                                                ],
                                                [
                                                    -4.973,
                                                    1.578
                                                ],
                                                [
                                                    -4.469,
                                                    2.112
                                                ],
                                                [
                                                    -3.77,
                                                    2.292
                                                ],
                                                [
                                                    -3.072,
                                                    2.112
                                                ],
                                                [
                                                    -2.561,
                                                    1.578
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.431
                                                ],
                                                [
                                                    -0.17,
                                                    0.316
                                                ],
                                                [
                                                    -0.301,
                                                    0.175
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.325,
                                                    -0.245
                                                ],
                                                [
                                                    -0.106,
                                                    -0.436
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.207,
                                                    0.145
                                                ],
                                                [
                                                    0.3,
                                                    0
                                                ],
                                                [
                                                    0.241,
                                                    -0.27
                                                ],
                                                [
                                                    0,
                                                    -0.491
                                                ],
                                                [
                                                    -0.239,
                                                    -0.271
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.2,
                                                    0.14
                                                ],
                                                [
                                                    -0.075,
                                                    0.26
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -0.255
                                                ],
                                                [
                                                    0.496,
                                                    0
                                                ],
                                                [
                                                    0.306,
                                                    0.175
                                                ],
                                                [
                                                    0.171,
                                                    0.321
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.171,
                                                    -0.321
                                                ],
                                                [
                                                    0.306,
                                                    -0.175
                                                ],
                                                [
                                                    0.505,
                                                    0
                                                ],
                                                [
                                                    0.332,
                                                    0.246
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.069,
                                                    -0.25
                                                ],
                                                [
                                                    -0.2,
                                                    -0.146
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.239,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.496
                                                ],
                                                [
                                                    0.241,
                                                    0.27
                                                ],
                                                [
                                                    0.3,
                                                    0
                                                ],
                                                [
                                                    0.201,
                                                    -0.14
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.421
                                                ],
                                                [
                                                    -0.331,
                                                    0.251
                                                ],
                                                [
                                                    -0.392,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    -0.175
                                                ],
                                                [
                                                    -0.17,
                                                    -0.32
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.223,
                                                    0.759
                                                ],
                                                [
                                                    1.477,
                                                    -0.353
                                                ],
                                                [
                                                    2.184,
                                                    -1.097
                                                ],
                                                [
                                                    3.229,
                                                    -1.36
                                                ],
                                                [
                                                    4.475,
                                                    -0.992
                                                ],
                                                [
                                                    5.13,
                                                    0.03
                                                ],
                                                [
                                                    4.393,
                                                    0.03
                                                ],
                                                [
                                                    3.979,
                                                    -0.563
                                                ],
                                                [
                                                    3.229,
                                                    -0.781
                                                ],
                                                [
                                                    2.281,
                                                    -0.376
                                                ],
                                                [
                                                    1.921,
                                                    0.759
                                                ],
                                                [
                                                    2.281,
                                                    1.909
                                                ],
                                                [
                                                    3.229,
                                                    2.314
                                                ],
                                                [
                                                    3.979,
                                                    2.104
                                                ],
                                                [
                                                    4.393,
                                                    1.503
                                                ],
                                                [
                                                    5.13,
                                                    1.503
                                                ],
                                                [
                                                    4.468,
                                                    2.517
                                                ],
                                                [
                                                    3.229,
                                                    2.893
                                                ],
                                                [
                                                    2.184,
                                                    2.63
                                                ],
                                                [
                                                    1.477,
                                                    1.886
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.392,
                                                    0
                                                ],
                                                [
                                                    0.317,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.181,
                                                    0.321
                                                ],
                                                [
                                                    -0.317,
                                                    0.17
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.175
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.191,
                                                    -0.325
                                                ],
                                                [
                                                    0.321,
                                                    -0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.175
                                                ],
                                                [
                                                    -0.175,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.185,
                                                    -0.326
                                                ],
                                                [
                                                    0.315,
                                                    -0.175
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.17
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.184,
                                                    0.321
                                                ],
                                                [
                                                    -0.319,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.837,
                                                    2.893
                                                ],
                                                [
                                                    6.785,
                                                    2.63
                                                ],
                                                [
                                                    6.049,
                                                    1.886
                                                ],
                                                [
                                                    5.786,
                                                    0.759
                                                ],
                                                [
                                                    6.057,
                                                    -0.353
                                                ],
                                                [
                                                    6.809,
                                                    -1.097
                                                ],
                                                [
                                                    7.867,
                                                    -1.36
                                                ],
                                                [
                                                    8.927,
                                                    -1.097
                                                ],
                                                [
                                                    9.671,
                                                    -0.361
                                                ],
                                                [
                                                    9.949,
                                                    0.759
                                                ],
                                                [
                                                    9.663,
                                                    1.886
                                                ],
                                                [
                                                    8.904,
                                                    2.63
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    0.115
                                                ],
                                                [
                                                    -0.131,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.244,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.116
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.119,
                                                    -0.23
                                                ],
                                                [
                                                    -0.205,
                                                    -0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.115
                                                ],
                                                [
                                                    0.134,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.131,
                                                    -0.23
                                                ],
                                                [
                                                    -0.211,
                                                    -0.116
                                                ],
                                                [
                                                    -0.252,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.231
                                                ],
                                                [
                                                    0.206,
                                                    0.11
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.837,
                                                    2.292
                                                ],
                                                [
                                                    8.529,
                                                    2.119
                                                ],
                                                [
                                                    9.048,
                                                    1.601
                                                ],
                                                [
                                                    9.251,
                                                    0.759
                                                ],
                                                [
                                                    9.055,
                                                    -0.083
                                                ],
                                                [
                                                    8.544,
                                                    -0.593
                                                ],
                                                [
                                                    7.861,
                                                    -0.766
                                                ],
                                                [
                                                    7.169,
                                                    -0.593
                                                ],
                                                [
                                                    6.673,
                                                    -0.083
                                                ],
                                                [
                                                    6.486,
                                                    0.759
                                                ],
                                                [
                                                    6.665,
                                                    1.608
                                                ],
                                                [
                                                    7.161,
                                                    2.127
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.205,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.235,
                                                    -0.115
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.854,
                                                    -1.367
                                                ],
                                                [
                                                    14.072,
                                                    -0.909
                                                ],
                                                [
                                                    14.537,
                                                    0.398
                                                ],
                                                [
                                                    14.537,
                                                    2.825
                                                ],
                                                [
                                                    13.861,
                                                    2.825
                                                ],
                                                [
                                                    13.861,
                                                    0.496
                                                ],
                                                [
                                                    13.553,
                                                    -0.443
                                                ],
                                                [
                                                    12.712,
                                                    -0.774
                                                ],
                                                [
                                                    11.848,
                                                    -0.436
                                                ],
                                                [
                                                    11.531,
                                                    0.549
                                                ],
                                                [
                                                    11.531,
                                                    2.825
                                                ],
                                                [
                                                    10.848,
                                                    2.825
                                                ],
                                                [
                                                    10.848,
                                                    -1.292
                                                ],
                                                [
                                                    11.531,
                                                    -1.292
                                                ],
                                                [
                                                    11.531,
                                                    -0.706
                                                ],
                                                [
                                                    12.08,
                                                    -1.195
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.316
                                                ],
                                                [
                                                    -0.297,
                                                    0.175
                                                ],
                                                [
                                                    -0.371,
                                                    0
                                                ],
                                                [
                                                    -0.276,
                                                    -0.151
                                                ],
                                                [
                                                    -0.145,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.264,
                                                    -0.16
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.18
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.321
                                                ],
                                                [
                                                    0.3,
                                                    -0.175
                                                ],
                                                [
                                                    0.319,
                                                    0
                                                ],
                                                [
                                                    0.274,
                                                    0.145
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.134,
                                                    0.246
                                                ],
                                                [
                                                    -0.267,
                                                    0.155
                                                ],
                                                [
                                                    -0.364,
                                                    0
                                                ],
                                                [
                                                    -0.297,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.399,
                                                    0.752
                                                ],
                                                [
                                                    15.654,
                                                    -0.353
                                                ],
                                                [
                                                    16.354,
                                                    -1.097
                                                ],
                                                [
                                                    17.361,
                                                    -1.36
                                                ],
                                                [
                                                    18.255,
                                                    -1.134
                                                ],
                                                [
                                                    18.885,
                                                    -0.556
                                                ],
                                                [
                                                    18.885,
                                                    -2.735
                                                ],
                                                [
                                                    19.576,
                                                    -2.735
                                                ],
                                                [
                                                    19.576,
                                                    2.825
                                                ],
                                                [
                                                    18.885,
                                                    2.825
                                                ],
                                                [
                                                    18.885,
                                                    2.051
                                                ],
                                                [
                                                    18.285,
                                                    2.66
                                                ],
                                                [
                                                    17.352,
                                                    2.893
                                                ],
                                                [
                                                    16.354,
                                                    2.623
                                                ],
                                                [
                                                    15.654,
                                                    1.864
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.311
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.209,
                                                    -0.12
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.212,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.209,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.209,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.212,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.315
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.209,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.126
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.885,
                                                    0.759
                                                ],
                                                [
                                                    18.697,
                                                    -0.052
                                                ],
                                                [
                                                    18.186,
                                                    -0.578
                                                ],
                                                [
                                                    17.488,
                                                    -0.766
                                                ],
                                                [
                                                    16.79,
                                                    -0.586
                                                ],
                                                [
                                                    16.285,
                                                    -0.06
                                                ],
                                                [
                                                    16.098,
                                                    0.752
                                                ],
                                                [
                                                    16.285,
                                                    1.578
                                                ],
                                                [
                                                    16.79,
                                                    2.112
                                                ],
                                                [
                                                    17.488,
                                                    2.292
                                                ],
                                                [
                                                    18.186,
                                                    2.112
                                                ],
                                                [
                                                    18.697,
                                                    1.578
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.091,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.09,
                                                    0.091
                                                ],
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.087,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.091,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.087,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.085,
                                                    -1.961
                                                ],
                                                [
                                                    20.755,
                                                    -2.096
                                                ],
                                                [
                                                    20.619,
                                                    -2.427
                                                ],
                                                [
                                                    20.755,
                                                    -2.758
                                                ],
                                                [
                                                    21.085,
                                                    -2.893
                                                ],
                                                [
                                                    21.402,
                                                    -2.758
                                                ],
                                                [
                                                    21.536,
                                                    -2.427
                                                ],
                                                [
                                                    21.402,
                                                    -2.096
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.417,
                                                    -1.292
                                                ],
                                                [
                                                    21.417,
                                                    2.825
                                                ],
                                                [
                                                    20.732,
                                                    2.825
                                                ],
                                                [
                                                    20.732,
                                                    -1.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.086
                                                ],
                                                [
                                                    -0.209,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.201
                                                ],
                                                [
                                                    0.084,
                                                    0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.415,
                                                    -0.729
                                                ],
                                                [
                                                    23.415,
                                                    1.698
                                                ],
                                                [
                                                    23.544,
                                                    2.127
                                                ],
                                                [
                                                    23.986,
                                                    2.247
                                                ],
                                                [
                                                    24.49,
                                                    2.247
                                                ],
                                                [
                                                    24.49,
                                                    2.825
                                                ],
                                                [
                                                    23.874,
                                                    2.825
                                                ],
                                                [
                                                    23.018,
                                                    2.562
                                                ],
                                                [
                                                    22.731,
                                                    1.698
                                                ],
                                                [
                                                    22.731,
                                                    -0.729
                                                ],
                                                [
                                                    22.199,
                                                    -0.729
                                                ],
                                                [
                                                    22.199,
                                                    -1.292
                                                ],
                                                [
                                                    22.731,
                                                    -1.292
                                                ],
                                                [
                                                    22.731,
                                                    -2.329
                                                ],
                                                [
                                                    23.415,
                                                    -2.329
                                                ],
                                                [
                                                    23.415,
                                                    -1.292
                                                ],
                                                [
                                                    24.49,
                                                    -1.292
                                                ],
                                                [
                                                    24.49,
                                                    -0.729
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.091,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.09,
                                                    0.091
                                                ],
                                                [
                                                    -0.129,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.089,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.129,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.091,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.086,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.671,
                                                    -1.961
                                                ],
                                                [
                                                    25.341,
                                                    -2.096
                                                ],
                                                [
                                                    25.205,
                                                    -2.427
                                                ],
                                                [
                                                    25.341,
                                                    -2.758
                                                ],
                                                [
                                                    25.671,
                                                    -2.893
                                                ],
                                                [
                                                    25.988,
                                                    -2.758
                                                ],
                                                [
                                                    26.122,
                                                    -2.427
                                                ],
                                                [
                                                    25.988,
                                                    -2.096
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    26.003,
                                                    -1.292
                                                ],
                                                [
                                                    26.003,
                                                    2.825
                                                ],
                                                [
                                                    25.318,
                                                    2.825
                                                ],
                                                [
                                                    25.318,
                                                    -1.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.179,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.17
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    -0.175
                                                ],
                                                [
                                                    -0.179,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.426
                                                ],
                                                [
                                                    0.189,
                                                    -0.325
                                                ],
                                                [
                                                    0.321,
                                                    -0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.387,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.175
                                                ],
                                                [
                                                    -0.176,
                                                    -0.325
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.186,
                                                    -0.326
                                                ],
                                                [
                                                    0.315,
                                                    -0.175
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.17
                                                ],
                                                [
                                                    0.186,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.426
                                                ],
                                                [
                                                    -0.186,
                                                    0.321
                                                ],
                                                [
                                                    -0.321,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.964,
                                                    2.893
                                                ],
                                                [
                                                    27.911,
                                                    2.63
                                                ],
                                                [
                                                    27.175,
                                                    1.886
                                                ],
                                                [
                                                    26.912,
                                                    0.759
                                                ],
                                                [
                                                    27.182,
                                                    -0.353
                                                ],
                                                [
                                                    27.934,
                                                    -1.097
                                                ],
                                                [
                                                    28.993,
                                                    -1.36
                                                ],
                                                [
                                                    30.053,
                                                    -1.097
                                                ],
                                                [
                                                    30.796,
                                                    -0.361
                                                ],
                                                [
                                                    31.074,
                                                    0.759
                                                ],
                                                [
                                                    30.79,
                                                    1.886
                                                ],
                                                [
                                                    30.031,
                                                    2.63
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.246,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.129,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.116
                                                ],
                                                [
                                                    0.126,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.121,
                                                    -0.23
                                                ],
                                                [
                                                    -0.206,
                                                    -0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.244,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.136,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.209,
                                                    -0.116
                                                ],
                                                [
                                                    -0.25,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.231
                                                ],
                                                [
                                                    0.205,
                                                    0.11
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.964,
                                                    2.292
                                                ],
                                                [
                                                    29.654,
                                                    2.119
                                                ],
                                                [
                                                    30.173,
                                                    1.601
                                                ],
                                                [
                                                    30.376,
                                                    0.759
                                                ],
                                                [
                                                    30.18,
                                                    -0.083
                                                ],
                                                [
                                                    29.669,
                                                    -0.593
                                                ],
                                                [
                                                    28.986,
                                                    -0.766
                                                ],
                                                [
                                                    28.294,
                                                    -0.593
                                                ],
                                                [
                                                    27.798,
                                                    -0.083
                                                ],
                                                [
                                                    27.611,
                                                    0.759
                                                ],
                                                [
                                                    27.792,
                                                    1.608
                                                ],
                                                [
                                                    28.287,
                                                    2.127
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.204,
                                                    0.215
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.231,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.411
                                                ],
                                                [
                                                    -0.207,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.235,
                                                    -0.115
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    33.98,
                                                    -1.367
                                                ],
                                                [
                                                    35.197,
                                                    -0.909
                                                ],
                                                [
                                                    35.663,
                                                    0.398
                                                ],
                                                [
                                                    35.663,
                                                    2.825
                                                ],
                                                [
                                                    34.988,
                                                    2.825
                                                ],
                                                [
                                                    34.988,
                                                    0.496
                                                ],
                                                [
                                                    34.68,
                                                    -0.443
                                                ],
                                                [
                                                    33.837,
                                                    -0.774
                                                ],
                                                [
                                                    32.973,
                                                    -0.436
                                                ],
                                                [
                                                    32.658,
                                                    0.549
                                                ],
                                                [
                                                    32.658,
                                                    2.825
                                                ],
                                                [
                                                    31.973,
                                                    2.825
                                                ],
                                                [
                                                    31.973,
                                                    -1.292
                                                ],
                                                [
                                                    32.658,
                                                    -1.292
                                                ],
                                                [
                                                    32.658,
                                                    -0.706
                                                ],
                                                [
                                                    33.206,
                                                    -1.195
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.105
                                                ],
                                                [
                                                    0.144,
                                                    0.191
                                                ],
                                                [
                                                    0.015,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.13
                                                ],
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.149,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.175
                                                ],
                                                [
                                                    0.161,
                                                    0.085
                                                ],
                                                [
                                                    0.336,
                                                    0.085
                                                ],
                                                [
                                                    0.194,
                                                    0.08
                                                ],
                                                [
                                                    0.14,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    -0.125,
                                                    0.175
                                                ],
                                                [
                                                    -0.23,
                                                    0.1
                                                ],
                                                [
                                                    -0.295,
                                                    0
                                                ],
                                                [
                                                    -0.282,
                                                    -0.231
                                                ],
                                                [
                                                    -0.019,
                                                    -0.4
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    0.13
                                                ],
                                                [
                                                    0.265,
                                                    0
                                                ],
                                                [
                                                    0.144,
                                                    -0.105
                                                ],
                                                [
                                                    0,
                                                    -0.171
                                                ],
                                                [
                                                    -0.086,
                                                    -0.09
                                                ],
                                                [
                                                    -0.13,
                                                    -0.055
                                                ],
                                                [
                                                    -0.235,
                                                    -0.065
                                                ],
                                                [
                                                    -0.186,
                                                    -0.081
                                                ],
                                                [
                                                    -0.131,
                                                    -0.155
                                                ],
                                                [
                                                    -0.004,
                                                    -0.251
                                                ],
                                                [
                                                    0.126,
                                                    -0.18
                                                ],
                                                [
                                                    0.229,
                                                    -0.105
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.315,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.11
                                                ],
                                                [
                                                    -0.146,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.02,
                                                    0.205
                                                ],
                                                [
                                                    0.177,
                                                    0.13
                                                ],
                                                [
                                                    0.262,
                                                    0
                                                ],
                                                [
                                                    0.15,
                                                    -0.116
                                                ],
                                                [
                                                    0,
                                                    -0.181
                                                ],
                                                [
                                                    -0.16,
                                                    -0.091
                                                ],
                                                [
                                                    -0.304,
                                                    -0.081
                                                ],
                                                [
                                                    -0.192,
                                                    -0.085
                                                ],
                                                [
                                                    -0.135,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    -0.211
                                                ],
                                                [
                                                    0.125,
                                                    -0.175
                                                ],
                                                [
                                                    0.231,
                                                    -0.105
                                                ],
                                                [
                                                    0.457,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.015,
                                                    -0.215
                                                ],
                                                [
                                                    -0.155,
                                                    -0.13
                                                ],
                                                [
                                                    -0.246,
                                                    0
                                                ],
                                                [
                                                    -0.147,
                                                    0.106
                                                ],
                                                [
                                                    0,
                                                    0.135
                                                ],
                                                [
                                                    0.091,
                                                    0.085
                                                ],
                                                [
                                                    0.136,
                                                    0.05
                                                ],
                                                [
                                                    0.297,
                                                    0.08
                                                ],
                                                [
                                                    0.185,
                                                    0.075
                                                ],
                                                [
                                                    0.134,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0.225
                                                ],
                                                [
                                                    -0.125,
                                                    0.181
                                                ],
                                                [
                                                    -0.226,
                                                    0.1
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    38.238,
                                                    2.893
                                                ],
                                                [
                                                    37.389,
                                                    2.735
                                                ],
                                                [
                                                    36.796,
                                                    2.284
                                                ],
                                                [
                                                    36.555,
                                                    1.616
                                                ],
                                                [
                                                    37.261,
                                                    1.616
                                                ],
                                                [
                                                    37.546,
                                                    2.119
                                                ],
                                                [
                                                    38.23,
                                                    2.314
                                                ],
                                                [
                                                    38.846,
                                                    2.142
                                                ],
                                                [
                                                    39.072,
                                                    1.706
                                                ],
                                                [
                                                    38.831,
                                                    1.308
                                                ],
                                                [
                                                    38.087,
                                                    1.045
                                                ],
                                                [
                                                    37.337,
                                                    0.804
                                                ],
                                                [
                                                    36.84,
                                                    0.436
                                                ],
                                                [
                                                    36.637,
                                                    -0.21
                                                ],
                                                [
                                                    36.826,
                                                    -0.789
                                                ],
                                                [
                                                    37.358,
                                                    -1.202
                                                ],
                                                [
                                                    38.147,
                                                    -1.36
                                                ],
                                                [
                                                    39.253,
                                                    -1.014
                                                ],
                                                [
                                                    39.703,
                                                    -0.068
                                                ],
                                                [
                                                    39.02,
                                                    -0.068
                                                ],
                                                [
                                                    38.757,
                                                    -0.586
                                                ],
                                                [
                                                    38.126,
                                                    -0.781
                                                ],
                                                [
                                                    37.54,
                                                    -0.624
                                                ],
                                                [
                                                    37.322,
                                                    -0.21
                                                ],
                                                [
                                                    37.449,
                                                    0.128
                                                ],
                                                [
                                                    37.779,
                                                    0.338
                                                ],
                                                [
                                                    38.335,
                                                    0.511
                                                ],
                                                [
                                                    39.057,
                                                    0.752
                                                ],
                                                [
                                                    39.531,
                                                    1.097
                                                ],
                                                [
                                                    39.74,
                                                    1.706
                                                ],
                                                [
                                                    39.552,
                                                    2.314
                                                ],
                                                [
                                                    39.02,
                                                    2.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.2392,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            161.975,
                                            247.117
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.276,
                                                    -0.09
                                                ],
                                                [
                                                    -0.155,
                                                    -0.125
                                                ],
                                                [
                                                    -0.091,
                                                    -0.186
                                                ],
                                                [
                                                    0,
                                                    -0.21
                                                ],
                                                [
                                                    0.136,
                                                    -0.216
                                                ],
                                                [
                                                    0.26,
                                                    -0.125
                                                ],
                                                [
                                                    0.35,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.12
                                                ],
                                                [
                                                    -0.125,
                                                    -0.2
                                                ],
                                                [
                                                    0,
                                                    -0.251
                                                ],
                                                [
                                                    0.17,
                                                    -0.205
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.191,
                                                    0.03
                                                ],
                                                [
                                                    0.16,
                                                    0.125
                                                ],
                                                [
                                                    0.095,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0.266
                                                ],
                                                [
                                                    -0.135,
                                                    0.21
                                                ],
                                                [
                                                    -0.256,
                                                    0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.117
                                                ],
                                                [
                                                    0.125,
                                                    0.201
                                                ],
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    -0.166,
                                                    0.199
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -103.477,
                                                    -0.853
                                                ],
                                                [
                                                    -102.958,
                                                    -0.62
                                                ],
                                                [
                                                    -102.582,
                                                    -0.154
                                                ],
                                                [
                                                    -102.44,
                                                    0.439
                                                ],
                                                [
                                                    -102.643,
                                                    1.161
                                                ],
                                                [
                                                    -103.236,
                                                    1.664
                                                ],
                                                [
                                                    -104.145,
                                                    1.844
                                                ],
                                                [
                                                    -106.099,
                                                    1.844
                                                ],
                                                [
                                                    -106.099,
                                                    -3.393
                                                ],
                                                [
                                                    -104.221,
                                                    -3.393
                                                ],
                                                [
                                                    -103.311,
                                                    -3.213
                                                ],
                                                [
                                                    -102.748,
                                                    -2.739
                                                ],
                                                [
                                                    -102.56,
                                                    -2.062
                                                ],
                                                [
                                                    -102.815,
                                                    -1.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.175,
                                                    0.151
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    0.176,
                                                    0.15
                                                ],
                                                [
                                                    0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.321,
                                                    0
                                                ],
                                                [
                                                    0.176,
                                                    -0.15
                                                ],
                                                [
                                                    0,
                                                    -0.265
                                                ],
                                                [
                                                    -0.175,
                                                    -0.15
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -105.415,
                                                    -1.131
                                                ],
                                                [
                                                    -104.266,
                                                    -1.131
                                                ],
                                                [
                                                    -103.522,
                                                    -1.357
                                                ],
                                                [
                                                    -103.259,
                                                    -1.98
                                                ],
                                                [
                                                    -103.522,
                                                    -2.604
                                                ],
                                                [
                                                    -104.281,
                                                    -2.829
                                                ],
                                                [
                                                    -105.415,
                                                    -2.829
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.19,
                                                    0.161
                                                ],
                                                [
                                                    0,
                                                    0.286
                                                ],
                                                [
                                                    0.2,
                                                    0.166
                                                ],
                                                [
                                                    0.336,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.341,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    -0.2,
                                                    -0.17
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -104.206,
                                                    1.281
                                                ],
                                                [
                                                    -103.409,
                                                    1.04
                                                ],
                                                [
                                                    -103.124,
                                                    0.372
                                                ],
                                                [
                                                    -103.424,
                                                    -0.312
                                                ],
                                                [
                                                    -104.228,
                                                    -0.568
                                                ],
                                                [
                                                    -105.415,
                                                    -0.568
                                                ],
                                                [
                                                    -105.415,
                                                    1.281
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -97.944,
                                                    -2.273
                                                ],
                                                [
                                                    -100.424,
                                                    3.783
                                                ],
                                                [
                                                    -101.13,
                                                    3.783
                                                ],
                                                [
                                                    -100.319,
                                                    1.799
                                                ],
                                                [
                                                    -101.979,
                                                    -2.273
                                                ],
                                                [
                                                    -101.22,
                                                    -2.273
                                                ],
                                                [
                                                    -99.928,
                                                    1.063
                                                ],
                                                [
                                                    -98.651,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.296,
                                                    0
                                                ],
                                                [
                                                    0.25,
                                                    0.104
                                                ],
                                                [
                                                    0.146,
                                                    0.191
                                                ],
                                                [
                                                    0.015,
                                                    0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.13
                                                ],
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.151,
                                                    0.115
                                                ],
                                                [
                                                    0,
                                                    0.175
                                                ],
                                                [
                                                    0.16,
                                                    0.085
                                                ],
                                                [
                                                    0.335,
                                                    0.085
                                                ],
                                                [
                                                    0.196,
                                                    0.08
                                                ],
                                                [
                                                    0.141,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.265
                                                ],
                                                [
                                                    -0.125,
                                                    0.176
                                                ],
                                                [
                                                    -0.231,
                                                    0.1
                                                ],
                                                [
                                                    -0.296,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.231
                                                ],
                                                [
                                                    -0.02,
                                                    -0.4
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    0.129
                                                ],
                                                [
                                                    0.266,
                                                    0
                                                ],
                                                [
                                                    0.146,
                                                    -0.105
                                                ],
                                                [
                                                    0,
                                                    -0.171
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    -0.131,
                                                    -0.055
                                                ],
                                                [
                                                    -0.236,
                                                    -0.066
                                                ],
                                                [
                                                    -0.185,
                                                    -0.081
                                                ],
                                                [
                                                    -0.13,
                                                    -0.155
                                                ],
                                                [
                                                    -0.005,
                                                    -0.25
                                                ],
                                                [
                                                    0.125,
                                                    -0.179
                                                ],
                                                [
                                                    0.23,
                                                    -0.104
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.316,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.11
                                                ],
                                                [
                                                    -0.145,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.02,
                                                    0.205
                                                ],
                                                [
                                                    0.175,
                                                    0.13
                                                ],
                                                [
                                                    0.26,
                                                    0
                                                ],
                                                [
                                                    0.15,
                                                    -0.115
                                                ],
                                                [
                                                    0,
                                                    -0.181
                                                ],
                                                [
                                                    -0.161,
                                                    -0.091
                                                ],
                                                [
                                                    -0.306,
                                                    -0.081
                                                ],
                                                [
                                                    -0.19,
                                                    -0.086
                                                ],
                                                [
                                                    -0.135,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    -0.211
                                                ],
                                                [
                                                    0.126,
                                                    -0.175
                                                ],
                                                [
                                                    0.23,
                                                    -0.105
                                                ],
                                                [
                                                    0.456,
                                                    0
                                                ],
                                                [
                                                    0.281,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    -0.215
                                                ],
                                                [
                                                    -0.156,
                                                    -0.131
                                                ],
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.145,
                                                    0.106
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    0.09,
                                                    0.085
                                                ],
                                                [
                                                    0.135,
                                                    0.051
                                                ],
                                                [
                                                    0.295,
                                                    0.079
                                                ],
                                                [
                                                    0.185,
                                                    0.075
                                                ],
                                                [
                                                    0.136,
                                                    0.154
                                                ],
                                                [
                                                    0,
                                                    0.226
                                                ],
                                                [
                                                    -0.125,
                                                    0.181
                                                ],
                                                [
                                                    -0.226,
                                                    0.101
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -93.796,
                                                    1.912
                                                ],
                                                [
                                                    -94.645,
                                                    1.755
                                                ],
                                                [
                                                    -95.239,
                                                    1.303
                                                ],
                                                [
                                                    -95.479,
                                                    0.635
                                                ],
                                                [
                                                    -94.773,
                                                    0.635
                                                ],
                                                [
                                                    -94.487,
                                                    1.138
                                                ],
                                                [
                                                    -93.803,
                                                    1.333
                                                ],
                                                [
                                                    -93.187,
                                                    1.161
                                                ],
                                                [
                                                    -92.962,
                                                    0.725
                                                ],
                                                [
                                                    -93.202,
                                                    0.327
                                                ],
                                                [
                                                    -93.946,
                                                    0.064
                                                ],
                                                [
                                                    -94.698,
                                                    -0.176
                                                ],
                                                [
                                                    -95.194,
                                                    -0.545
                                                ],
                                                [
                                                    -95.396,
                                                    -1.191
                                                ],
                                                [
                                                    -95.209,
                                                    -1.77
                                                ],
                                                [
                                                    -94.675,
                                                    -2.183
                                                ],
                                                [
                                                    -93.886,
                                                    -2.34
                                                ],
                                                [
                                                    -92.782,
                                                    -1.995
                                                ],
                                                [
                                                    -92.331,
                                                    -1.049
                                                ],
                                                [
                                                    -93.014,
                                                    -1.049
                                                ],
                                                [
                                                    -93.277,
                                                    -1.566
                                                ],
                                                [
                                                    -93.909,
                                                    -1.762
                                                ],
                                                [
                                                    -94.495,
                                                    -1.605
                                                ],
                                                [
                                                    -94.713,
                                                    -1.191
                                                ],
                                                [
                                                    -94.585,
                                                    -0.853
                                                ],
                                                [
                                                    -94.254,
                                                    -0.643
                                                ],
                                                [
                                                    -93.698,
                                                    -0.469
                                                ],
                                                [
                                                    -92.977,
                                                    -0.229
                                                ],
                                                [
                                                    -92.504,
                                                    0.117
                                                ],
                                                [
                                                    -92.293,
                                                    0.725
                                                ],
                                                [
                                                    -92.481,
                                                    1.333
                                                ],
                                                [
                                                    -93.014,
                                                    1.762
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.126,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.091,
                                                    0.091
                                                ],
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.091,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0.126,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.085,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -90.975,
                                                    -2.941
                                                ],
                                                [
                                                    -91.305,
                                                    -3.077
                                                ],
                                                [
                                                    -91.441,
                                                    -3.408
                                                ],
                                                [
                                                    -91.305,
                                                    -3.739
                                                ],
                                                [
                                                    -90.975,
                                                    -3.874
                                                ],
                                                [
                                                    -90.659,
                                                    -3.739
                                                ],
                                                [
                                                    -90.524,
                                                    -3.408
                                                ],
                                                [
                                                    -90.659,
                                                    -3.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -90.644,
                                                    -2.273
                                                ],
                                                [
                                                    -90.644,
                                                    1.844
                                                ],
                                                [
                                                    -91.328,
                                                    1.844
                                                ],
                                                [
                                                    -91.328,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.291
                                                ],
                                                [
                                                    0.301,
                                                    -0.166
                                                ],
                                                [
                                                    0.396,
                                                    0
                                                ],
                                                [
                                                    0.361,
                                                    0.255
                                                ],
                                                [
                                                    0.065,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    -0.152
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    0.236
                                                ],
                                                [
                                                    0,
                                                    0.424
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    -0.162
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    0.179
                                                ],
                                                [
                                                    0.171,
                                                    0.325
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.295,
                                                    0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.375
                                                ],
                                                [
                                                    -0.16,
                                                    0.295
                                                ],
                                                [
                                                    -0.296,
                                                    0.166
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.25
                                                ],
                                                [
                                                    0.235,
                                                    0.154
                                                ],
                                                [
                                                    0.376,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.241
                                                ],
                                                [
                                                    -0.265,
                                                    0.159
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.295,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.171,
                                                    -0.322
                                                ],
                                                [
                                                    0.301,
                                                    -0.176
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -87.781,
                                                    -2.34
                                                ],
                                                [
                                                    -86.849,
                                                    -2.107
                                                ],
                                                [
                                                    -86.248,
                                                    -1.521
                                                ],
                                                [
                                                    -86.248,
                                                    -2.273
                                                ],
                                                [
                                                    -85.556,
                                                    -2.273
                                                ],
                                                [
                                                    -85.556,
                                                    1.936
                                                ],
                                                [
                                                    -85.797,
                                                    2.934
                                                ],
                                                [
                                                    -86.488,
                                                    3.626
                                                ],
                                                [
                                                    -87.525,
                                                    3.873
                                                ],
                                                [
                                                    -88.878,
                                                    3.49
                                                ],
                                                [
                                                    -89.516,
                                                    2.447
                                                ],
                                                [
                                                    -88.84,
                                                    2.447
                                                ],
                                                [
                                                    -88.374,
                                                    3.048
                                                ],
                                                [
                                                    -87.525,
                                                    3.281
                                                ],
                                                [
                                                    -86.608,
                                                    2.926
                                                ],
                                                [
                                                    -86.248,
                                                    1.936
                                                ],
                                                [
                                                    -86.248,
                                                    1.07
                                                ],
                                                [
                                                    -86.849,
                                                    1.673
                                                ],
                                                [
                                                    -87.781,
                                                    1.912
                                                ],
                                                [
                                                    -88.78,
                                                    1.643
                                                ],
                                                [
                                                    -89.479,
                                                    0.883
                                                ],
                                                [
                                                    -89.734,
                                                    -0.229
                                                ],
                                                [
                                                    -89.479,
                                                    -1.333
                                                ],
                                                [
                                                    -88.78,
                                                    -2.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.126,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.121
                                                ],
                                                [
                                                    0.126,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.126,
                                                    0.229
                                                ],
                                                [
                                                    0.21,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -86.248,
                                                    -0.221
                                                ],
                                                [
                                                    -86.436,
                                                    -1.033
                                                ],
                                                [
                                                    -86.947,
                                                    -1.559
                                                ],
                                                [
                                                    -87.645,
                                                    -1.747
                                                ],
                                                [
                                                    -88.344,
                                                    -1.566
                                                ],
                                                [
                                                    -88.848,
                                                    -1.04
                                                ],
                                                [
                                                    -89.035,
                                                    -0.229
                                                ],
                                                [
                                                    -88.848,
                                                    0.598
                                                ],
                                                [
                                                    -88.344,
                                                    1.132
                                                ],
                                                [
                                                    -87.645,
                                                    1.311
                                                ],
                                                [
                                                    -86.947,
                                                    1.132
                                                ],
                                                [
                                                    -86.436,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.28,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.206,
                                                    0.216
                                                ],
                                                [
                                                    0.355,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.412
                                                ],
                                                [
                                                    -0.205,
                                                    -0.221
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.135,
                                                    -0.211
                                                ],
                                                [
                                                    0.236,
                                                    -0.114
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -82.395,
                                                    -2.348
                                                ],
                                                [
                                                    -81.177,
                                                    -1.89
                                                ],
                                                [
                                                    -80.712,
                                                    -0.583
                                                ],
                                                [
                                                    -80.712,
                                                    1.844
                                                ],
                                                [
                                                    -81.388,
                                                    1.844
                                                ],
                                                [
                                                    -81.388,
                                                    -0.484
                                                ],
                                                [
                                                    -81.696,
                                                    -1.424
                                                ],
                                                [
                                                    -82.537,
                                                    -1.755
                                                ],
                                                [
                                                    -83.402,
                                                    -1.417
                                                ],
                                                [
                                                    -83.717,
                                                    -0.432
                                                ],
                                                [
                                                    -83.717,
                                                    1.844
                                                ],
                                                [
                                                    -84.401,
                                                    1.844
                                                ],
                                                [
                                                    -84.401,
                                                    -2.273
                                                ],
                                                [
                                                    -83.717,
                                                    -2.273
                                                ],
                                                [
                                                    -83.717,
                                                    -1.687
                                                ],
                                                [
                                                    -83.169,
                                                    -2.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.09
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.09,
                                                    0.091
                                                ],
                                                [
                                                    -0.131,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.131,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.131
                                                ],
                                                [
                                                    -0.085,
                                                    0.09
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -79.241,
                                                    -2.941
                                                ],
                                                [
                                                    -79.572,
                                                    -3.077
                                                ],
                                                [
                                                    -79.707,
                                                    -3.408
                                                ],
                                                [
                                                    -79.572,
                                                    -3.739
                                                ],
                                                [
                                                    -79.241,
                                                    -3.874
                                                ],
                                                [
                                                    -78.926,
                                                    -3.739
                                                ],
                                                [
                                                    -78.791,
                                                    -3.408
                                                ],
                                                [
                                                    -78.926,
                                                    -3.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -78.911,
                                                    -2.273
                                                ],
                                                [
                                                    -78.911,
                                                    1.844
                                                ],
                                                [
                                                    -79.595,
                                                    1.844
                                                ],
                                                [
                                                    -79.595,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.281,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.306
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.216
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.412
                                                ],
                                                [
                                                    -0.206,
                                                    -0.221
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.235,
                                                    -0.114
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -75.739,
                                                    -2.348
                                                ],
                                                [
                                                    -74.522,
                                                    -1.89
                                                ],
                                                [
                                                    -74.056,
                                                    -0.583
                                                ],
                                                [
                                                    -74.056,
                                                    1.844
                                                ],
                                                [
                                                    -74.732,
                                                    1.844
                                                ],
                                                [
                                                    -74.732,
                                                    -0.484
                                                ],
                                                [
                                                    -75.04,
                                                    -1.424
                                                ],
                                                [
                                                    -75.882,
                                                    -1.755
                                                ],
                                                [
                                                    -76.746,
                                                    -1.417
                                                ],
                                                [
                                                    -77.062,
                                                    -0.432
                                                ],
                                                [
                                                    -77.062,
                                                    1.844
                                                ],
                                                [
                                                    -77.745,
                                                    1.844
                                                ],
                                                [
                                                    -77.745,
                                                    -2.273
                                                ],
                                                [
                                                    -77.062,
                                                    -2.273
                                                ],
                                                [
                                                    -77.062,
                                                    -1.687
                                                ],
                                                [
                                                    -76.513,
                                                    -2.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.291
                                                ],
                                                [
                                                    0.301,
                                                    -0.166
                                                ],
                                                [
                                                    0.395,
                                                    0
                                                ],
                                                [
                                                    0.361,
                                                    0.255
                                                ],
                                                [
                                                    0.066,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.152
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.236
                                                ],
                                                [
                                                    0,
                                                    0.424
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    -0.162
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.375
                                                ],
                                                [
                                                    -0.161,
                                                    0.295
                                                ],
                                                [
                                                    -0.295,
                                                    0.166
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.361,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.25
                                                ],
                                                [
                                                    0.236,
                                                    0.154
                                                ],
                                                [
                                                    0.375,
                                                    0
                                                ],
                                                [
                                                    0.241,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.241
                                                ],
                                                [
                                                    -0.266,
                                                    0.159
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.3,
                                                    -0.176
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -71.241,
                                                    -2.34
                                                ],
                                                [
                                                    -70.309,
                                                    -2.107
                                                ],
                                                [
                                                    -69.708,
                                                    -1.521
                                                ],
                                                [
                                                    -69.708,
                                                    -2.273
                                                ],
                                                [
                                                    -69.017,
                                                    -2.273
                                                ],
                                                [
                                                    -69.017,
                                                    1.936
                                                ],
                                                [
                                                    -69.257,
                                                    2.934
                                                ],
                                                [
                                                    -69.949,
                                                    3.626
                                                ],
                                                [
                                                    -70.985,
                                                    3.873
                                                ],
                                                [
                                                    -72.338,
                                                    3.49
                                                ],
                                                [
                                                    -72.977,
                                                    2.447
                                                ],
                                                [
                                                    -72.3,
                                                    2.447
                                                ],
                                                [
                                                    -71.835,
                                                    3.048
                                                ],
                                                [
                                                    -70.985,
                                                    3.281
                                                ],
                                                [
                                                    -70.069,
                                                    2.926
                                                ],
                                                [
                                                    -69.708,
                                                    1.936
                                                ],
                                                [
                                                    -69.708,
                                                    1.07
                                                ],
                                                [
                                                    -70.309,
                                                    1.673
                                                ],
                                                [
                                                    -71.241,
                                                    1.912
                                                ],
                                                [
                                                    -72.24,
                                                    1.643
                                                ],
                                                [
                                                    -72.939,
                                                    0.883
                                                ],
                                                [
                                                    -73.195,
                                                    -0.229
                                                ],
                                                [
                                                    -72.939,
                                                    -1.333
                                                ],
                                                [
                                                    -72.24,
                                                    -2.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.215,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.121
                                                ],
                                                [
                                                    0.125,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.21,
                                                    -0.127
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.125,
                                                    0.229
                                                ],
                                                [
                                                    0.211,
                                                    0.119
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.127
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -69.708,
                                                    -0.221
                                                ],
                                                [
                                                    -69.896,
                                                    -1.033
                                                ],
                                                [
                                                    -70.407,
                                                    -1.559
                                                ],
                                                [
                                                    -71.106,
                                                    -1.747
                                                ],
                                                [
                                                    -71.805,
                                                    -1.566
                                                ],
                                                [
                                                    -72.308,
                                                    -1.04
                                                ],
                                                [
                                                    -72.496,
                                                    -0.229
                                                ],
                                                [
                                                    -72.308,
                                                    0.598
                                                ],
                                                [
                                                    -71.805,
                                                    1.132
                                                ],
                                                [
                                                    -71.106,
                                                    1.311
                                                ],
                                                [
                                                    -70.407,
                                                    1.132
                                                ],
                                                [
                                                    -69.896,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.236,
                                                    -0.121
                                                ],
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    0.255,
                                                    0.129
                                                ],
                                                [
                                                    0.151,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.381
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.206,
                                                    -0.22
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.13,
                                                    0.211
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ],
                                                [
                                                    -0.321,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    -0.136
                                                ],
                                                [
                                                    -0.145,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    0.205,
                                                    0.215
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -62.206,
                                                    -2.273
                                                ],
                                                [
                                                    -62.206,
                                                    1.844
                                                ],
                                                [
                                                    -62.89,
                                                    1.844
                                                ],
                                                [
                                                    -62.89,
                                                    1.236
                                                ],
                                                [
                                                    -63.439,
                                                    1.732
                                                ],
                                                [
                                                    -64.205,
                                                    1.904
                                                ],
                                                [
                                                    -65.069,
                                                    1.71
                                                ],
                                                [
                                                    -65.678,
                                                    1.108
                                                ],
                                                [
                                                    -65.896,
                                                    0.139
                                                ],
                                                [
                                                    -65.896,
                                                    -2.273
                                                ],
                                                [
                                                    -65.219,
                                                    -2.273
                                                ],
                                                [
                                                    -65.219,
                                                    0.049
                                                ],
                                                [
                                                    -64.911,
                                                    0.988
                                                ],
                                                [
                                                    -64.07,
                                                    1.311
                                                ],
                                                [
                                                    -63.206,
                                                    0.973
                                                ],
                                                [
                                                    -62.89,
                                                    -0.012
                                                ],
                                                [
                                                    -62.89,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    0.155
                                                ],
                                                [
                                                    -0.355,
                                                    0
                                                ],
                                                [
                                                    -0.295,
                                                    -0.176
                                                ],
                                                [
                                                    -0.171,
                                                    -0.322
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0.301,
                                                    -0.181
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    0.156
                                                ],
                                                [
                                                    0.14,
                                                    0.237
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.135,
                                                    -0.235
                                                ],
                                                [
                                                    0.271,
                                                    -0.16
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    0.175
                                                ],
                                                [
                                                    0.17,
                                                    0.315
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.171,
                                                    0.325
                                                ],
                                                [
                                                    -0.295,
                                                    0.179
                                                ],
                                                [
                                                    -0.35,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.159
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -60.368,
                                                    -1.514
                                                ],
                                                [
                                                    -59.767,
                                                    -2.1
                                                ],
                                                [
                                                    -58.828,
                                                    -2.34
                                                ],
                                                [
                                                    -57.836,
                                                    -2.077
                                                ],
                                                [
                                                    -57.129,
                                                    -1.333
                                                ],
                                                [
                                                    -56.874,
                                                    -0.229
                                                ],
                                                [
                                                    -57.129,
                                                    0.883
                                                ],
                                                [
                                                    -57.836,
                                                    1.643
                                                ],
                                                [
                                                    -58.828,
                                                    1.912
                                                ],
                                                [
                                                    -59.759,
                                                    1.679
                                                ],
                                                [
                                                    -60.368,
                                                    1.085
                                                ],
                                                [
                                                    -60.368,
                                                    3.798
                                                ],
                                                [
                                                    -61.052,
                                                    3.798
                                                ],
                                                [
                                                    -61.052,
                                                    -2.273
                                                ],
                                                [
                                                    -60.368,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.126,
                                                    0.229
                                                ],
                                                [
                                                    0.216,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.126
                                                ],
                                                [
                                                    0.13,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.306
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.121
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.12
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.13,
                                                    0.229
                                                ],
                                                [
                                                    0.215,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -57.573,
                                                    -0.229
                                                ],
                                                [
                                                    -57.761,
                                                    -1.04
                                                ],
                                                [
                                                    -58.272,
                                                    -1.566
                                                ],
                                                [
                                                    -58.97,
                                                    -1.747
                                                ],
                                                [
                                                    -59.669,
                                                    -1.559
                                                ],
                                                [
                                                    -60.18,
                                                    -1.025
                                                ],
                                                [
                                                    -60.368,
                                                    -0.221
                                                ],
                                                [
                                                    -60.18,
                                                    0.598
                                                ],
                                                [
                                                    -59.669,
                                                    1.132
                                                ],
                                                [
                                                    -58.97,
                                                    1.311
                                                ],
                                                [
                                                    -58.272,
                                                    1.132
                                                ],
                                                [
                                                    -57.761,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -50.424,
                                                    -2.273
                                                ],
                                                [
                                                    -52.904,
                                                    3.783
                                                ],
                                                [
                                                    -53.61,
                                                    3.783
                                                ],
                                                [
                                                    -52.799,
                                                    1.799
                                                ],
                                                [
                                                    -54.459,
                                                    -2.273
                                                ],
                                                [
                                                    -53.7,
                                                    -2.273
                                                ],
                                                [
                                                    -52.408,
                                                    1.063
                                                ],
                                                [
                                                    -51.13,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.169
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.176
                                                ],
                                                [
                                                    -0.181,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.321,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.174
                                                ],
                                                [
                                                    -0.176,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.186,
                                                    -0.327
                                                ],
                                                [
                                                    0.315,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.169
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.185,
                                                    0.321
                                                ],
                                                [
                                                    -0.32,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -47.941,
                                                    1.912
                                                ],
                                                [
                                                    -48.993,
                                                    1.649
                                                ],
                                                [
                                                    -49.729,
                                                    0.906
                                                ],
                                                [
                                                    -49.992,
                                                    -0.221
                                                ],
                                                [
                                                    -49.722,
                                                    -1.333
                                                ],
                                                [
                                                    -48.97,
                                                    -2.077
                                                ],
                                                [
                                                    -47.911,
                                                    -2.34
                                                ],
                                                [
                                                    -46.851,
                                                    -2.077
                                                ],
                                                [
                                                    -46.107,
                                                    -1.342
                                                ],
                                                [
                                                    -45.829,
                                                    -0.221
                                                ],
                                                [
                                                    -46.115,
                                                    0.906
                                                ],
                                                [
                                                    -46.874,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.13,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.115
                                                ],
                                                [
                                                    0.126,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.12,
                                                    -0.231
                                                ],
                                                [
                                                    -0.206,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.21,
                                                    -0.115
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -47.941,
                                                    1.311
                                                ],
                                                [
                                                    -47.25,
                                                    1.138
                                                ],
                                                [
                                                    -46.731,
                                                    0.62
                                                ],
                                                [
                                                    -46.528,
                                                    -0.221
                                                ],
                                                [
                                                    -46.724,
                                                    -1.064
                                                ],
                                                [
                                                    -47.235,
                                                    -1.574
                                                ],
                                                [
                                                    -47.918,
                                                    -1.747
                                                ],
                                                [
                                                    -48.61,
                                                    -1.574
                                                ],
                                                [
                                                    -49.106,
                                                    -1.064
                                                ],
                                                [
                                                    -49.293,
                                                    -0.221
                                                ],
                                                [
                                                    -49.113,
                                                    0.628
                                                ],
                                                [
                                                    -48.617,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.236,
                                                    -0.121
                                                ],
                                                [
                                                    0.28,
                                                    0
                                                ],
                                                [
                                                    0.255,
                                                    0.129
                                                ],
                                                [
                                                    0.15,
                                                    0.266
                                                ],
                                                [
                                                    0,
                                                    0.381
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    -0.22
                                                ],
                                                [
                                                    -0.356,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    0.211
                                                ],
                                                [
                                                    -0.23,
                                                    0.116
                                                ],
                                                [
                                                    -0.321,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    -0.136
                                                ],
                                                [
                                                    -0.145,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.405
                                                ],
                                                [
                                                    0.206,
                                                    0.215
                                                ],
                                                [
                                                    0.366,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -41.279,
                                                    -2.273
                                                ],
                                                [
                                                    -41.279,
                                                    1.844
                                                ],
                                                [
                                                    -41.962,
                                                    1.844
                                                ],
                                                [
                                                    -41.962,
                                                    1.236
                                                ],
                                                [
                                                    -42.511,
                                                    1.732
                                                ],
                                                [
                                                    -43.277,
                                                    1.904
                                                ],
                                                [
                                                    -44.141,
                                                    1.71
                                                ],
                                                [
                                                    -44.75,
                                                    1.108
                                                ],
                                                [
                                                    -44.968,
                                                    0.139
                                                ],
                                                [
                                                    -44.968,
                                                    -2.273
                                                ],
                                                [
                                                    -44.292,
                                                    -2.273
                                                ],
                                                [
                                                    -44.292,
                                                    0.049
                                                ],
                                                [
                                                    -43.984,
                                                    0.988
                                                ],
                                                [
                                                    -43.142,
                                                    1.311
                                                ],
                                                [
                                                    -42.278,
                                                    0.973
                                                ],
                                                [
                                                    -41.962,
                                                    -0.012
                                                ],
                                                [
                                                    -41.962,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    -0.159
                                                ],
                                                [
                                                    0.355,
                                                    0
                                                ],
                                                [
                                                    0.296,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.301,
                                                    -0.176
                                                ],
                                                [
                                                    0.361,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.24
                                                ],
                                                [
                                                    -0.266,
                                                    0.156
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.376,
                                                    -0.229
                                                ],
                                                [
                                                    -38.121,
                                                    -1.333
                                                ],
                                                [
                                                    -37.422,
                                                    -2.077
                                                ],
                                                [
                                                    -36.423,
                                                    -2.34
                                                ],
                                                [
                                                    -35.483,
                                                    -2.107
                                                ],
                                                [
                                                    -34.89,
                                                    -1.521
                                                ],
                                                [
                                                    -34.89,
                                                    -2.273
                                                ],
                                                [
                                                    -34.199,
                                                    -2.273
                                                ],
                                                [
                                                    -34.199,
                                                    1.844
                                                ],
                                                [
                                                    -34.89,
                                                    1.844
                                                ],
                                                [
                                                    -34.89,
                                                    1.078
                                                ],
                                                [
                                                    -35.498,
                                                    1.679
                                                ],
                                                [
                                                    -36.43,
                                                    1.912
                                                ],
                                                [
                                                    -37.422,
                                                    1.643
                                                ],
                                                [
                                                    -38.121,
                                                    0.883
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.126,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.121
                                                ],
                                                [
                                                    0.126,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.256,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.126,
                                                    0.229
                                                ],
                                                [
                                                    0.21,
                                                    0.119
                                                ],
                                                [
                                                    0.255,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.126,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -34.89,
                                                    -0.221
                                                ],
                                                [
                                                    -35.078,
                                                    -1.033
                                                ],
                                                [
                                                    -35.589,
                                                    -1.559
                                                ],
                                                [
                                                    -36.287,
                                                    -1.747
                                                ],
                                                [
                                                    -36.986,
                                                    -1.566
                                                ],
                                                [
                                                    -37.49,
                                                    -1.04
                                                ],
                                                [
                                                    -37.678,
                                                    -0.229
                                                ],
                                                [
                                                    -37.49,
                                                    0.598
                                                ],
                                                [
                                                    -36.986,
                                                    1.132
                                                ],
                                                [
                                                    -36.287,
                                                    1.311
                                                ],
                                                [
                                                    -35.589,
                                                    1.132
                                                ],
                                                [
                                                    -35.078,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.291
                                                ],
                                                [
                                                    0.3,
                                                    -0.166
                                                ],
                                                [
                                                    0.395,
                                                    0
                                                ],
                                                [
                                                    0.361,
                                                    0.255
                                                ],
                                                [
                                                    0.066,
                                                    0.439
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    -0.152
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.236
                                                ],
                                                [
                                                    0,
                                                    0.424
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    -0.162
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ],
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.27,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.375
                                                ],
                                                [
                                                    -0.16,
                                                    0.295
                                                ],
                                                [
                                                    -0.296,
                                                    0.166
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.361,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.25
                                                ],
                                                [
                                                    0.235,
                                                    0.154
                                                ],
                                                [
                                                    0.375,
                                                    0
                                                ],
                                                [
                                                    0.241,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.241
                                                ],
                                                [
                                                    -0.266,
                                                    0.159
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.3,
                                                    -0.176
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.345,
                                                    -2.34
                                                ],
                                                [
                                                    -30.413,
                                                    -2.107
                                                ],
                                                [
                                                    -29.812,
                                                    -1.521
                                                ],
                                                [
                                                    -29.812,
                                                    -2.273
                                                ],
                                                [
                                                    -29.121,
                                                    -2.273
                                                ],
                                                [
                                                    -29.121,
                                                    1.936
                                                ],
                                                [
                                                    -29.361,
                                                    2.934
                                                ],
                                                [
                                                    -30.052,
                                                    3.626
                                                ],
                                                [
                                                    -31.089,
                                                    3.873
                                                ],
                                                [
                                                    -32.442,
                                                    3.49
                                                ],
                                                [
                                                    -33.081,
                                                    2.447
                                                ],
                                                [
                                                    -32.404,
                                                    2.447
                                                ],
                                                [
                                                    -31.938,
                                                    3.048
                                                ],
                                                [
                                                    -31.089,
                                                    3.281
                                                ],
                                                [
                                                    -30.173,
                                                    2.926
                                                ],
                                                [
                                                    -29.812,
                                                    1.936
                                                ],
                                                [
                                                    -29.812,
                                                    1.07
                                                ],
                                                [
                                                    -30.413,
                                                    1.673
                                                ],
                                                [
                                                    -31.345,
                                                    1.912
                                                ],
                                                [
                                                    -32.344,
                                                    1.643
                                                ],
                                                [
                                                    -33.043,
                                                    0.883
                                                ],
                                                [
                                                    -33.299,
                                                    -0.229
                                                ],
                                                [
                                                    -33.043,
                                                    -1.333
                                                ],
                                                [
                                                    -32.344,
                                                    -2.077
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.216,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.121
                                                ],
                                                [
                                                    0.125,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.211,
                                                    -0.127
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.211,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.125,
                                                    0.229
                                                ],
                                                [
                                                    0.21,
                                                    0.119
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.127
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -29.812,
                                                    -0.221
                                                ],
                                                [
                                                    -30,
                                                    -1.033
                                                ],
                                                [
                                                    -30.511,
                                                    -1.559
                                                ],
                                                [
                                                    -31.21,
                                                    -1.747
                                                ],
                                                [
                                                    -31.908,
                                                    -1.566
                                                ],
                                                [
                                                    -32.412,
                                                    -1.04
                                                ],
                                                [
                                                    -32.6,
                                                    -0.229
                                                ],
                                                [
                                                    -32.412,
                                                    0.598
                                                ],
                                                [
                                                    -31.908,
                                                    1.132
                                                ],
                                                [
                                                    -31.21,
                                                    1.311
                                                ],
                                                [
                                                    -30.511,
                                                    1.132
                                                ],
                                                [
                                                    -30,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.221,
                                                    0.129
                                                ],
                                                [
                                                    -0.321,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.831
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.12,
                                                    -0.235
                                                ],
                                                [
                                                    0.225,
                                                    -0.131
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.766,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -27.281,
                                                    -1.605
                                                ],
                                                [
                                                    -26.77,
                                                    -2.152
                                                ],
                                                [
                                                    -25.951,
                                                    -2.348
                                                ],
                                                [
                                                    -25.951,
                                                    -1.642
                                                ],
                                                [
                                                    -26.132,
                                                    -1.642
                                                ],
                                                [
                                                    -27.281,
                                                    -0.395
                                                ],
                                                [
                                                    -27.281,
                                                    1.844
                                                ],
                                                [
                                                    -27.965,
                                                    1.844
                                                ],
                                                [
                                                    -27.965,
                                                    -2.273
                                                ],
                                                [
                                                    -27.281,
                                                    -2.273
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.375
                                                ],
                                                [
                                                    0.015,
                                                    -0.146
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.251,
                                                    -0.229
                                                ],
                                                [
                                                    -0.361,
                                                    0
                                                ],
                                                [
                                                    -0.195,
                                                    0.134
                                                ],
                                                [
                                                    -0.08,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    -0.25
                                                ],
                                                [
                                                    0.491,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.175
                                                ],
                                                [
                                                    0.176,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.17,
                                                    0.321
                                                ],
                                                [
                                                    -0.306,
                                                    0.169
                                                ],
                                                [
                                                    -0.401,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    -0.171
                                                ],
                                                [
                                                    -0.16,
                                                    -0.301
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.405
                                                ],
                                                [
                                                    0.255,
                                                    0.226
                                                ],
                                                [
                                                    0.295,
                                                    0
                                                ],
                                                [
                                                    0.2,
                                                    -0.142
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.394
                                                ],
                                                [
                                                    -0.331,
                                                    0.245
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.306,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.17,
                                                    -0.319
                                                ],
                                                [
                                                    0.31,
                                                    -0.176
                                                ],
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.17
                                                ],
                                                [
                                                    0.165,
                                                    0.296
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -21.405,
                                                    -0.372
                                                ],
                                                [
                                                    -21.428,
                                                    0.042
                                                ],
                                                [
                                                    -24.719,
                                                    0.042
                                                ],
                                                [
                                                    -24.305,
                                                    0.995
                                                ],
                                                [
                                                    -23.381,
                                                    1.333
                                                ],
                                                [
                                                    -22.645,
                                                    1.132
                                                ],
                                                [
                                                    -22.224,
                                                    0.576
                                                ],
                                                [
                                                    -21.488,
                                                    0.576
                                                ],
                                                [
                                                    -22.149,
                                                    1.544
                                                ],
                                                [
                                                    -23.381,
                                                    1.912
                                                ],
                                                [
                                                    -24.433,
                                                    1.649
                                                ],
                                                [
                                                    -25.155,
                                                    0.906
                                                ],
                                                [
                                                    -25.418,
                                                    -0.221
                                                ],
                                                [
                                                    -25.162,
                                                    -1.342
                                                ],
                                                [
                                                    -24.448,
                                                    -2.077
                                                ],
                                                [
                                                    -23.381,
                                                    -2.34
                                                ],
                                                [
                                                    -22.344,
                                                    -2.085
                                                ],
                                                [
                                                    -21.653,
                                                    -1.379
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 29",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.115,
                                                    0.187
                                                ],
                                                [
                                                    0.201,
                                                    0.095
                                                ],
                                                [
                                                    0.24,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    -0.22
                                                ],
                                                [
                                                    0.035,
                                                    -0.391
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.26
                                                ],
                                                [
                                                    -0.115,
                                                    -0.19
                                                ],
                                                [
                                                    -0.195,
                                                    -0.1
                                                ],
                                                [
                                                    -0.346,
                                                    0
                                                ],
                                                [
                                                    -0.24,
                                                    0.221
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.111,
                                                    -0.515
                                                ],
                                                [
                                                    -22.284,
                                                    -1.184
                                                ],
                                                [
                                                    -22.758,
                                                    -1.612
                                                ],
                                                [
                                                    -23.411,
                                                    -1.762
                                                ],
                                                [
                                                    -24.298,
                                                    -1.432
                                                ],
                                                [
                                                    -24.711,
                                                    -0.515
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 30",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.375
                                                ],
                                                [
                                                    0.015,
                                                    -0.146
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.229
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.196,
                                                    0.134
                                                ],
                                                [
                                                    -0.08,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -0.25
                                                ],
                                                [
                                                    0.491,
                                                    0
                                                ],
                                                [
                                                    0.311,
                                                    0.175
                                                ],
                                                [
                                                    0.175,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.17,
                                                    0.321
                                                ],
                                                [
                                                    -0.305,
                                                    0.169
                                                ],
                                                [
                                                    -0.4,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    -0.171
                                                ],
                                                [
                                                    -0.161,
                                                    -0.301
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    0.405
                                                ],
                                                [
                                                    0.256,
                                                    0.226
                                                ],
                                                [
                                                    0.296,
                                                    0
                                                ],
                                                [
                                                    0.2,
                                                    -0.142
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.11,
                                                    0.394
                                                ],
                                                [
                                                    -0.331,
                                                    0.245
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.305,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.171,
                                                    -0.319
                                                ],
                                                [
                                                    0.311,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    0.17
                                                ],
                                                [
                                                    0.165,
                                                    0.296
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -16.746,
                                                    -0.372
                                                ],
                                                [
                                                    -16.768,
                                                    0.042
                                                ],
                                                [
                                                    -20.059,
                                                    0.042
                                                ],
                                                [
                                                    -19.646,
                                                    0.995
                                                ],
                                                [
                                                    -18.722,
                                                    1.333
                                                ],
                                                [
                                                    -17.985,
                                                    1.132
                                                ],
                                                [
                                                    -17.565,
                                                    0.576
                                                ],
                                                [
                                                    -16.828,
                                                    0.576
                                                ],
                                                [
                                                    -17.489,
                                                    1.544
                                                ],
                                                [
                                                    -18.722,
                                                    1.912
                                                ],
                                                [
                                                    -19.774,
                                                    1.649
                                                ],
                                                [
                                                    -20.495,
                                                    0.906
                                                ],
                                                [
                                                    -20.758,
                                                    -0.221
                                                ],
                                                [
                                                    -20.503,
                                                    -1.342
                                                ],
                                                [
                                                    -19.789,
                                                    -2.077
                                                ],
                                                [
                                                    -18.722,
                                                    -2.34
                                                ],
                                                [
                                                    -17.685,
                                                    -2.085
                                                ],
                                                [
                                                    -16.993,
                                                    -1.379
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 31",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.116,
                                                    0.187
                                                ],
                                                [
                                                    0.2,
                                                    0.095
                                                ],
                                                [
                                                    0.241,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    -0.22
                                                ],
                                                [
                                                    0.035,
                                                    -0.391
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.26
                                                ],
                                                [
                                                    -0.115,
                                                    -0.19
                                                ],
                                                [
                                                    -0.195,
                                                    -0.1
                                                ],
                                                [
                                                    -0.345,
                                                    0
                                                ],
                                                [
                                                    -0.241,
                                                    0.221
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -17.452,
                                                    -0.515
                                                ],
                                                [
                                                    -17.625,
                                                    -1.184
                                                ],
                                                [
                                                    -18.098,
                                                    -1.612
                                                ],
                                                [
                                                    -18.752,
                                                    -1.762
                                                ],
                                                [
                                                    -19.638,
                                                    -1.432
                                                ],
                                                [
                                                    -20.052,
                                                    -0.515
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 32",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.085
                                                ],
                                                [
                                                    -0.21,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.19,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.202
                                                ],
                                                [
                                                    0.085,
                                                    0.081
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0
                                                ],
                                                [
                                                    -0.19,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.006,
                                                    -1.71
                                                ],
                                                [
                                                    -13.006,
                                                    0.717
                                                ],
                                                [
                                                    -12.878,
                                                    1.146
                                                ],
                                                [
                                                    -12.435,
                                                    1.266
                                                ],
                                                [
                                                    -11.931,
                                                    1.266
                                                ],
                                                [
                                                    -11.931,
                                                    1.844
                                                ],
                                                [
                                                    -12.547,
                                                    1.844
                                                ],
                                                [
                                                    -13.404,
                                                    1.581
                                                ],
                                                [
                                                    -13.689,
                                                    0.717
                                                ],
                                                [
                                                    -13.689,
                                                    -1.71
                                                ],
                                                [
                                                    -14.223,
                                                    -1.71
                                                ],
                                                [
                                                    -14.223,
                                                    -2.273
                                                ],
                                                [
                                                    -13.689,
                                                    -2.273
                                                ],
                                                [
                                                    -13.689,
                                                    -3.31
                                                ],
                                                [
                                                    -13.006,
                                                    -3.31
                                                ],
                                                [
                                                    -13.006,
                                                    -2.273
                                                ],
                                                [
                                                    -11.931,
                                                    -2.273
                                                ],
                                                [
                                                    -11.931,
                                                    -1.71
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 33",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.169
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.176
                                                ],
                                                [
                                                    -0.181,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.321,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.386,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.186,
                                                    -0.327
                                                ],
                                                [
                                                    0.315,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.169
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.185,
                                                    0.321
                                                ],
                                                [
                                                    -0.32,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.307,
                                                    1.912
                                                ],
                                                [
                                                    -10.359,
                                                    1.649
                                                ],
                                                [
                                                    -11.095,
                                                    0.906
                                                ],
                                                [
                                                    -11.358,
                                                    -0.221
                                                ],
                                                [
                                                    -11.088,
                                                    -1.333
                                                ],
                                                [
                                                    -10.336,
                                                    -2.077
                                                ],
                                                [
                                                    -9.277,
                                                    -2.34
                                                ],
                                                [
                                                    -8.217,
                                                    -2.077
                                                ],
                                                [
                                                    -7.473,
                                                    -1.342
                                                ],
                                                [
                                                    -7.195,
                                                    -0.221
                                                ],
                                                [
                                                    -7.481,
                                                    0.906
                                                ],
                                                [
                                                    -8.24,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 34",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.13,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.115
                                                ],
                                                [
                                                    0.126,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.12,
                                                    -0.231
                                                ],
                                                [
                                                    -0.205,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.21,
                                                    -0.115
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.307,
                                                    1.311
                                                ],
                                                [
                                                    -8.616,
                                                    1.138
                                                ],
                                                [
                                                    -8.097,
                                                    0.62
                                                ],
                                                [
                                                    -7.894,
                                                    -0.221
                                                ],
                                                [
                                                    -8.09,
                                                    -1.064
                                                ],
                                                [
                                                    -8.601,
                                                    -1.574
                                                ],
                                                [
                                                    -9.284,
                                                    -1.747
                                                ],
                                                [
                                                    -9.976,
                                                    -1.574
                                                ],
                                                [
                                                    -10.472,
                                                    -1.064
                                                ],
                                                [
                                                    -10.659,
                                                    -0.221
                                                ],
                                                [
                                                    -10.479,
                                                    0.628
                                                ],
                                                [
                                                    -9.983,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 35",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.415
                                                ],
                                                [
                                                    -0.17,
                                                    0.315
                                                ],
                                                [
                                                    -0.296,
                                                    0.175
                                                ],
                                                [
                                                    -0.366,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.155
                                                ],
                                                [
                                                    -0.13,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    -0.159
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.295,
                                                    0.179
                                                ],
                                                [
                                                    0.17,
                                                    0.325
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.421
                                                ],
                                                [
                                                    0.17,
                                                    -0.322
                                                ],
                                                [
                                                    0.3,
                                                    -0.176
                                                ],
                                                [
                                                    0.361,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    0.155
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    0.24
                                                ],
                                                [
                                                    -0.265,
                                                    0.156
                                                ],
                                                [
                                                    -0.365,
                                                    0
                                                ],
                                                [
                                                    -0.296,
                                                    -0.181
                                                ],
                                                [
                                                    -0.17,
                                                    -0.326
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    77.518,
                                                    -0.229
                                                ],
                                                [
                                                    77.774,
                                                    -1.333
                                                ],
                                                [
                                                    78.473,
                                                    -2.077
                                                ],
                                                [
                                                    79.472,
                                                    -2.34
                                                ],
                                                [
                                                    80.411,
                                                    -2.107
                                                ],
                                                [
                                                    81.005,
                                                    -1.521
                                                ],
                                                [
                                                    81.005,
                                                    -2.273
                                                ],
                                                [
                                                    81.696,
                                                    -2.273
                                                ],
                                                [
                                                    81.696,
                                                    1.844
                                                ],
                                                [
                                                    81.005,
                                                    1.844
                                                ],
                                                [
                                                    81.005,
                                                    1.078
                                                ],
                                                [
                                                    80.396,
                                                    1.679
                                                ],
                                                [
                                                    79.464,
                                                    1.912
                                                ],
                                                [
                                                    78.473,
                                                    1.643
                                                ],
                                                [
                                                    77.774,
                                                    0.883
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 36",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.31
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.215,
                                                    0.12
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.121
                                                ],
                                                [
                                                    0.125,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.311
                                                ],
                                                [
                                                    -0.125,
                                                    -0.235
                                                ],
                                                [
                                                    -0.21,
                                                    -0.127
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.312
                                                ],
                                                [
                                                    -0.125,
                                                    -0.231
                                                ],
                                                [
                                                    -0.21,
                                                    -0.126
                                                ],
                                                [
                                                    -0.255,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.119
                                                ],
                                                [
                                                    -0.125,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0.316
                                                ],
                                                [
                                                    0.125,
                                                    0.229
                                                ],
                                                [
                                                    0.211,
                                                    0.119
                                                ],
                                                [
                                                    0.256,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.127
                                                ],
                                                [
                                                    0.125,
                                                    -0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    81.005,
                                                    -0.221
                                                ],
                                                [
                                                    80.817,
                                                    -1.033
                                                ],
                                                [
                                                    80.306,
                                                    -1.559
                                                ],
                                                [
                                                    79.607,
                                                    -1.747
                                                ],
                                                [
                                                    78.908,
                                                    -1.566
                                                ],
                                                [
                                                    78.405,
                                                    -1.04
                                                ],
                                                [
                                                    78.217,
                                                    -0.229
                                                ],
                                                [
                                                    78.405,
                                                    0.598
                                                ],
                                                [
                                                    78.908,
                                                    1.132
                                                ],
                                                [
                                                    79.607,
                                                    1.311
                                                ],
                                                [
                                                    80.306,
                                                    1.132
                                                ],
                                                [
                                                    80.817,
                                                    0.598
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 37",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.085
                                                ],
                                                [
                                                    -0.211,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    0.176
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.202
                                                ],
                                                [
                                                    0.086,
                                                    0.081
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.381,
                                                    0
                                                ],
                                                [
                                                    -0.19,
                                                    -0.175
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    83.686,
                                                    -1.71
                                                ],
                                                [
                                                    83.686,
                                                    0.717
                                                ],
                                                [
                                                    83.813,
                                                    1.146
                                                ],
                                                [
                                                    84.257,
                                                    1.266
                                                ],
                                                [
                                                    84.76,
                                                    1.266
                                                ],
                                                [
                                                    84.76,
                                                    1.844
                                                ],
                                                [
                                                    84.144,
                                                    1.844
                                                ],
                                                [
                                                    83.287,
                                                    1.581
                                                ],
                                                [
                                                    83.002,
                                                    0.717
                                                ],
                                                [
                                                    83.002,
                                                    -1.71
                                                ],
                                                [
                                                    82.468,
                                                    -1.71
                                                ],
                                                [
                                                    82.468,
                                                    -2.273
                                                ],
                                                [
                                                    83.002,
                                                    -2.273
                                                ],
                                                [
                                                    83.002,
                                                    -3.31
                                                ],
                                                [
                                                    83.686,
                                                    -3.31
                                                ],
                                                [
                                                    83.686,
                                                    -2.273
                                                ],
                                                [
                                                    84.76,
                                                    -2.273
                                                ],
                                                [
                                                    84.76,
                                                    -1.71
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 38",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    88.103,
                                                    1.281
                                                ],
                                                [
                                                    90.124,
                                                    1.281
                                                ],
                                                [
                                                    90.124,
                                                    1.844
                                                ],
                                                [
                                                    87.321,
                                                    1.844
                                                ],
                                                [
                                                    87.321,
                                                    1.281
                                                ],
                                                [
                                                    89.32,
                                                    -1.717
                                                ],
                                                [
                                                    87.336,
                                                    -1.717
                                                ],
                                                [
                                                    87.336,
                                                    -2.273
                                                ],
                                                [
                                                    90.109,
                                                    -2.273
                                                ],
                                                [
                                                    90.109,
                                                    -1.717
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 39",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.316,
                                                    0.169
                                                ],
                                                [
                                                    -0.39,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    -0.176
                                                ],
                                                [
                                                    -0.181,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.321,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.174
                                                ],
                                                [
                                                    -0.175,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.186,
                                                    -0.327
                                                ],
                                                [
                                                    0.315,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.169
                                                ],
                                                [
                                                    0.185,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.185,
                                                    0.321
                                                ],
                                                [
                                                    -0.32,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    92.807,
                                                    1.912
                                                ],
                                                [
                                                    91.755,
                                                    1.649
                                                ],
                                                [
                                                    91.019,
                                                    0.906
                                                ],
                                                [
                                                    90.756,
                                                    -0.221
                                                ],
                                                [
                                                    91.026,
                                                    -1.333
                                                ],
                                                [
                                                    91.778,
                                                    -2.077
                                                ],
                                                [
                                                    92.837,
                                                    -2.34
                                                ],
                                                [
                                                    93.897,
                                                    -2.077
                                                ],
                                                [
                                                    94.641,
                                                    -1.342
                                                ],
                                                [
                                                    94.919,
                                                    -0.221
                                                ],
                                                [
                                                    94.633,
                                                    0.906
                                                ],
                                                [
                                                    93.874,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 40",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.245,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    0.115
                                                ],
                                                [
                                                    -0.13,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.131,
                                                    0.231
                                                ],
                                                [
                                                    0.21,
                                                    0.11
                                                ],
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.211,
                                                    -0.115
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.12,
                                                    -0.231
                                                ],
                                                [
                                                    -0.205,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.211,
                                                    -0.115
                                                ],
                                                [
                                                    -0.251,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.126,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    92.807,
                                                    1.311
                                                ],
                                                [
                                                    93.499,
                                                    1.138
                                                ],
                                                [
                                                    94.017,
                                                    0.62
                                                ],
                                                [
                                                    94.22,
                                                    -0.221
                                                ],
                                                [
                                                    94.024,
                                                    -1.064
                                                ],
                                                [
                                                    93.514,
                                                    -1.574
                                                ],
                                                [
                                                    92.83,
                                                    -1.747
                                                ],
                                                [
                                                    92.138,
                                                    -1.574
                                                ],
                                                [
                                                    91.643,
                                                    -1.064
                                                ],
                                                [
                                                    91.455,
                                                    -0.221
                                                ],
                                                [
                                                    91.635,
                                                    0.628
                                                ],
                                                [
                                                    92.131,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 41",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.296,
                                                    0
                                                ],
                                                [
                                                    -0.25,
                                                    -0.135
                                                ],
                                                [
                                                    -0.14,
                                                    -0.265
                                                ],
                                                [
                                                    0,
                                                    -0.38
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.216
                                                ],
                                                [
                                                    0.356,
                                                    0
                                                ],
                                                [
                                                    0.215,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    -0.431
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    0.116
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.31,
                                                    0
                                                ],
                                                [
                                                    0.251,
                                                    0.131
                                                ],
                                                [
                                                    0.145,
                                                    0.265
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.412
                                                ],
                                                [
                                                    -0.206,
                                                    -0.221
                                                ],
                                                [
                                                    -0.36,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.136,
                                                    -0.211
                                                ],
                                                [
                                                    0.24,
                                                    -0.114
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    97.862,
                                                    -2.348
                                                ],
                                                [
                                                    98.703,
                                                    -2.146
                                                ],
                                                [
                                                    99.289,
                                                    -1.551
                                                ],
                                                [
                                                    99.507,
                                                    -0.583
                                                ],
                                                [
                                                    99.507,
                                                    1.844
                                                ],
                                                [
                                                    98.831,
                                                    1.844
                                                ],
                                                [
                                                    98.831,
                                                    -0.484
                                                ],
                                                [
                                                    98.523,
                                                    -1.424
                                                ],
                                                [
                                                    97.681,
                                                    -1.755
                                                ],
                                                [
                                                    96.817,
                                                    -1.417
                                                ],
                                                [
                                                    96.501,
                                                    -0.432
                                                ],
                                                [
                                                    96.501,
                                                    1.844
                                                ],
                                                [
                                                    95.818,
                                                    1.844
                                                ],
                                                [
                                                    95.818,
                                                    -3.715
                                                ],
                                                [
                                                    96.501,
                                                    -3.715
                                                ],
                                                [
                                                    96.501,
                                                    -1.687
                                                ],
                                                [
                                                    97.058,
                                                    -2.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 42",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    0.175
                                                ],
                                                [
                                                    0.18,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.18,
                                                    0.321
                                                ],
                                                [
                                                    -0.315,
                                                    0.169
                                                ],
                                                [
                                                    -0.391,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    -0.176
                                                ],
                                                [
                                                    -0.18,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.427
                                                ],
                                                [
                                                    0.19,
                                                    -0.326
                                                ],
                                                [
                                                    0.32,
                                                    -0.174
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.386,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    -0.174
                                                ],
                                                [
                                                    -0.176,
                                                    -0.326
                                                ],
                                                [
                                                    0,
                                                    -0.422
                                                ],
                                                [
                                                    0.185,
                                                    -0.327
                                                ],
                                                [
                                                    0.316,
                                                    -0.176
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    0.169
                                                ],
                                                [
                                                    0.186,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.425
                                                ],
                                                [
                                                    -0.186,
                                                    0.321
                                                ],
                                                [
                                                    -0.321,
                                                    0.175
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    102.42,
                                                    1.912
                                                ],
                                                [
                                                    101.368,
                                                    1.649
                                                ],
                                                [
                                                    100.632,
                                                    0.906
                                                ],
                                                [
                                                    100.369,
                                                    -0.221
                                                ],
                                                [
                                                    100.639,
                                                    -1.333
                                                ],
                                                [
                                                    101.39,
                                                    -2.077
                                                ],
                                                [
                                                    102.45,
                                                    -2.34
                                                ],
                                                [
                                                    103.509,
                                                    -2.077
                                                ],
                                                [
                                                    104.253,
                                                    -1.342
                                                ],
                                                [
                                                    104.531,
                                                    -0.221
                                                ],
                                                [
                                                    104.246,
                                                    0.906
                                                ],
                                                [
                                                    103.487,
                                                    1.649
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 43",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.246,
                                                    0
                                                ],
                                                [
                                                    -0.215,
                                                    0.115
                                                ],
                                                [
                                                    -0.131,
                                                    0.23
                                                ],
                                                [
                                                    0,
                                                    0.33
                                                ],
                                                [
                                                    0.13,
                                                    0.231
                                                ],
                                                [
                                                    0.211,
                                                    0.11
                                                ],
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.115
                                                ],
                                                [
                                                    0.125,
                                                    -0.23
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.121,
                                                    -0.231
                                                ],
                                                [
                                                    -0.206,
                                                    -0.115
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.245,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.115
                                                ],
                                                [
                                                    0.135,
                                                    -0.231
                                                ],
                                                [
                                                    0,
                                                    -0.332
                                                ],
                                                [
                                                    -0.13,
                                                    -0.23
                                                ],
                                                [
                                                    -0.21,
                                                    -0.115
                                                ],
                                                [
                                                    -0.25,
                                                    0
                                                ],
                                                [
                                                    -0.205,
                                                    0.11
                                                ],
                                                [
                                                    -0.125,
                                                    0.231
                                                ],
                                                [
                                                    0,
                                                    0.336
                                                ],
                                                [
                                                    0.125,
                                                    0.23
                                                ],
                                                [
                                                    0.205,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    102.42,
                                                    1.311
                                                ],
                                                [
                                                    103.111,
                                                    1.138
                                                ],
                                                [
                                                    103.63,
                                                    0.62
                                                ],
                                                [
                                                    103.832,
                                                    -0.221
                                                ],
                                                [
                                                    103.637,
                                                    -1.064
                                                ],
                                                [
                                                    103.126,
                                                    -1.574
                                                ],
                                                [
                                                    102.442,
                                                    -1.747
                                                ],
                                                [
                                                    101.751,
                                                    -1.574
                                                ],
                                                [
                                                    101.255,
                                                    -1.064
                                                ],
                                                [
                                                    101.067,
                                                    -0.221
                                                ],
                                                [
                                                    101.248,
                                                    0.628
                                                ],
                                                [
                                                    101.744,
                                                    1.146
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 44",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.089
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.091,
                                                    0.091
                                                ],
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.091
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.13,
                                                    0
                                                ],
                                                [
                                                    -0.091,
                                                    -0.091
                                                ],
                                                [
                                                    0,
                                                    -0.13
                                                ],
                                                [
                                                    0.09,
                                                    -0.09
                                                ],
                                                [
                                                    0.125,
                                                    0
                                                ],
                                                [
                                                    0.09,
                                                    0.091
                                                ],
                                                [
                                                    0,
                                                    0.13
                                                ],
                                                [
                                                    -0.085,
                                                    0.089
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    105.648,
                                                    1.889
                                                ],
                                                [
                                                    105.318,
                                                    1.755
                                                ],
                                                [
                                                    105.182,
                                                    1.424
                                                ],
                                                [
                                                    105.318,
                                                    1.093
                                                ],
                                                [
                                                    105.648,
                                                    0.958
                                                ],
                                                [
                                                    105.964,
                                                    1.093
                                                ],
                                                [
                                                    106.099,
                                                    1.424
                                                ],
                                                [
                                                    105.964,
                                                    1.755
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            126.91,
                                            248.098
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.517,
                                                    -0.263
                                                ],
                                                [
                                                    -0.253,
                                                    -0.441
                                                ],
                                                [
                                                    0,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.526
                                                ],
                                                [
                                                    0.77,
                                                    -0.188
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.751,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    0.263
                                                ],
                                                [
                                                    0.263,
                                                    0.442
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.366,
                                                    0.517
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.041,
                                                    3.508
                                                ],
                                                [
                                                    -25.295,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    -6.284
                                                ],
                                                [
                                                    -24.746,
                                                    -6.284
                                                ],
                                                [
                                                    -22.844,
                                                    -5.89
                                                ],
                                                [
                                                    -21.675,
                                                    -4.833
                                                ],
                                                [
                                                    -21.28,
                                                    -3.354
                                                ],
                                                [
                                                    -21.844,
                                                    -1.607
                                                ],
                                                [
                                                    -23.548,
                                                    -0.55
                                                ],
                                                [
                                                    -21.125,
                                                    3.508
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    0.301
                                                ],
                                                [
                                                    0,
                                                    0.508
                                                ],
                                                [
                                                    0.3,
                                                    0.282
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    -0.507
                                                ],
                                                [
                                                    -0.301,
                                                    -0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.521,
                                                    -1.691
                                                ],
                                                [
                                                    -24.746,
                                                    -1.691
                                                ],
                                                [
                                                    -23.393,
                                                    -2.142
                                                ],
                                                [
                                                    -22.928,
                                                    -3.354
                                                ],
                                                [
                                                    -23.379,
                                                    -4.537
                                                ],
                                                [
                                                    -24.746,
                                                    -4.974
                                                ],
                                                [
                                                    -26.521,
                                                    -4.974
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.751
                                                ],
                                                [
                                                    0.038,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.375
                                                ],
                                                [
                                                    -0.602,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.62,
                                                    -0.46
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.592,
                                                    0.329
                                                ],
                                                [
                                                    0.338,
                                                    0.602
                                                ],
                                                [
                                                    0,
                                                    0.799
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.583,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.573,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.376
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.714
                                                ],
                                                [
                                                    -0.611,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.582,
                                                    -0.338
                                                ],
                                                [
                                                    -0.328,
                                                    -0.61
                                                ],
                                                [
                                                    0,
                                                    -0.798
                                                ],
                                                [
                                                    0.329,
                                                    -0.611
                                                ],
                                                [
                                                    0.592,
                                                    -0.329
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.319
                                                ],
                                                [
                                                    0.32,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.111,
                                                    -0.564
                                                ],
                                                [
                                                    -12.167,
                                                    0.225
                                                ],
                                                [
                                                    -18.098,
                                                    0.225
                                                ],
                                                [
                                                    -17.408,
                                                    1.718
                                                ],
                                                [
                                                    -15.886,
                                                    2.282
                                                ],
                                                [
                                                    -14.055,
                                                    1.197
                                                ],
                                                [
                                                    -12.322,
                                                    1.197
                                                ],
                                                [
                                                    -13.604,
                                                    2.958
                                                ],
                                                [
                                                    -15.886,
                                                    3.634
                                                ],
                                                [
                                                    -17.887,
                                                    3.141
                                                ],
                                                [
                                                    -19.268,
                                                    1.732
                                                ],
                                                [
                                                    -19.761,
                                                    -0.381
                                                ],
                                                [
                                                    -19.282,
                                                    -2.48
                                                ],
                                                [
                                                    -17.915,
                                                    -3.889
                                                ],
                                                [
                                                    -15.886,
                                                    -4.382
                                                ],
                                                [
                                                    -13.928,
                                                    -3.903
                                                ],
                                                [
                                                    -12.59,
                                                    -2.551
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.357
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.01,
                                                    -0.592
                                                ],
                                                [
                                                    -0.413,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.347
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.787,
                                                    -1.071
                                                ],
                                                [
                                                    -14.421,
                                                    -2.494
                                                ],
                                                [
                                                    -15.957,
                                                    -3.03
                                                ],
                                                [
                                                    -17.38,
                                                    -2.494
                                                ],
                                                [
                                                    -18.084,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.677,
                                                    0
                                                ],
                                                [
                                                    -0.461,
                                                    -0.244
                                                ],
                                                [
                                                    -0.263,
                                                    -0.357
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    -0.554
                                                ],
                                                [
                                                    0.573,
                                                    -0.32
                                                ],
                                                [
                                                    0.789,
                                                    0
                                                ],
                                                [
                                                    0.695,
                                                    0.498
                                                ],
                                                [
                                                    0.094,
                                                    0.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    -0.245
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.752
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    -0.253
                                                ],
                                                [
                                                    0.591,
                                                    0
                                                ],
                                                [
                                                    0.563,
                                                    0.338
                                                ],
                                                [
                                                    0.328,
                                                    0.611
                                                ],
                                                [
                                                    0,
                                                    0.78
                                                ],
                                                [
                                                    -0.32,
                                                    0.601
                                                ],
                                                [
                                                    -0.554,
                                                    0.329
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    -0.301,
                                                    0.564
                                                ],
                                                [
                                                    -0.564,
                                                    0.319
                                                ],
                                                [
                                                    -1.052,
                                                    0
                                                ],
                                                [
                                                    -0.695,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.122,
                                                    0.404
                                                ],
                                                [
                                                    0.404,
                                                    0.253
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.404,
                                                    -0.394
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.273,
                                                    0.367
                                                ],
                                                [
                                                    -0.461,
                                                    0.244
                                                ],
                                                [
                                                    -0.677,
                                                    0
                                                ],
                                                [
                                                    -0.554,
                                                    -0.347
                                                ],
                                                [
                                                    -0.32,
                                                    -0.62
                                                ],
                                                [
                                                    0,
                                                    -0.78
                                                ],
                                                [
                                                    0.328,
                                                    -0.601
                                                ],
                                                [
                                                    0.563,
                                                    -0.338
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.402,
                                                    -4.382
                                                ],
                                                [
                                                    -5.81,
                                                    -4.016
                                                ],
                                                [
                                                    -4.711,
                                                    -3.128
                                                ],
                                                [
                                                    -4.711,
                                                    -4.255
                                                ],
                                                [
                                                    -3.091,
                                                    -4.255
                                                ],
                                                [
                                                    -3.091,
                                                    3.634
                                                ],
                                                [
                                                    -3.542,
                                                    5.536
                                                ],
                                                [
                                                    -4.852,
                                                    6.861
                                                ],
                                                [
                                                    -6.881,
                                                    7.34
                                                ],
                                                [
                                                    -9.502,
                                                    6.593
                                                ],
                                                [
                                                    -10.685,
                                                    4.592
                                                ],
                                                [
                                                    -9.093,
                                                    4.592
                                                ],
                                                [
                                                    -8.318,
                                                    5.565
                                                ],
                                                [
                                                    -6.881,
                                                    5.945
                                                ],
                                                [
                                                    -5.317,
                                                    5.353
                                                ],
                                                [
                                                    -4.711,
                                                    3.634
                                                ],
                                                [
                                                    -4.711,
                                                    2.338
                                                ],
                                                [
                                                    -5.824,
                                                    3.268
                                                ],
                                                [
                                                    -7.402,
                                                    3.634
                                                ],
                                                [
                                                    -9.262,
                                                    3.127
                                                ],
                                                [
                                                    -10.586,
                                                    1.69
                                                ],
                                                [
                                                    -11.065,
                                                    -0.409
                                                ],
                                                [
                                                    -10.586,
                                                    -2.48
                                                ],
                                                [
                                                    -9.262,
                                                    -3.875
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.536
                                                ],
                                                [
                                                    0.226,
                                                    0.395
                                                ],
                                                [
                                                    0.357,
                                                    0.206
                                                ],
                                                [
                                                    0.413,
                                                    0
                                                ],
                                                [
                                                    0.356,
                                                    -0.207
                                                ],
                                                [
                                                    0.225,
                                                    -0.394
                                                ],
                                                [
                                                    0,
                                                    -0.535
                                                ],
                                                [
                                                    -0.216,
                                                    -0.404
                                                ],
                                                [
                                                    -0.357,
                                                    -0.216
                                                ],
                                                [
                                                    -0.404,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.206
                                                ],
                                                [
                                                    -0.216,
                                                    0.394
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.535
                                                ],
                                                [
                                                    -0.216,
                                                    -0.394
                                                ],
                                                [
                                                    -0.357,
                                                    -0.207
                                                ],
                                                [
                                                    -0.413,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.197
                                                ],
                                                [
                                                    -0.216,
                                                    0.385
                                                ],
                                                [
                                                    0,
                                                    0.535
                                                ],
                                                [
                                                    0.225,
                                                    0.404
                                                ],
                                                [
                                                    0.366,
                                                    0.206
                                                ],
                                                [
                                                    0.413,
                                                    0
                                                ],
                                                [
                                                    0.357,
                                                    -0.207
                                                ],
                                                [
                                                    0.226,
                                                    -0.404
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.711,
                                                    -0.381
                                                ],
                                                [
                                                    -5.05,
                                                    -1.776
                                                ],
                                                [
                                                    -5.909,
                                                    -2.677
                                                ],
                                                [
                                                    -7.064,
                                                    -2.987
                                                ],
                                                [
                                                    -8.219,
                                                    -2.677
                                                ],
                                                [
                                                    -9.093,
                                                    -1.79
                                                ],
                                                [
                                                    -9.417,
                                                    -0.409
                                                ],
                                                [
                                                    -9.093,
                                                    1
                                                ],
                                                [
                                                    -8.219,
                                                    1.93
                                                ],
                                                [
                                                    -7.064,
                                                    2.24
                                                ],
                                                [
                                                    -5.909,
                                                    1.93
                                                ],
                                                [
                                                    -5.05,
                                                    1.028
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    0.197,
                                                    0.198
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.197,
                                                    0.197
                                                ],
                                                [
                                                    -0.292,
                                                    0
                                                ],
                                                [
                                                    -0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.197,
                                                    -0.197
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.292,
                                                    0
                                                ],
                                                [
                                                    -0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0.281,
                                                    0
                                                ],
                                                [
                                                    0.197,
                                                    0.197
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.197,
                                                    0.198
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.164,
                                                    -5.284
                                                ],
                                                [
                                                    -0.897,
                                                    -5.58
                                                ],
                                                [
                                                    -1.193,
                                                    -6.312
                                                ],
                                                [
                                                    -0.897,
                                                    -7.045
                                                ],
                                                [
                                                    -0.164,
                                                    -7.341
                                                ],
                                                [
                                                    0.554,
                                                    -7.045
                                                ],
                                                [
                                                    0.85,
                                                    -6.312
                                                ],
                                                [
                                                    0.554,
                                                    -5.58
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.625,
                                                    -4.255
                                                ],
                                                [
                                                    0.625,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    0.216
                                                ],
                                                [
                                                    0.282,
                                                    0.375
                                                ],
                                                [
                                                    0.018,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.282,
                                                    -0.226
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.244,
                                                    0.169
                                                ],
                                                [
                                                    0,
                                                    0.272
                                                ],
                                                [
                                                    0.282,
                                                    0.141
                                                ],
                                                [
                                                    0.601,
                                                    0.169
                                                ],
                                                [
                                                    0.366,
                                                    0.15
                                                ],
                                                [
                                                    0.272,
                                                    0.31
                                                ],
                                                [
                                                    0,
                                                    0.507
                                                ],
                                                [
                                                    -0.245,
                                                    0.338
                                                ],
                                                [
                                                    -0.451,
                                                    0.197
                                                ],
                                                [
                                                    -0.592,
                                                    0
                                                ],
                                                [
                                                    -0.536,
                                                    -0.451
                                                ],
                                                [
                                                    -0.038,
                                                    -0.771
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.254,
                                                    0.207
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.225,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.263
                                                ],
                                                [
                                                    -0.15,
                                                    -0.141
                                                ],
                                                [
                                                    -0.216,
                                                    -0.084
                                                ],
                                                [
                                                    -0.422,
                                                    -0.122
                                                ],
                                                [
                                                    -0.357,
                                                    -0.16
                                                ],
                                                [
                                                    -0.263,
                                                    -0.3
                                                ],
                                                [
                                                    -0.01,
                                                    -0.498
                                                ],
                                                [
                                                    0.245,
                                                    -0.347
                                                ],
                                                [
                                                    0.451,
                                                    -0.198
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.611,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    -0.225
                                                ],
                                                [
                                                    -0.281,
                                                    -0.385
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.328
                                                ],
                                                [
                                                    0.291,
                                                    0.216
                                                ],
                                                [
                                                    0.451,
                                                    0
                                                ],
                                                [
                                                    0.254,
                                                    -0.178
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    -0.272,
                                                    -0.141
                                                ],
                                                [
                                                    -0.583,
                                                    -0.16
                                                ],
                                                [
                                                    -0.366,
                                                    -0.15
                                                ],
                                                [
                                                    -0.263,
                                                    -0.31
                                                ],
                                                [
                                                    0,
                                                    -0.413
                                                ],
                                                [
                                                    0.244,
                                                    -0.348
                                                ],
                                                [
                                                    0.46,
                                                    -0.197
                                                ],
                                                [
                                                    0.883,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.442
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.028,
                                                    -0.348
                                                ],
                                                [
                                                    -0.253,
                                                    -0.206
                                                ],
                                                [
                                                    -0.423,
                                                    0
                                                ],
                                                [
                                                    -0.226,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.207
                                                ],
                                                [
                                                    0.15,
                                                    0.141
                                                ],
                                                [
                                                    0.216,
                                                    0.076
                                                ],
                                                [
                                                    0.564,
                                                    0.151
                                                ],
                                                [
                                                    0.366,
                                                    0.15
                                                ],
                                                [
                                                    0.263,
                                                    0.301
                                                ],
                                                [
                                                    0,
                                                    0.441
                                                ],
                                                [
                                                    -0.244,
                                                    0.348
                                                ],
                                                [
                                                    -0.442,
                                                    0.197
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.551,
                                                    3.634
                                                ],
                                                [
                                                    3.903,
                                                    3.31
                                                ],
                                                [
                                                    2.761,
                                                    2.409
                                                ],
                                                [
                                                    2.311,
                                                    1.127
                                                ],
                                                [
                                                    3.973,
                                                    1.127
                                                ],
                                                [
                                                    4.438,
                                                    1.958
                                                ],
                                                [
                                                    5.523,
                                                    2.282
                                                ],
                                                [
                                                    6.565,
                                                    2.028
                                                ],
                                                [
                                                    6.946,
                                                    1.352
                                                ],
                                                [
                                                    6.523,
                                                    0.704
                                                ],
                                                [
                                                    5.213,
                                                    0.239
                                                ],
                                                [
                                                    3.79,
                                                    -0.226
                                                ],
                                                [
                                                    2.832,
                                                    -0.916
                                                ],
                                                [
                                                    2.437,
                                                    -2.142
                                                ],
                                                [
                                                    2.804,
                                                    -3.269
                                                ],
                                                [
                                                    3.846,
                                                    -4.086
                                                ],
                                                [
                                                    5.424,
                                                    -4.382
                                                ],
                                                [
                                                    7.552,
                                                    -3.706
                                                ],
                                                [
                                                    8.425,
                                                    -1.888
                                                ],
                                                [
                                                    6.819,
                                                    -1.888
                                                ],
                                                [
                                                    6.396,
                                                    -2.72
                                                ],
                                                [
                                                    5.368,
                                                    -3.03
                                                ],
                                                [
                                                    4.396,
                                                    -2.79
                                                ],
                                                [
                                                    4.058,
                                                    -2.156
                                                ],
                                                [
                                                    4.283,
                                                    -1.635
                                                ],
                                                [
                                                    4.832,
                                                    -1.297
                                                ],
                                                [
                                                    5.79,
                                                    -1.001
                                                ],
                                                [
                                                    7.171,
                                                    -0.536
                                                ],
                                                [
                                                    8.115,
                                                    0.14
                                                ],
                                                [
                                                    8.524,
                                                    1.338
                                                ],
                                                [
                                                    8.157,
                                                    2.521
                                                ],
                                                [
                                                    7.115,
                                                    3.339
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    -0.131
                                                ],
                                                [
                                                    -0.329,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.385,
                                                    0.339
                                                ],
                                                [
                                                    0,
                                                    0.761
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0.141,
                                                    0.122
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.723,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    -0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.133,
                                                    -2.945
                                                ],
                                                [
                                                    12.133,
                                                    1.352
                                                ],
                                                [
                                                    12.33,
                                                    1.986
                                                ],
                                                [
                                                    13.035,
                                                    2.169
                                                ],
                                                [
                                                    14.021,
                                                    2.169
                                                ],
                                                [
                                                    14.021,
                                                    3.508
                                                ],
                                                [
                                                    12.753,
                                                    3.508
                                                ],
                                                [
                                                    11.09,
                                                    3
                                                ],
                                                [
                                                    10.513,
                                                    1.352
                                                ],
                                                [
                                                    10.513,
                                                    -2.945
                                                ],
                                                [
                                                    9.597,
                                                    -2.945
                                                ],
                                                [
                                                    9.597,
                                                    -4.255
                                                ],
                                                [
                                                    10.513,
                                                    -4.255
                                                ],
                                                [
                                                    10.513,
                                                    -6.185
                                                ],
                                                [
                                                    12.133,
                                                    -6.185
                                                ],
                                                [
                                                    12.133,
                                                    -4.255
                                                ],
                                                [
                                                    14.021,
                                                    -4.255
                                                ],
                                                [
                                                    14.021,
                                                    -2.945
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.751
                                                ],
                                                [
                                                    0.037,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.414,
                                                    -0.375
                                                ],
                                                [
                                                    -0.601,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.619,
                                                    -0.46
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.591,
                                                    0.329
                                                ],
                                                [
                                                    0.338,
                                                    0.602
                                                ],
                                                [
                                                    0,
                                                    0.799
                                                ],
                                                [
                                                    -0.32,
                                                    0.601
                                                ],
                                                [
                                                    -0.582,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.572,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.376
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.714
                                                ],
                                                [
                                                    -0.611,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.583,
                                                    -0.338
                                                ],
                                                [
                                                    -0.329,
                                                    -0.61
                                                ],
                                                [
                                                    0,
                                                    -0.798
                                                ],
                                                [
                                                    0.329,
                                                    -0.611
                                                ],
                                                [
                                                    0.592,
                                                    -0.329
                                                ],
                                                [
                                                    0.733,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.319
                                                ],
                                                [
                                                    0.319,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.616,
                                                    -0.564
                                                ],
                                                [
                                                    22.56,
                                                    0.225
                                                ],
                                                [
                                                    16.628,
                                                    0.225
                                                ],
                                                [
                                                    17.319,
                                                    1.718
                                                ],
                                                [
                                                    18.84,
                                                    2.282
                                                ],
                                                [
                                                    20.672,
                                                    1.197
                                                ],
                                                [
                                                    22.405,
                                                    1.197
                                                ],
                                                [
                                                    21.123,
                                                    2.958
                                                ],
                                                [
                                                    18.84,
                                                    3.634
                                                ],
                                                [
                                                    16.84,
                                                    3.141
                                                ],
                                                [
                                                    15.459,
                                                    1.732
                                                ],
                                                [
                                                    14.966,
                                                    -0.381
                                                ],
                                                [
                                                    15.445,
                                                    -2.48
                                                ],
                                                [
                                                    16.811,
                                                    -3.889
                                                ],
                                                [
                                                    18.84,
                                                    -4.382
                                                ],
                                                [
                                                    20.798,
                                                    -3.903
                                                ],
                                                [
                                                    22.137,
                                                    -2.551
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.414,
                                                    0.357
                                                ],
                                                [
                                                    0.61,
                                                    0
                                                ],
                                                [
                                                    0.394,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.009,
                                                    -0.592
                                                ],
                                                [
                                                    -0.413,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.347
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.939,
                                                    -1.071
                                                ],
                                                [
                                                    20.305,
                                                    -2.494
                                                ],
                                                [
                                                    18.77,
                                                    -3.03
                                                ],
                                                [
                                                    17.347,
                                                    -2.494
                                                ],
                                                [
                                                    16.642,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    0.216
                                                ],
                                                [
                                                    -0.535,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.328,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.234,
                                                    -0.395
                                                ],
                                                [
                                                    0.395,
                                                    -0.225
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.803,
                                                    -3.128
                                                ],
                                                [
                                                    26.732,
                                                    -4.044
                                                ],
                                                [
                                                    28.127,
                                                    -4.382
                                                ],
                                                [
                                                    28.127,
                                                    -2.72
                                                ],
                                                [
                                                    27.719,
                                                    -2.72
                                                ],
                                                [
                                                    26.282,
                                                    -2.241
                                                ],
                                                [
                                                    25.803,
                                                    -0.578
                                                ],
                                                [
                                                    25.803,
                                                    3.508
                                                ],
                                                [
                                                    24.197,
                                                    3.508
                                                ],
                                                [
                                                    24.197,
                                                    -4.255
                                                ],
                                                [
                                                    25.803,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9804,
                                            0.9804,
                                            0.9804
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.379,
                                            279.966
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -18.785
                                                ],
                                                [
                                                    108.014,
                                                    -18.785
                                                ],
                                                [
                                                    112.71,
                                                    -14.089
                                                ],
                                                [
                                                    112.71,
                                                    14.089
                                                ],
                                                [
                                                    108.014,
                                                    18.785
                                                ],
                                                [
                                                    -108.014,
                                                    18.785
                                                ],
                                                [
                                                    -112.71,
                                                    14.089
                                                ],
                                                [
                                                    -112.71,
                                                    -14.089
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0.2392,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.942,
                                            279.04
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.161,
                                                    -0.001
                                                ],
                                                [
                                                    0.104,
                                                    1.365
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.188,
                                                    -0.367
                                                ],
                                                [
                                                    0,
                                                    -0.093
                                                ],
                                                [
                                                    -0.043,
                                                    -0.083
                                                ],
                                                [
                                                    -2.254,
                                                    0
                                                ],
                                                [
                                                    -0.459,
                                                    0.118
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.39,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.253,
                                                    0.318
                                                ],
                                                [
                                                    -0.043,
                                                    0.083
                                                ],
                                                [
                                                    0,
                                                    0.093
                                                ],
                                                [
                                                    0.994,
                                                    1.942
                                                ],
                                                [
                                                    0.494,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.157,
                                                    0.031
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.001,
                                                    2.642
                                                ],
                                                [
                                                    -2.622,
                                                    0.2
                                                ],
                                                [
                                                    -4.546,
                                                    -1.287
                                                ],
                                                [
                                                    -5.219,
                                                    -0.267
                                                ],
                                                [
                                                    -5.283,
                                                    0.001
                                                ],
                                                [
                                                    -5.219,
                                                    0.268
                                                ],
                                                [
                                                    -0.001,
                                                    3.523
                                                ],
                                                [
                                                    1.428,
                                                    3.331
                                                ],
                                                [
                                                    0.477,
                                                    2.594
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.061,
                                                    0.048
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.367,
                                                    0.717
                                                ],
                                                [
                                                    0,
                                                    0.093
                                                ],
                                                [
                                                    0.043,
                                                    0.083
                                                ],
                                                [
                                                    2.256,
                                                    0
                                                ],
                                                [
                                                    0.828,
                                                    -0.453
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    0.01
                                                ],
                                                [
                                                    0.038,
                                                    -0.005
                                                ],
                                                [
                                                    0.035,
                                                    -0.019
                                                ],
                                                [
                                                    0.025,
                                                    -0.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.01,
                                                    -0.077
                                                ],
                                                [
                                                    -0.061,
                                                    -0.048
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.037,
                                                    -0.01
                                                ],
                                                [
                                                    -0.038,
                                                    0.004
                                                ],
                                                [
                                                    -0.032,
                                                    0.019
                                                ],
                                                [
                                                    -0.025,
                                                    0.03
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.01,
                                                    0.078
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.615,
                                                    -0.519
                                                ],
                                                [
                                                    0.043,
                                                    -0.083
                                                ],
                                                [
                                                    0,
                                                    -0.093
                                                ],
                                                [
                                                    -0.994,
                                                    -1.941
                                                ],
                                                [
                                                    -0.944,
                                                    0.002
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.032,
                                                    -0.023
                                                ],
                                                [
                                                    -0.037,
                                                    -0.01
                                                ],
                                                [
                                                    -0.039,
                                                    0.004
                                                ],
                                                [
                                                    -0.032,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.047,
                                                    0.062
                                                ],
                                                [
                                                    0.009,
                                                    0.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.03,
                                                    0.024
                                                ],
                                                [
                                                    0.037,
                                                    0.011
                                                ],
                                                [
                                                    0.039,
                                                    -0.005
                                                ],
                                                [
                                                    0.035,
                                                    -0.02
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    -0.062
                                                ],
                                                [
                                                    -0.009,
                                                    -0.077
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.757,
                                                    3.708
                                                ],
                                                [
                                                    3.729,
                                                    2.141
                                                ],
                                                [
                                                    5.219,
                                                    0.268
                                                ],
                                                [
                                                    5.284,
                                                    0.001
                                                ],
                                                [
                                                    5.219,
                                                    -0.267
                                                ],
                                                [
                                                    -0.001,
                                                    -3.522
                                                ],
                                                [
                                                    -2.702,
                                                    -2.83
                                                ],
                                                [
                                                    -5.036,
                                                    -4.634
                                                ],
                                                [
                                                    -5.139,
                                                    -4.685
                                                ],
                                                [
                                                    -5.253,
                                                    -4.693
                                                ],
                                                [
                                                    -5.363,
                                                    -4.657
                                                ],
                                                [
                                                    -5.449,
                                                    -4.582
                                                ],
                                                [
                                                    -5.809,
                                                    -4.119
                                                ],
                                                [
                                                    -5.868,
                                                    -3.902
                                                ],
                                                [
                                                    -5.757,
                                                    -3.707
                                                ],
                                                [
                                                    5.036,
                                                    4.635
                                                ],
                                                [
                                                    5.139,
                                                    4.686
                                                ],
                                                [
                                                    5.253,
                                                    4.695
                                                ],
                                                [
                                                    5.361,
                                                    4.659
                                                ],
                                                [
                                                    5.449,
                                                    4.584
                                                ],
                                                [
                                                    5.809,
                                                    4.12
                                                ],
                                                [
                                                    5.868,
                                                    3.903
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.002,
                                                    0.185
                                                ],
                                                [
                                                    0.119,
                                                    0.244
                                                ],
                                                [
                                                    0.217,
                                                    0.164
                                                ],
                                                [
                                                    0.268,
                                                    0.05
                                                ],
                                                [
                                                    0.261,
                                                    -0.076
                                                ],
                                                [
                                                    0,
                                                    -0.187
                                                ],
                                                [
                                                    0.017,
                                                    -0.06
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.61,
                                                    0
                                                ],
                                                [
                                                    -0.319,
                                                    -0.133
                                                ],
                                                [
                                                    -0.246,
                                                    -0.245
                                                ],
                                                [
                                                    -0.132,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.347
                                                ],
                                                [
                                                    0.157,
                                                    -0.336
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.062,
                                                    -0.176
                                                ],
                                                [
                                                    0.004,
                                                    -0.272
                                                ],
                                                [
                                                    -0.12,
                                                    -0.245
                                                ],
                                                [
                                                    -0.216,
                                                    -0.165
                                                ],
                                                [
                                                    -0.267,
                                                    -0.049
                                                ],
                                                [
                                                    0.11,
                                                    0.15
                                                ],
                                                [
                                                    -0.002,
                                                    0.062
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    -0.392
                                                ],
                                                [
                                                    0.347,
                                                    0
                                                ],
                                                [
                                                    0.321,
                                                    0.132
                                                ],
                                                [
                                                    0.245,
                                                    0.246
                                                ],
                                                [
                                                    0.133,
                                                    0.321
                                                ],
                                                [
                                                    0,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.387,
                                                    1.103
                                                ],
                                                [
                                                    1.665,
                                                    0.546
                                                ],
                                                [
                                                    1.76,
                                                    0.001
                                                ],
                                                [
                                                    1.585,
                                                    -0.784
                                                ],
                                                [
                                                    1.075,
                                                    -1.406
                                                ],
                                                [
                                                    0.339,
                                                    -1.732
                                                ],
                                                [
                                                    -0.464,
                                                    -1.691
                                                ],
                                                [
                                                    -0.294,
                                                    -1.173
                                                ],
                                                [
                                                    -0.322,
                                                    -0.99
                                                ],
                                                [
                                                    -1.673,
                                                    -2.034
                                                ],
                                                [
                                                    -0.001,
                                                    -2.641
                                                ],
                                                [
                                                    1.01,
                                                    -2.44
                                                ],
                                                [
                                                    1.868,
                                                    -1.868
                                                ],
                                                [
                                                    2.441,
                                                    -1.011
                                                ],
                                                [
                                                    2.641,
                                                    0.001
                                                ],
                                                [
                                                    2.387,
                                                    1.103
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8353,
                                            0.8275,
                                            0.8275
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            231.329,
                                            208.828
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.676
                                                ],
                                                [
                                                    0.451,
                                                    -0.436
                                                ],
                                                [
                                                    0.917,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.458,
                                                    -0.428
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.654
                                                ],
                                                [
                                                    -0.443,
                                                    0.428
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.886,
                                                    0
                                                ],
                                                [
                                                    0.466,
                                                    0.429
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.98,
                                                    -1.437
                                                ],
                                                [
                                                    -21.656,
                                                    0.198
                                                ],
                                                [
                                                    -23.696,
                                                    0.84
                                                ],
                                                [
                                                    -25.207,
                                                    0.84
                                                ],
                                                [
                                                    -25.207,
                                                    4.12
                                                ],
                                                [
                                                    -26.232,
                                                    4.12
                                                ],
                                                [
                                                    -26.232,
                                                    -3.736
                                                ],
                                                [
                                                    -23.696,
                                                    -3.736
                                                ],
                                                [
                                                    -21.679,
                                                    -3.094
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.27,
                                                    0.248
                                                ],
                                                [
                                                    0,
                                                    0.459
                                                ],
                                                [
                                                    1.112,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.571,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    -0.969
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.696,
                                                    -0.005
                                                ],
                                                [
                                                    -22.434,
                                                    -0.377
                                                ],
                                                [
                                                    -22.028,
                                                    -1.437
                                                ],
                                                [
                                                    -23.696,
                                                    -2.891
                                                ],
                                                [
                                                    -25.207,
                                                    -2.891
                                                ],
                                                [
                                                    -25.207,
                                                    -0.005
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.256,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.548,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.195,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.241
                                                ],
                                                [
                                                    0.533,
                                                    0
                                                ],
                                                [
                                                    0.443,
                                                    0.27
                                                ],
                                                [
                                                    0.255,
                                                    0.489
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.255,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.202,
                                                    0.361
                                                ],
                                                [
                                                    -0.398,
                                                    0.233
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.271
                                                ],
                                                [
                                                    -0.256,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.088,
                                                    1.009
                                                ],
                                                [
                                                    -19.705,
                                                    -0.648
                                                ],
                                                [
                                                    -18.657,
                                                    -1.764
                                                ],
                                                [
                                                    -17.158,
                                                    -2.158
                                                ],
                                                [
                                                    -15.749,
                                                    -1.809
                                                ],
                                                [
                                                    -14.859,
                                                    -0.93
                                                ],
                                                [
                                                    -14.859,
                                                    -2.057
                                                ],
                                                [
                                                    -13.822,
                                                    -2.057
                                                ],
                                                [
                                                    -13.822,
                                                    4.12
                                                ],
                                                [
                                                    -14.859,
                                                    4.12
                                                ],
                                                [
                                                    -14.859,
                                                    2.97
                                                ],
                                                [
                                                    -15.772,
                                                    3.872
                                                ],
                                                [
                                                    -17.169,
                                                    4.221
                                                ],
                                                [
                                                    -18.657,
                                                    3.816
                                                ],
                                                [
                                                    -19.705,
                                                    2.677
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.187,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.18
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.353
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.346
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.465
                                                ],
                                                [
                                                    -0.188,
                                                    -0.346
                                                ],
                                                [
                                                    -0.315,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.315,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.187,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.859,
                                                    1.02
                                                ],
                                                [
                                                    -15.14,
                                                    -0.197
                                                ],
                                                [
                                                    -15.907,
                                                    -0.986
                                                ],
                                                [
                                                    -16.955,
                                                    -1.268
                                                ],
                                                [
                                                    -18.003,
                                                    -0.997
                                                ],
                                                [
                                                    -18.758,
                                                    -0.208
                                                ],
                                                [
                                                    -19.04,
                                                    1.009
                                                ],
                                                [
                                                    -18.758,
                                                    2.249
                                                ],
                                                [
                                                    -18.003,
                                                    3.049
                                                ],
                                                [
                                                    -16.955,
                                                    3.32
                                                ],
                                                [
                                                    -15.907,
                                                    3.049
                                                ],
                                                [
                                                    -15.14,
                                                    2.249
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.444,
                                                    0
                                                ],
                                                [
                                                    0.375,
                                                    0.157
                                                ],
                                                [
                                                    0.218,
                                                    0.286
                                                ],
                                                [
                                                    0.023,
                                                    0.376
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.255,
                                                    -0.195
                                                ],
                                                [
                                                    -0.421,
                                                    0
                                                ],
                                                [
                                                    -0.225,
                                                    0.173
                                                ],
                                                [
                                                    0,
                                                    0.263
                                                ],
                                                [
                                                    0.24,
                                                    0.128
                                                ],
                                                [
                                                    0.503,
                                                    0.127
                                                ],
                                                [
                                                    0.293,
                                                    0.12
                                                ],
                                                [
                                                    0.21,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.399
                                                ],
                                                [
                                                    -0.188,
                                                    0.263
                                                ],
                                                [
                                                    -0.345,
                                                    0.15
                                                ],
                                                [
                                                    -0.443,
                                                    0
                                                ],
                                                [
                                                    -0.421,
                                                    -0.345
                                                ],
                                                [
                                                    -0.03,
                                                    -0.602
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    0.195
                                                ],
                                                [
                                                    0.398,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    -0.158
                                                ],
                                                [
                                                    0,
                                                    -0.255
                                                ],
                                                [
                                                    -0.128,
                                                    -0.136
                                                ],
                                                [
                                                    -0.196,
                                                    -0.082
                                                ],
                                                [
                                                    -0.353,
                                                    -0.097
                                                ],
                                                [
                                                    -0.278,
                                                    -0.12
                                                ],
                                                [
                                                    -0.196,
                                                    -0.233
                                                ],
                                                [
                                                    -0.007,
                                                    -0.376
                                                ],
                                                [
                                                    0.187,
                                                    -0.27
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.473,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    -0.166
                                                ],
                                                [
                                                    -0.218,
                                                    -0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.03,
                                                    0.308
                                                ],
                                                [
                                                    0.263,
                                                    0.196
                                                ],
                                                [
                                                    0.391,
                                                    0
                                                ],
                                                [
                                                    0.226,
                                                    -0.173
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    -0.241,
                                                    -0.135
                                                ],
                                                [
                                                    -0.459,
                                                    -0.121
                                                ],
                                                [
                                                    -0.286,
                                                    -0.128
                                                ],
                                                [
                                                    -0.203,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    -0.315
                                                ],
                                                [
                                                    0.188,
                                                    -0.263
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ],
                                                [
                                                    0.684,
                                                    0
                                                ],
                                                [
                                                    0.421,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.022,
                                                    -0.324
                                                ],
                                                [
                                                    -0.233,
                                                    -0.195
                                                ],
                                                [
                                                    -0.368,
                                                    0
                                                ],
                                                [
                                                    -0.218,
                                                    0.157
                                                ],
                                                [
                                                    0,
                                                    0.203
                                                ],
                                                [
                                                    0.135,
                                                    0.127
                                                ],
                                                [
                                                    0.203,
                                                    0.075
                                                ],
                                                [
                                                    0.443,
                                                    0.121
                                                ],
                                                [
                                                    0.278,
                                                    0.113
                                                ],
                                                [
                                                    0.203,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0.338
                                                ],
                                                [
                                                    -0.188,
                                                    0.271
                                                ],
                                                [
                                                    -0.338,
                                                    0.15
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -9.902,
                                                    4.221
                                                ],
                                                [
                                                    -11.175,
                                                    3.985
                                                ],
                                                [
                                                    -12.066,
                                                    3.308
                                                ],
                                                [
                                                    -12.427,
                                                    2.305
                                                ],
                                                [
                                                    -11.367,
                                                    2.305
                                                ],
                                                [
                                                    -10.939,
                                                    3.06
                                                ],
                                                [
                                                    -9.913,
                                                    3.353
                                                ],
                                                [
                                                    -8.989,
                                                    3.094
                                                ],
                                                [
                                                    -8.651,
                                                    2.441
                                                ],
                                                [
                                                    -9.011,
                                                    1.843
                                                ],
                                                [
                                                    -10.127,
                                                    1.449
                                                ],
                                                [
                                                    -11.254,
                                                    1.088
                                                ],
                                                [
                                                    -11.998,
                                                    0.536
                                                ],
                                                [
                                                    -12.303,
                                                    -0.434
                                                ],
                                                [
                                                    -12.021,
                                                    -1.301
                                                ],
                                                [
                                                    -11.221,
                                                    -1.921
                                                ],
                                                [
                                                    -10.037,
                                                    -2.158
                                                ],
                                                [
                                                    -8.38,
                                                    -1.64
                                                ],
                                                [
                                                    -7.704,
                                                    -0.219
                                                ],
                                                [
                                                    -8.73,
                                                    -0.219
                                                ],
                                                [
                                                    -9.124,
                                                    -0.997
                                                ],
                                                [
                                                    -10.071,
                                                    -1.29
                                                ],
                                                [
                                                    -10.95,
                                                    -1.053
                                                ],
                                                [
                                                    -11.277,
                                                    -0.434
                                                ],
                                                [
                                                    -11.085,
                                                    0.074
                                                ],
                                                [
                                                    -10.589,
                                                    0.389
                                                ],
                                                [
                                                    -9.755,
                                                    0.648
                                                ],
                                                [
                                                    -8.673,
                                                    1.009
                                                ],
                                                [
                                                    -7.963,
                                                    1.528
                                                ],
                                                [
                                                    -7.648,
                                                    2.441
                                                ],
                                                [
                                                    -7.929,
                                                    3.353
                                                ],
                                                [
                                                    -8.73,
                                                    3.996
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.443,
                                                    0
                                                ],
                                                [
                                                    0.376,
                                                    0.157
                                                ],
                                                [
                                                    0.218,
                                                    0.286
                                                ],
                                                [
                                                    0.023,
                                                    0.376
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    -0.195
                                                ],
                                                [
                                                    -0.421,
                                                    0
                                                ],
                                                [
                                                    -0.226,
                                                    0.173
                                                ],
                                                [
                                                    0,
                                                    0.263
                                                ],
                                                [
                                                    0.241,
                                                    0.128
                                                ],
                                                [
                                                    0.504,
                                                    0.127
                                                ],
                                                [
                                                    0.293,
                                                    0.12
                                                ],
                                                [
                                                    0.211,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.399
                                                ],
                                                [
                                                    -0.188,
                                                    0.263
                                                ],
                                                [
                                                    -0.346,
                                                    0.15
                                                ],
                                                [
                                                    -0.444,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    -0.345
                                                ],
                                                [
                                                    -0.03,
                                                    -0.602
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    0.195
                                                ],
                                                [
                                                    0.398,
                                                    0
                                                ],
                                                [
                                                    0.218,
                                                    -0.158
                                                ],
                                                [
                                                    0,
                                                    -0.255
                                                ],
                                                [
                                                    -0.127,
                                                    -0.136
                                                ],
                                                [
                                                    -0.195,
                                                    -0.082
                                                ],
                                                [
                                                    -0.353,
                                                    -0.097
                                                ],
                                                [
                                                    -0.278,
                                                    -0.12
                                                ],
                                                [
                                                    -0.195,
                                                    -0.233
                                                ],
                                                [
                                                    -0.007,
                                                    -0.376
                                                ],
                                                [
                                                    0.188,
                                                    -0.27
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.474,
                                                    0
                                                ],
                                                [
                                                    -0.375,
                                                    -0.166
                                                ],
                                                [
                                                    -0.218,
                                                    -0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.03,
                                                    0.308
                                                ],
                                                [
                                                    0.263,
                                                    0.196
                                                ],
                                                [
                                                    0.39,
                                                    0
                                                ],
                                                [
                                                    0.225,
                                                    -0.173
                                                ],
                                                [
                                                    0,
                                                    -0.271
                                                ],
                                                [
                                                    -0.24,
                                                    -0.135
                                                ],
                                                [
                                                    -0.458,
                                                    -0.121
                                                ],
                                                [
                                                    -0.285,
                                                    -0.128
                                                ],
                                                [
                                                    -0.202,
                                                    -0.248
                                                ],
                                                [
                                                    0,
                                                    -0.315
                                                ],
                                                [
                                                    0.188,
                                                    -0.263
                                                ],
                                                [
                                                    0.346,
                                                    -0.158
                                                ],
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.421,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.023,
                                                    -0.324
                                                ],
                                                [
                                                    -0.233,
                                                    -0.195
                                                ],
                                                [
                                                    -0.368,
                                                    0
                                                ],
                                                [
                                                    -0.218,
                                                    0.157
                                                ],
                                                [
                                                    0,
                                                    0.203
                                                ],
                                                [
                                                    0.136,
                                                    0.127
                                                ],
                                                [
                                                    0.203,
                                                    0.075
                                                ],
                                                [
                                                    0.444,
                                                    0.121
                                                ],
                                                [
                                                    0.278,
                                                    0.113
                                                ],
                                                [
                                                    0.203,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0.338
                                                ],
                                                [
                                                    -0.188,
                                                    0.271
                                                ],
                                                [
                                                    -0.338,
                                                    0.15
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.013,
                                                    4.221
                                                ],
                                                [
                                                    -5.287,
                                                    3.985
                                                ],
                                                [
                                                    -6.177,
                                                    3.308
                                                ],
                                                [
                                                    -6.538,
                                                    2.305
                                                ],
                                                [
                                                    -5.478,
                                                    2.305
                                                ],
                                                [
                                                    -5.05,
                                                    3.06
                                                ],
                                                [
                                                    -4.024,
                                                    3.353
                                                ],
                                                [
                                                    -3.1,
                                                    3.094
                                                ],
                                                [
                                                    -2.762,
                                                    2.441
                                                ],
                                                [
                                                    -3.123,
                                                    1.843
                                                ],
                                                [
                                                    -4.239,
                                                    1.449
                                                ],
                                                [
                                                    -5.366,
                                                    1.088
                                                ],
                                                [
                                                    -6.11,
                                                    0.536
                                                ],
                                                [
                                                    -6.414,
                                                    -0.434
                                                ],
                                                [
                                                    -6.132,
                                                    -1.301
                                                ],
                                                [
                                                    -5.332,
                                                    -1.921
                                                ],
                                                [
                                                    -4.148,
                                                    -2.158
                                                ],
                                                [
                                                    -2.492,
                                                    -1.64
                                                ],
                                                [
                                                    -1.815,
                                                    -0.219
                                                ],
                                                [
                                                    -2.841,
                                                    -0.219
                                                ],
                                                [
                                                    -3.235,
                                                    -0.997
                                                ],
                                                [
                                                    -4.182,
                                                    -1.29
                                                ],
                                                [
                                                    -5.061,
                                                    -1.053
                                                ],
                                                [
                                                    -5.388,
                                                    -0.434
                                                ],
                                                [
                                                    -5.197,
                                                    0.074
                                                ],
                                                [
                                                    -4.701,
                                                    0.389
                                                ],
                                                [
                                                    -3.867,
                                                    0.648
                                                ],
                                                [
                                                    -2.785,
                                                    1.009
                                                ],
                                                [
                                                    -2.075,
                                                    1.528
                                                ],
                                                [
                                                    -1.759,
                                                    2.441
                                                ],
                                                [
                                                    -2.041,
                                                    3.353
                                                ],
                                                [
                                                    -2.841,
                                                    3.996
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.917,
                                                    -2.057
                                                ],
                                                [
                                                    5.989,
                                                    4.12
                                                ],
                                                [
                                                    4.93,
                                                    4.12
                                                ],
                                                [
                                                    3.442,
                                                    -0.783
                                                ],
                                                [
                                                    1.954,
                                                    4.12
                                                ],
                                                [
                                                    0.895,
                                                    4.12
                                                ],
                                                [
                                                    -1.044,
                                                    -2.057
                                                ],
                                                [
                                                    0.005,
                                                    -2.057
                                                ],
                                                [
                                                    1.425,
                                                    3.128
                                                ],
                                                [
                                                    2.958,
                                                    -2.057
                                                ],
                                                [
                                                    4.006,
                                                    -2.057
                                                ],
                                                [
                                                    5.505,
                                                    3.139
                                                ],
                                                [
                                                    6.902,
                                                    -2.057
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.587,
                                                    0
                                                ],
                                                [
                                                    0.473,
                                                    0.263
                                                ],
                                                [
                                                    0.27,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.27,
                                                    0.481
                                                ],
                                                [
                                                    -0.473,
                                                    0.256
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.474,
                                                    -0.263
                                                ],
                                                [
                                                    -0.271,
                                                    -0.481
                                                ],
                                                [
                                                    0,
                                                    -0.638
                                                ],
                                                [
                                                    0.286,
                                                    -0.488
                                                ],
                                                [
                                                    0.481,
                                                    -0.263
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.578,
                                                    0
                                                ],
                                                [
                                                    -0.466,
                                                    -0.263
                                                ],
                                                [
                                                    -0.263,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.278,
                                                    -0.488
                                                ],
                                                [
                                                    0.474,
                                                    -0.263
                                                ],
                                                [
                                                    0.586,
                                                    0
                                                ],
                                                [
                                                    0.473,
                                                    0.256
                                                ],
                                                [
                                                    0.278,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.278,
                                                    0.481
                                                ],
                                                [
                                                    -0.481,
                                                    0.263
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.628,
                                                    4.221
                                                ],
                                                [
                                                    10.051,
                                                    3.827
                                                ],
                                                [
                                                    8.946,
                                                    2.711
                                                ],
                                                [
                                                    8.551,
                                                    1.02
                                                ],
                                                [
                                                    8.957,
                                                    -0.648
                                                ],
                                                [
                                                    10.084,
                                                    -1.764
                                                ],
                                                [
                                                    11.674,
                                                    -2.158
                                                ],
                                                [
                                                    13.263,
                                                    -1.764
                                                ],
                                                [
                                                    14.379,
                                                    -0.659
                                                ],
                                                [
                                                    14.796,
                                                    1.02
                                                ],
                                                [
                                                    14.367,
                                                    2.711
                                                ],
                                                [
                                                    13.229,
                                                    3.827
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.368,
                                                    0
                                                ],
                                                [
                                                    -0.323,
                                                    0.173
                                                ],
                                                [
                                                    -0.195,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.496
                                                ],
                                                [
                                                    0.196,
                                                    0.346
                                                ],
                                                [
                                                    0.316,
                                                    0.165
                                                ],
                                                [
                                                    0.368,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.173
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.496
                                                ],
                                                [
                                                    -0.18,
                                                    -0.346
                                                ],
                                                [
                                                    -0.308,
                                                    -0.173
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.369,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.172
                                                ],
                                                [
                                                    0.203,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.496
                                                ],
                                                [
                                                    -0.195,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.173
                                                ],
                                                [
                                                    -0.375,
                                                    0
                                                ],
                                                [
                                                    -0.308,
                                                    0.165
                                                ],
                                                [
                                                    -0.187,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0.504
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.308,
                                                    0.165
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.628,
                                                    3.32
                                                ],
                                                [
                                                    12.665,
                                                    3.06
                                                ],
                                                [
                                                    13.443,
                                                    2.283
                                                ],
                                                [
                                                    13.747,
                                                    1.02
                                                ],
                                                [
                                                    13.454,
                                                    -0.242
                                                ],
                                                [
                                                    12.688,
                                                    -1.008
                                                ],
                                                [
                                                    11.662,
                                                    -1.268
                                                ],
                                                [
                                                    10.625,
                                                    -1.008
                                                ],
                                                [
                                                    9.881,
                                                    -0.242
                                                ],
                                                [
                                                    9.6,
                                                    1.02
                                                ],
                                                [
                                                    9.87,
                                                    2.294
                                                ],
                                                [
                                                    10.614,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.33,
                                                    0.195
                                                ],
                                                [
                                                    -0.481,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.247
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.18,
                                                    -0.354
                                                ],
                                                [
                                                    0.338,
                                                    -0.196
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.149,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.17,
                                                    -1.053
                                                ],
                                                [
                                                    17.936,
                                                    -1.876
                                                ],
                                                [
                                                    19.165,
                                                    -2.169
                                                ],
                                                [
                                                    19.165,
                                                    -1.11
                                                ],
                                                [
                                                    18.894,
                                                    -1.11
                                                ],
                                                [
                                                    17.17,
                                                    0.761
                                                ],
                                                [
                                                    17.17,
                                                    4.12
                                                ],
                                                [
                                                    16.144,
                                                    4.12
                                                ],
                                                [
                                                    16.144,
                                                    -2.057
                                                ],
                                                [
                                                    17.17,
                                                    -2.057
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.256,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.556,
                                                    0
                                                ],
                                                [
                                                    -0.414,
                                                    -0.225
                                                ],
                                                [
                                                    -0.218,
                                                    -0.361
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    -0.241
                                                ],
                                                [
                                                    0.533,
                                                    0
                                                ],
                                                [
                                                    0.451,
                                                    0.27
                                                ],
                                                [
                                                    0.255,
                                                    0.489
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.255,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.481,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.368
                                                ],
                                                [
                                                    -0.399,
                                                    0.233
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.271
                                                ],
                                                [
                                                    -0.256,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    19.965,
                                                    1.009
                                                ],
                                                [
                                                    20.349,
                                                    -0.648
                                                ],
                                                [
                                                    21.397,
                                                    -1.764
                                                ],
                                                [
                                                    22.907,
                                                    -2.158
                                                ],
                                                [
                                                    24.249,
                                                    -1.82
                                                ],
                                                [
                                                    25.195,
                                                    -0.952
                                                ],
                                                [
                                                    25.195,
                                                    -4.221
                                                ],
                                                [
                                                    26.232,
                                                    -4.221
                                                ],
                                                [
                                                    26.232,
                                                    4.12
                                                ],
                                                [
                                                    25.195,
                                                    4.12
                                                ],
                                                [
                                                    25.195,
                                                    2.959
                                                ],
                                                [
                                                    24.294,
                                                    3.872
                                                ],
                                                [
                                                    22.896,
                                                    4.221
                                                ],
                                                [
                                                    21.397,
                                                    3.816
                                                ],
                                                [
                                                    20.349,
                                                    2.677
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.187,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.18
                                                ],
                                                [
                                                    0.187,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.353
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.346
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.465
                                                ],
                                                [
                                                    -0.188,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.187,
                                                    0.346
                                                ],
                                                [
                                                    0.315,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.187,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.195,
                                                    1.02
                                                ],
                                                [
                                                    24.914,
                                                    -0.197
                                                ],
                                                [
                                                    24.147,
                                                    -0.986
                                                ],
                                                [
                                                    23.099,
                                                    -1.268
                                                ],
                                                [
                                                    22.051,
                                                    -0.997
                                                ],
                                                [
                                                    21.296,
                                                    -0.208
                                                ],
                                                [
                                                    21.014,
                                                    1.009
                                                ],
                                                [
                                                    21.296,
                                                    2.249
                                                ],
                                                [
                                                    22.051,
                                                    3.049
                                                ],
                                                [
                                                    23.099,
                                                    3.32
                                                ],
                                                [
                                                    24.147,
                                                    3.049
                                                ],
                                                [
                                                    24.914,
                                                    2.249
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.332,
                                            182.426
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -15.85
                                                ],
                                                [
                                                    108.014,
                                                    -15.85
                                                ],
                                                [
                                                    112.123,
                                                    -11.741
                                                ],
                                                [
                                                    112.123,
                                                    11.741
                                                ],
                                                [
                                                    108.014,
                                                    15.85
                                                ],
                                                [
                                                    -108.014,
                                                    15.85
                                                ],
                                                [
                                                    -112.123,
                                                    11.741
                                                ],
                                                [
                                                    -112.123,
                                                    -11.741
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.174
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8235,
                                            0.8235,
                                            0.8235
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.943,
                                            208.829
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.88,
                                                    -2.784
                                                ],
                                                [
                                                    -14.88,
                                                    -0.158
                                                ],
                                                [
                                                    -12.017,
                                                    -0.158
                                                ],
                                                [
                                                    -12.017,
                                                    0.687
                                                ],
                                                [
                                                    -14.88,
                                                    0.687
                                                ],
                                                [
                                                    -14.88,
                                                    3.392
                                                ],
                                                [
                                                    -11.679,
                                                    3.392
                                                ],
                                                [
                                                    -11.679,
                                                    4.238
                                                ],
                                                [
                                                    -15.906,
                                                    4.238
                                                ],
                                                [
                                                    -15.906,
                                                    -3.629
                                                ],
                                                [
                                                    -11.679,
                                                    -3.629
                                                ],
                                                [
                                                    -11.679,
                                                    -2.784
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.488,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    -0.203
                                                ],
                                                [
                                                    -0.218,
                                                    -0.398
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.519,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.345
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.519,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.345
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.338,
                                                    0.173
                                                ],
                                                [
                                                    -0.413,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.196,
                                                    -0.451
                                                ],
                                                [
                                                    -0.398,
                                                    0.241
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.481,
                                                    0
                                                ],
                                                [
                                                    0.376,
                                                    0.195
                                                ],
                                                [
                                                    0.218,
                                                    0.399
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.301,
                                                    -0.331
                                                ],
                                                [
                                                    -0.533,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.339
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.301,
                                                    -0.331
                                                ],
                                                [
                                                    -0.533,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.339
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.203,
                                                    -0.323
                                                ],
                                                [
                                                    0.345,
                                                    -0.173
                                                ],
                                                [
                                                    0.519,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0.172,
                                                    -0.436
                                                ],
                                                [
                                                    0.398,
                                                    -0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.305,
                                                    -2.051
                                                ],
                                                [
                                                    1.59,
                                                    -1.747
                                                ],
                                                [
                                                    2.48,
                                                    -0.857
                                                ],
                                                [
                                                    2.807,
                                                    0.597
                                                ],
                                                [
                                                    2.807,
                                                    4.238
                                                ],
                                                [
                                                    1.793,
                                                    4.238
                                                ],
                                                [
                                                    1.793,
                                                    0.744
                                                ],
                                                [
                                                    1.331,
                                                    -0.665
                                                ],
                                                [
                                                    0.102,
                                                    -1.161
                                                ],
                                                [
                                                    -1.171,
                                                    -0.643
                                                ],
                                                [
                                                    -1.645,
                                                    0.834
                                                ],
                                                [
                                                    -1.645,
                                                    4.238
                                                ],
                                                [
                                                    -2.659,
                                                    4.238
                                                ],
                                                [
                                                    -2.659,
                                                    0.744
                                                ],
                                                [
                                                    -3.121,
                                                    -0.665
                                                ],
                                                [
                                                    -4.35,
                                                    -1.161
                                                ],
                                                [
                                                    -5.623,
                                                    -0.643
                                                ],
                                                [
                                                    -6.097,
                                                    0.834
                                                ],
                                                [
                                                    -6.097,
                                                    4.238
                                                ],
                                                [
                                                    -7.123,
                                                    4.238
                                                ],
                                                [
                                                    -7.123,
                                                    -1.939
                                                ],
                                                [
                                                    -6.097,
                                                    -1.939
                                                ],
                                                [
                                                    -6.097,
                                                    -1.048
                                                ],
                                                [
                                                    -5.285,
                                                    -1.792
                                                ],
                                                [
                                                    -4.147,
                                                    -2.051
                                                ],
                                                [
                                                    -2.772,
                                                    -1.702
                                                ],
                                                [
                                                    -1.881,
                                                    -0.676
                                                ],
                                                [
                                                    -1.025,
                                                    -1.691
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.256,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.195,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.241
                                                ],
                                                [
                                                    0.533,
                                                    0
                                                ],
                                                [
                                                    0.443,
                                                    0.271
                                                ],
                                                [
                                                    0.255,
                                                    0.488
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.255,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.361
                                                ],
                                                [
                                                    -0.398,
                                                    0.233
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.27
                                                ],
                                                [
                                                    -0.256,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.106,
                                                    1.127
                                                ],
                                                [
                                                    4.49,
                                                    -0.53
                                                ],
                                                [
                                                    5.538,
                                                    -1.646
                                                ],
                                                [
                                                    7.037,
                                                    -2.04
                                                ],
                                                [
                                                    8.446,
                                                    -1.691
                                                ],
                                                [
                                                    9.336,
                                                    -0.812
                                                ],
                                                [
                                                    9.336,
                                                    -1.939
                                                ],
                                                [
                                                    10.373,
                                                    -1.939
                                                ],
                                                [
                                                    10.373,
                                                    4.238
                                                ],
                                                [
                                                    9.336,
                                                    4.238
                                                ],
                                                [
                                                    9.336,
                                                    3.088
                                                ],
                                                [
                                                    8.423,
                                                    3.99
                                                ],
                                                [
                                                    7.026,
                                                    4.339
                                                ],
                                                [
                                                    5.538,
                                                    3.933
                                                ],
                                                [
                                                    4.49,
                                                    2.795
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.315,
                                                    -0.181
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.187,
                                                    -0.353
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.187,
                                                    0.345
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.187,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.187,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.188,
                                                    0.345
                                                ],
                                                [
                                                    0.315,
                                                    0.18
                                                ],
                                                [
                                                    0.383,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.188,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.336,
                                                    1.138
                                                ],
                                                [
                                                    9.054,
                                                    -0.079
                                                ],
                                                [
                                                    8.288,
                                                    -0.868
                                                ],
                                                [
                                                    7.24,
                                                    -1.15
                                                ],
                                                [
                                                    6.192,
                                                    -0.879
                                                ],
                                                [
                                                    5.436,
                                                    -0.09
                                                ],
                                                [
                                                    5.155,
                                                    1.127
                                                ],
                                                [
                                                    5.436,
                                                    2.367
                                                ],
                                                [
                                                    6.192,
                                                    3.167
                                                ],
                                                [
                                                    7.24,
                                                    3.438
                                                ],
                                                [
                                                    8.288,
                                                    3.167
                                                ],
                                                [
                                                    9.054,
                                                    2.367
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.188,
                                                    0
                                                ],
                                                [
                                                    0.135,
                                                    0.136
                                                ],
                                                [
                                                    0,
                                                    0.196
                                                ],
                                                [
                                                    -0.135,
                                                    0.136
                                                ],
                                                [
                                                    -0.195,
                                                    0
                                                ],
                                                [
                                                    -0.128,
                                                    -0.135
                                                ],
                                                [
                                                    0,
                                                    -0.195
                                                ],
                                                [
                                                    0.135,
                                                    -0.135
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.195,
                                                    0
                                                ],
                                                [
                                                    -0.135,
                                                    -0.135
                                                ],
                                                [
                                                    0,
                                                    -0.195
                                                ],
                                                [
                                                    0.135,
                                                    -0.135
                                                ],
                                                [
                                                    0.188,
                                                    0
                                                ],
                                                [
                                                    0.135,
                                                    0.136
                                                ],
                                                [
                                                    0,
                                                    0.196
                                                ],
                                                [
                                                    -0.128,
                                                    0.136
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.636,
                                                    -2.942
                                                ],
                                                [
                                                    12.14,
                                                    -3.145
                                                ],
                                                [
                                                    11.937,
                                                    -3.641
                                                ],
                                                [
                                                    12.14,
                                                    -4.137
                                                ],
                                                [
                                                    12.636,
                                                    -4.339
                                                ],
                                                [
                                                    13.11,
                                                    -4.137
                                                ],
                                                [
                                                    13.312,
                                                    -3.641
                                                ],
                                                [
                                                    13.11,
                                                    -3.145
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.132,
                                                    -1.939
                                                ],
                                                [
                                                    13.132,
                                                    4.238
                                                ],
                                                [
                                                    12.106,
                                                    4.238
                                                ],
                                                [
                                                    12.106,
                                                    -1.939
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.906,
                                                    -4.103
                                                ],
                                                [
                                                    15.906,
                                                    4.238
                                                ],
                                                [
                                                    14.88,
                                                    4.238
                                                ],
                                                [
                                                    14.88,
                                                    -4.103
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            37.006,
                                            125.48
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -15.85
                                                ],
                                                [
                                                    108.014,
                                                    -15.85
                                                ],
                                                [
                                                    112.123,
                                                    -11.741
                                                ],
                                                [
                                                    112.123,
                                                    11.741
                                                ],
                                                [
                                                    108.014,
                                                    15.85
                                                ],
                                                [
                                                    -108.014,
                                                    15.85
                                                ],
                                                [
                                                    -112.123,
                                                    11.741
                                                ],
                                                [
                                                    -112.123,
                                                    -11.741
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.174
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8235,
                                            0.8235,
                                            0.8235
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.943,
                                            152.001
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -10.218,
                                                    3.883
                                                ],
                                                [
                                                    -11.244,
                                                    3.883
                                                ],
                                                [
                                                    -15.369,
                                                    -2.373
                                                ],
                                                [
                                                    -15.369,
                                                    3.883
                                                ],
                                                [
                                                    -16.395,
                                                    3.883
                                                ],
                                                [
                                                    -16.395,
                                                    -3.984
                                                ],
                                                [
                                                    -15.369,
                                                    -3.984
                                                ],
                                                [
                                                    -11.244,
                                                    2.26
                                                ],
                                                [
                                                    -11.244,
                                                    -3.984
                                                ],
                                                [
                                                    -10.218,
                                                    -3.984
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    -0.255,
                                                    0.474
                                                ],
                                                [
                                                    -0.443,
                                                    0.263
                                                ],
                                                [
                                                    -0.549,
                                                    0
                                                ],
                                                [
                                                    -0.398,
                                                    -0.233
                                                ],
                                                [
                                                    -0.196,
                                                    -0.353
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.241
                                                ],
                                                [
                                                    0.534,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    0.271
                                                ],
                                                [
                                                    0.256,
                                                    0.488
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.631
                                                ],
                                                [
                                                    0.256,
                                                    -0.481
                                                ],
                                                [
                                                    0.451,
                                                    -0.263
                                                ],
                                                [
                                                    0.541,
                                                    0
                                                ],
                                                [
                                                    0.399,
                                                    0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.361
                                                ],
                                                [
                                                    -0.398,
                                                    0.233
                                                ],
                                                [
                                                    -0.548,
                                                    0
                                                ],
                                                [
                                                    -0.443,
                                                    -0.27
                                                ],
                                                [
                                                    -0.255,
                                                    -0.488
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.853,
                                                    0.772
                                                ],
                                                [
                                                    -8.47,
                                                    -0.885
                                                ],
                                                [
                                                    -7.422,
                                                    -2.001
                                                ],
                                                [
                                                    -5.922,
                                                    -2.395
                                                ],
                                                [
                                                    -4.514,
                                                    -2.046
                                                ],
                                                [
                                                    -3.623,
                                                    -1.167
                                                ],
                                                [
                                                    -3.623,
                                                    -2.294
                                                ],
                                                [
                                                    -2.586,
                                                    -2.294
                                                ],
                                                [
                                                    -2.586,
                                                    3.883
                                                ],
                                                [
                                                    -3.623,
                                                    3.883
                                                ],
                                                [
                                                    -3.623,
                                                    2.733
                                                ],
                                                [
                                                    -4.536,
                                                    3.635
                                                ],
                                                [
                                                    -5.934,
                                                    3.984
                                                ],
                                                [
                                                    -7.422,
                                                    3.578
                                                ],
                                                [
                                                    -8.47,
                                                    2.44
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.466
                                                ],
                                                [
                                                    0.188,
                                                    0.346
                                                ],
                                                [
                                                    0.323,
                                                    0.18
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.181
                                                ],
                                                [
                                                    0.188,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.353
                                                ],
                                                [
                                                    -0.315,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.466
                                                ],
                                                [
                                                    -0.188,
                                                    -0.346
                                                ],
                                                [
                                                    -0.316,
                                                    -0.188
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.315,
                                                    0.18
                                                ],
                                                [
                                                    -0.188,
                                                    0.345
                                                ],
                                                [
                                                    0,
                                                    0.473
                                                ],
                                                [
                                                    0.188,
                                                    0.345
                                                ],
                                                [
                                                    0.316,
                                                    0.18
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.188
                                                ],
                                                [
                                                    0.188,
                                                    -0.353
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.623,
                                                    0.783
                                                ],
                                                [
                                                    -3.905,
                                                    -0.434
                                                ],
                                                [
                                                    -4.671,
                                                    -1.223
                                                ],
                                                [
                                                    -5.72,
                                                    -1.505
                                                ],
                                                [
                                                    -6.768,
                                                    -1.234
                                                ],
                                                [
                                                    -7.523,
                                                    -0.445
                                                ],
                                                [
                                                    -7.805,
                                                    0.772
                                                ],
                                                [
                                                    -7.523,
                                                    2.012
                                                ],
                                                [
                                                    -6.768,
                                                    2.812
                                                ],
                                                [
                                                    -5.72,
                                                    3.083
                                                ],
                                                [
                                                    -4.671,
                                                    2.812
                                                ],
                                                [
                                                    -3.905,
                                                    2.012
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.489,
                                                    0
                                                ],
                                                [
                                                    -0.375,
                                                    -0.203
                                                ],
                                                [
                                                    -0.218,
                                                    -0.398
                                                ],
                                                [
                                                    0,
                                                    -0.571
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.518,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.308,
                                                    0.323
                                                ],
                                                [
                                                    0.518,
                                                    0
                                                ],
                                                [
                                                    0.316,
                                                    -0.346
                                                ],
                                                [
                                                    0,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.338,
                                                    0.173
                                                ],
                                                [
                                                    -0.414,
                                                    0
                                                ],
                                                [
                                                    -0.399,
                                                    -0.233
                                                ],
                                                [
                                                    -0.195,
                                                    -0.451
                                                ],
                                                [
                                                    -0.399,
                                                    0.241
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.376,
                                                    0.195
                                                ],
                                                [
                                                    0.218,
                                                    0.399
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.3,
                                                    -0.331
                                                ],
                                                [
                                                    -0.534,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.616
                                                ],
                                                [
                                                    -0.3,
                                                    -0.331
                                                ],
                                                [
                                                    -0.534,
                                                    0
                                                ],
                                                [
                                                    -0.316,
                                                    0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.203,
                                                    -0.323
                                                ],
                                                [
                                                    0.346,
                                                    -0.173
                                                ],
                                                [
                                                    0.518,
                                                    0
                                                ],
                                                [
                                                    0.398,
                                                    0.233
                                                ],
                                                [
                                                    0.173,
                                                    -0.436
                                                ],
                                                [
                                                    0.398,
                                                    -0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.575,
                                                    -2.406
                                                ],
                                                [
                                                    7.859,
                                                    -2.102
                                                ],
                                                [
                                                    8.75,
                                                    -1.212
                                                ],
                                                [
                                                    9.077,
                                                    0.242
                                                ],
                                                [
                                                    9.077,
                                                    3.883
                                                ],
                                                [
                                                    8.062,
                                                    3.883
                                                ],
                                                [
                                                    8.062,
                                                    0.389
                                                ],
                                                [
                                                    7.6,
                                                    -1.02
                                                ],
                                                [
                                                    6.372,
                                                    -1.516
                                                ],
                                                [
                                                    5.098,
                                                    -0.997
                                                ],
                                                [
                                                    4.625,
                                                    0.479
                                                ],
                                                [
                                                    4.625,
                                                    3.883
                                                ],
                                                [
                                                    3.61,
                                                    3.883
                                                ],
                                                [
                                                    3.61,
                                                    0.389
                                                ],
                                                [
                                                    3.148,
                                                    -1.02
                                                ],
                                                [
                                                    1.92,
                                                    -1.516
                                                ],
                                                [
                                                    0.646,
                                                    -0.997
                                                ],
                                                [
                                                    0.173,
                                                    0.479
                                                ],
                                                [
                                                    0.173,
                                                    3.883
                                                ],
                                                [
                                                    -0.853,
                                                    3.883
                                                ],
                                                [
                                                    -0.853,
                                                    -2.294
                                                ],
                                                [
                                                    0.173,
                                                    -2.294
                                                ],
                                                [
                                                    0.173,
                                                    -1.403
                                                ],
                                                [
                                                    0.984,
                                                    -2.147
                                                ],
                                                [
                                                    2.123,
                                                    -2.406
                                                ],
                                                [
                                                    3.498,
                                                    -2.057
                                                ],
                                                [
                                                    4.388,
                                                    -1.031
                                                ],
                                                [
                                                    5.245,
                                                    -2.046
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.564
                                                ],
                                                [
                                                    0.022,
                                                    -0.218
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    -0.345
                                                ],
                                                [
                                                    -0.541,
                                                    0
                                                ],
                                                [
                                                    -0.293,
                                                    0.203
                                                ],
                                                [
                                                    -0.12,
                                                    0.346
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.496,
                                                    -0.376
                                                ],
                                                [
                                                    0.737,
                                                    0
                                                ],
                                                [
                                                    0.466,
                                                    0.263
                                                ],
                                                [
                                                    0.263,
                                                    0.481
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.255,
                                                    0.481
                                                ],
                                                [
                                                    -0.458,
                                                    0.256
                                                ],
                                                [
                                                    -0.601,
                                                    0
                                                ],
                                                [
                                                    -0.451,
                                                    -0.255
                                                ],
                                                [
                                                    -0.241,
                                                    -0.451
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.038,
                                                    0.608
                                                ],
                                                [
                                                    0.383,
                                                    0.338
                                                ],
                                                [
                                                    0.444,
                                                    0
                                                ],
                                                [
                                                    0.301,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.166,
                                                    0.594
                                                ],
                                                [
                                                    -0.496,
                                                    0.368
                                                ],
                                                [
                                                    -0.586,
                                                    0
                                                ],
                                                [
                                                    -0.458,
                                                    -0.263
                                                ],
                                                [
                                                    -0.263,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    -0.638
                                                ],
                                                [
                                                    0.256,
                                                    -0.481
                                                ],
                                                [
                                                    0.466,
                                                    -0.263
                                                ],
                                                [
                                                    0.587,
                                                    0
                                                ],
                                                [
                                                    0.451,
                                                    0.256
                                                ],
                                                [
                                                    0.248,
                                                    0.443
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.395,
                                                    0.558
                                                ],
                                                [
                                                    16.361,
                                                    1.178
                                                ],
                                                [
                                                    11.424,
                                                    1.178
                                                ],
                                                [
                                                    12.044,
                                                    2.609
                                                ],
                                                [
                                                    13.43,
                                                    3.116
                                                ],
                                                [
                                                    14.535,
                                                    2.812
                                                ],
                                                [
                                                    15.166,
                                                    1.978
                                                ],
                                                [
                                                    16.271,
                                                    1.978
                                                ],
                                                [
                                                    15.279,
                                                    3.432
                                                ],
                                                [
                                                    13.43,
                                                    3.984
                                                ],
                                                [
                                                    11.852,
                                                    3.59
                                                ],
                                                [
                                                    10.77,
                                                    2.474
                                                ],
                                                [
                                                    10.376,
                                                    0.783
                                                ],
                                                [
                                                    10.759,
                                                    -0.896
                                                ],
                                                [
                                                    11.83,
                                                    -2.001
                                                ],
                                                [
                                                    13.43,
                                                    -2.395
                                                ],
                                                [
                                                    14.986,
                                                    -2.012
                                                ],
                                                [
                                                    16.023,
                                                    -0.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.173,
                                                    0.278
                                                ],
                                                [
                                                    0.3,
                                                    0.143
                                                ],
                                                [
                                                    0.361,
                                                    0
                                                ],
                                                [
                                                    0.369,
                                                    -0.331
                                                ],
                                                [
                                                    0.053,
                                                    -0.586
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.391
                                                ],
                                                [
                                                    -0.173,
                                                    -0.286
                                                ],
                                                [
                                                    -0.293,
                                                    -0.15
                                                ],
                                                [
                                                    -0.518,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    0.33
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.335,
                                                    0.344
                                                ],
                                                [
                                                    15.076,
                                                    -0.659
                                                ],
                                                [
                                                    14.366,
                                                    -1.302
                                                ],
                                                [
                                                    13.385,
                                                    -1.527
                                                ],
                                                [
                                                    12.055,
                                                    -1.031
                                                ],
                                                [
                                                    11.435,
                                                    0.344
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            37.495,
                                            69.019
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.269,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -15.85
                                                ],
                                                [
                                                    108.014,
                                                    -15.85
                                                ],
                                                [
                                                    112.123,
                                                    -11.741
                                                ],
                                                [
                                                    112.123,
                                                    11.741
                                                ],
                                                [
                                                    108.014,
                                                    15.85
                                                ],
                                                [
                                                    -108.014,
                                                    15.85
                                                ],
                                                [
                                                    -112.123,
                                                    11.741
                                                ],
                                                [
                                                    -112.123,
                                                    -11.741
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.174
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8235,
                                            0.8235,
                                            0.8235
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.943,
                                            95.184
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.601,
                                                    0.325
                                                ],
                                                [
                                                    0.789,
                                                    0
                                                ],
                                                [
                                                    0.676,
                                                    -0.388
                                                ],
                                                [
                                                    0.388,
                                                    -0.714
                                                ],
                                                [
                                                    0,
                                                    -0.94
                                                ],
                                                [
                                                    -0.376,
                                                    -0.726
                                                ],
                                                [
                                                    -0.676,
                                                    -0.388
                                                ],
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.726,
                                                    0.651
                                                ],
                                                [
                                                    -0.163,
                                                    1.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.588,
                                                    -0.851
                                                ],
                                                [
                                                    0.939,
                                                    -0.514
                                                ],
                                                [
                                                    1.14,
                                                    0
                                                ],
                                                [
                                                    1.014,
                                                    0.563
                                                ],
                                                [
                                                    0.601,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    1.277
                                                ],
                                                [
                                                    -0.589,
                                                    1.014
                                                ],
                                                [
                                                    -1.015,
                                                    0.564
                                                ],
                                                [
                                                    -1.214,
                                                    0
                                                ],
                                                [
                                                    -1.077,
                                                    -0.689
                                                ],
                                                [
                                                    -0.488,
                                                    -1.252
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.338,
                                                    -0.651
                                                ],
                                                [
                                                    -0.602,
                                                    -0.338
                                                ],
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.676,
                                                    0.388
                                                ],
                                                [
                                                    -0.376,
                                                    0.714
                                                ],
                                                [
                                                    0,
                                                    0.939
                                                ],
                                                [
                                                    0.388,
                                                    0.714
                                                ],
                                                [
                                                    0.676,
                                                    0.388
                                                ],
                                                [
                                                    1.165,
                                                    0
                                                ],
                                                [
                                                    0.726,
                                                    -0.652
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.137,
                                                    1.015
                                                ],
                                                [
                                                    -0.576,
                                                    0.852
                                                ],
                                                [
                                                    -0.927,
                                                    0.501
                                                ],
                                                [
                                                    -1.227,
                                                    0
                                                ],
                                                [
                                                    -1.015,
                                                    -0.576
                                                ],
                                                [
                                                    -0.589,
                                                    -1.014
                                                ],
                                                [
                                                    0,
                                                    -1.278
                                                ],
                                                [
                                                    0.601,
                                                    -1.015
                                                ],
                                                [
                                                    1.027,
                                                    -0.576
                                                ],
                                                [
                                                    1.39,
                                                    0
                                                ],
                                                [
                                                    1.09,
                                                    0.676
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -81.375,
                                                    -2.132
                                                ],
                                                [
                                                    -82.783,
                                                    -3.597
                                                ],
                                                [
                                                    -84.869,
                                                    -4.105
                                                ],
                                                [
                                                    -87.179,
                                                    -3.522
                                                ],
                                                [
                                                    -88.776,
                                                    -1.869
                                                ],
                                                [
                                                    -89.339,
                                                    0.611
                                                ],
                                                [
                                                    -88.776,
                                                    3.109
                                                ],
                                                [
                                                    -87.179,
                                                    4.762
                                                ],
                                                [
                                                    -84.869,
                                                    5.344
                                                ],
                                                [
                                                    -82.032,
                                                    4.368
                                                ],
                                                [
                                                    -80.698,
                                                    1.719
                                                ],
                                                [
                                                    -85.601,
                                                    1.719
                                                ],
                                                [
                                                    -85.601,
                                                    0.009
                                                ],
                                                [
                                                    -78.407,
                                                    0.009
                                                ],
                                                [
                                                    -78.407,
                                                    1.681
                                                ],
                                                [
                                                    -79.496,
                                                    4.48
                                                ],
                                                [
                                                    -81.769,
                                                    6.528
                                                ],
                                                [
                                                    -84.869,
                                                    7.279
                                                ],
                                                [
                                                    -88.231,
                                                    6.434
                                                ],
                                                [
                                                    -90.654,
                                                    4.048
                                                ],
                                                [
                                                    -91.537,
                                                    0.611
                                                ],
                                                [
                                                    -90.654,
                                                    -2.827
                                                ],
                                                [
                                                    -88.231,
                                                    -5.194
                                                ],
                                                [
                                                    -84.869,
                                                    -6.058
                                                ],
                                                [
                                                    -81.168,
                                                    -5.025
                                                ],
                                                [
                                                    -78.801,
                                                    -2.132
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.777,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.425,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.439,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.976,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -66.808,
                                                    1.738
                                                ],
                                                [
                                                    -66.883,
                                                    2.79
                                                ],
                                                [
                                                    -74.792,
                                                    2.79
                                                ],
                                                [
                                                    -73.871,
                                                    4.781
                                                ],
                                                [
                                                    -71.842,
                                                    5.532
                                                ],
                                                [
                                                    -69.4,
                                                    4.086
                                                ],
                                                [
                                                    -67.09,
                                                    4.086
                                                ],
                                                [
                                                    -68.799,
                                                    6.434
                                                ],
                                                [
                                                    -71.842,
                                                    7.336
                                                ],
                                                [
                                                    -74.51,
                                                    6.678
                                                ],
                                                [
                                                    -76.351,
                                                    4.8
                                                ],
                                                [
                                                    -77.008,
                                                    1.982
                                                ],
                                                [
                                                    -76.37,
                                                    -0.817
                                                ],
                                                [
                                                    -74.547,
                                                    -2.696
                                                ],
                                                [
                                                    -71.842,
                                                    -3.353
                                                ],
                                                [
                                                    -69.231,
                                                    -2.714
                                                ],
                                                [
                                                    -67.447,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.013,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.526,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -69.043,
                                                    1.061
                                                ],
                                                [
                                                    -69.889,
                                                    -0.836
                                                ],
                                                [
                                                    -71.936,
                                                    -1.55
                                                ],
                                                [
                                                    -73.834,
                                                    -0.836
                                                ],
                                                [
                                                    -74.773,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.176,
                                                    -0.176
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    0.451
                                                ],
                                                [
                                                    0,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.389
                                                ],
                                                [
                                                    0.188,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.964,
                                                    0
                                                ],
                                                [
                                                    -0.514,
                                                    -0.451
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -62.202,
                                                    -1.437
                                                ],
                                                [
                                                    -62.202,
                                                    4.292
                                                ],
                                                [
                                                    -61.939,
                                                    5.138
                                                ],
                                                [
                                                    -61,
                                                    5.382
                                                ],
                                                [
                                                    -59.685,
                                                    5.382
                                                ],
                                                [
                                                    -59.685,
                                                    7.166
                                                ],
                                                [
                                                    -61.376,
                                                    7.166
                                                ],
                                                [
                                                    -63.592,
                                                    6.49
                                                ],
                                                [
                                                    -64.362,
                                                    4.292
                                                ],
                                                [
                                                    -64.362,
                                                    -1.437
                                                ],
                                                [
                                                    -65.583,
                                                    -1.437
                                                ],
                                                [
                                                    -65.583,
                                                    -3.184
                                                ],
                                                [
                                                    -64.362,
                                                    -3.184
                                                ],
                                                [
                                                    -64.362,
                                                    -5.758
                                                ],
                                                [
                                                    -62.202,
                                                    -5.758
                                                ],
                                                [
                                                    -62.202,
                                                    -3.184
                                                ],
                                                [
                                                    -59.685,
                                                    -3.184
                                                ],
                                                [
                                                    -59.685,
                                                    -1.437
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.927,
                                                    0
                                                ],
                                                [
                                                    0.702,
                                                    0.301
                                                ],
                                                [
                                                    0.401,
                                                    0.564
                                                ],
                                                [
                                                    0,
                                                    0.751
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.388,
                                                    -0.363
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    0.35
                                                ],
                                                [
                                                    0,
                                                    0.563
                                                ],
                                                [
                                                    0.263,
                                                    0.275
                                                ],
                                                [
                                                    0.388,
                                                    0.15
                                                ],
                                                [
                                                    0.676,
                                                    0.175
                                                ],
                                                [
                                                    0.538,
                                                    0.226
                                                ],
                                                [
                                                    0.376,
                                                    0.488
                                                ],
                                                [
                                                    0,
                                                    0.814
                                                ],
                                                [
                                                    -0.375,
                                                    0.563
                                                ],
                                                [
                                                    -0.676,
                                                    0.3
                                                ],
                                                [
                                                    -0.889,
                                                    0
                                                ],
                                                [
                                                    -0.802,
                                                    -0.639
                                                ],
                                                [
                                                    -0.087,
                                                    -1.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.338
                                                ],
                                                [
                                                    0.676,
                                                    0
                                                ],
                                                [
                                                    0.388,
                                                    -0.313
                                                ],
                                                [
                                                    0,
                                                    -0.588
                                                ],
                                                [
                                                    -0.238,
                                                    -0.263
                                                ],
                                                [
                                                    -0.376,
                                                    -0.15
                                                ],
                                                [
                                                    -0.651,
                                                    -0.175
                                                ],
                                                [
                                                    -0.538,
                                                    -0.238
                                                ],
                                                [
                                                    -0.375,
                                                    -0.501
                                                ],
                                                [
                                                    0,
                                                    -0.827
                                                ],
                                                [
                                                    0.363,
                                                    -0.588
                                                ],
                                                [
                                                    0.688,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.701,
                                                    -0.313
                                                ],
                                                [
                                                    -0.401,
                                                    -0.563
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.05,
                                                    0.563
                                                ],
                                                [
                                                    0.401,
                                                    0.363
                                                ],
                                                [
                                                    0.739,
                                                    0
                                                ],
                                                [
                                                    0.414,
                                                    -0.364
                                                ],
                                                [
                                                    0,
                                                    -0.439
                                                ],
                                                [
                                                    -0.251,
                                                    -0.276
                                                ],
                                                [
                                                    -0.376,
                                                    -0.15
                                                ],
                                                [
                                                    -0.852,
                                                    -0.226
                                                ],
                                                [
                                                    -0.526,
                                                    -0.237
                                                ],
                                                [
                                                    -0.375,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    -0.751
                                                ],
                                                [
                                                    0.376,
                                                    -0.564
                                                ],
                                                [
                                                    0.676,
                                                    -0.301
                                                ],
                                                [
                                                    1.265,
                                                    0
                                                ],
                                                [
                                                    0.814,
                                                    0.626
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.037,
                                                    -0.476
                                                ],
                                                [
                                                    -0.413,
                                                    -0.338
                                                ],
                                                [
                                                    -0.614,
                                                    0
                                                ],
                                                [
                                                    -0.388,
                                                    0.313
                                                ],
                                                [
                                                    0,
                                                    0.401
                                                ],
                                                [
                                                    0.25,
                                                    0.25
                                                ],
                                                [
                                                    0.376,
                                                    0.15
                                                ],
                                                [
                                                    0.864,
                                                    0.238
                                                ],
                                                [
                                                    0.551,
                                                    0.238
                                                ],
                                                [
                                                    0.389,
                                                    0.489
                                                ],
                                                [
                                                    0,
                                                    0.664
                                                ],
                                                [
                                                    -0.351,
                                                    0.589
                                                ],
                                                [
                                                    -0.677,
                                                    0.351
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -48.53,
                                                    7.298
                                                ],
                                                [
                                                    -50.897,
                                                    6.847
                                                ],
                                                [
                                                    -52.55,
                                                    5.532
                                                ],
                                                [
                                                    -53.151,
                                                    3.56
                                                ],
                                                [
                                                    -50.859,
                                                    3.56
                                                ],
                                                [
                                                    -50.202,
                                                    4.95
                                                ],
                                                [
                                                    -48.53,
                                                    5.495
                                                ],
                                                [
                                                    -46.802,
                                                    4.969
                                                ],
                                                [
                                                    -46.182,
                                                    3.579
                                                ],
                                                [
                                                    -46.576,
                                                    2.508
                                                ],
                                                [
                                                    -47.534,
                                                    1.869
                                                ],
                                                [
                                                    -49.112,
                                                    1.381
                                                ],
                                                [
                                                    -51.197,
                                                    0.704
                                                ],
                                                [
                                                    -52.55,
                                                    -0.385
                                                ],
                                                [
                                                    -53.113,
                                                    -2.339
                                                ],
                                                [
                                                    -52.55,
                                                    -4.311
                                                ],
                                                [
                                                    -50.972,
                                                    -5.607
                                                ],
                                                [
                                                    -48.624,
                                                    -6.058
                                                ],
                                                [
                                                    -45.524,
                                                    -5.1
                                                ],
                                                [
                                                    -44.172,
                                                    -2.508
                                                ],
                                                [
                                                    -46.539,
                                                    -2.508
                                                ],
                                                [
                                                    -47.215,
                                                    -3.729
                                                ],
                                                [
                                                    -48.849,
                                                    -4.236
                                                ],
                                                [
                                                    -50.352,
                                                    -3.766
                                                ],
                                                [
                                                    -50.934,
                                                    -2.414
                                                ],
                                                [
                                                    -50.577,
                                                    -1.418
                                                ],
                                                [
                                                    -49.638,
                                                    -0.817
                                                ],
                                                [
                                                    -48.098,
                                                    -0.329
                                                ],
                                                [
                                                    -45.994,
                                                    0.385
                                                ],
                                                [
                                                    -44.604,
                                                    1.493
                                                ],
                                                [
                                                    -44.021,
                                                    3.466
                                                ],
                                                [
                                                    -44.566,
                                                    5.344
                                                ],
                                                [
                                                    -46.125,
                                                    6.772
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.175,
                                                    -0.176
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    0.451
                                                ],
                                                [
                                                    0,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.389
                                                ],
                                                [
                                                    0.188,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.964,
                                                    0
                                                ],
                                                [
                                                    -0.514,
                                                    -0.451
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.996,
                                                    -1.437
                                                ],
                                                [
                                                    -38.996,
                                                    4.292
                                                ],
                                                [
                                                    -38.733,
                                                    5.138
                                                ],
                                                [
                                                    -37.794,
                                                    5.382
                                                ],
                                                [
                                                    -36.479,
                                                    5.382
                                                ],
                                                [
                                                    -36.479,
                                                    7.166
                                                ],
                                                [
                                                    -38.17,
                                                    7.166
                                                ],
                                                [
                                                    -40.386,
                                                    6.49
                                                ],
                                                [
                                                    -41.156,
                                                    4.292
                                                ],
                                                [
                                                    -41.156,
                                                    -1.437
                                                ],
                                                [
                                                    -42.377,
                                                    -1.437
                                                ],
                                                [
                                                    -42.377,
                                                    -3.184
                                                ],
                                                [
                                                    -41.156,
                                                    -3.184
                                                ],
                                                [
                                                    -41.156,
                                                    -5.758
                                                ],
                                                [
                                                    -38.996,
                                                    -5.758
                                                ],
                                                [
                                                    -38.996,
                                                    -3.184
                                                ],
                                                [
                                                    -36.479,
                                                    -3.184
                                                ],
                                                [
                                                    -36.479,
                                                    -1.437
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    1.04
                                                ],
                                                [
                                                    -0.426,
                                                    0.801
                                                ],
                                                [
                                                    -0.738,
                                                    0.438
                                                ],
                                                [
                                                    -0.902,
                                                    0
                                                ],
                                                [
                                                    -0.601,
                                                    -0.325
                                                ],
                                                [
                                                    -0.363,
                                                    -0.476
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.626,
                                                    -0.325
                                                ],
                                                [
                                                    0.801,
                                                    0
                                                ],
                                                [
                                                    0.739,
                                                    0.451
                                                ],
                                                [
                                                    0.438,
                                                    0.814
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -1.039
                                                ],
                                                [
                                                    0.438,
                                                    -0.802
                                                ],
                                                [
                                                    0.752,
                                                    -0.451
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.613,
                                                    0.313
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    0.489
                                                ],
                                                [
                                                    -0.626,
                                                    0.326
                                                ],
                                                [
                                                    -0.89,
                                                    0
                                                ],
                                                [
                                                    -0.738,
                                                    -0.463
                                                ],
                                                [
                                                    -0.426,
                                                    -0.826
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -35.219,
                                                    1.944
                                                ],
                                                [
                                                    -34.58,
                                                    -0.817
                                                ],
                                                [
                                                    -32.815,
                                                    -2.677
                                                ],
                                                [
                                                    -30.335,
                                                    -3.353
                                                ],
                                                [
                                                    -28.212,
                                                    -2.865
                                                ],
                                                [
                                                    -26.747,
                                                    -1.681
                                                ],
                                                [
                                                    -26.747,
                                                    -3.184
                                                ],
                                                [
                                                    -24.587,
                                                    -3.184
                                                ],
                                                [
                                                    -24.587,
                                                    7.166
                                                ],
                                                [
                                                    -26.747,
                                                    7.166
                                                ],
                                                [
                                                    -26.747,
                                                    5.626
                                                ],
                                                [
                                                    -28.231,
                                                    6.847
                                                ],
                                                [
                                                    -30.372,
                                                    7.336
                                                ],
                                                [
                                                    -32.815,
                                                    6.659
                                                ],
                                                [
                                                    -34.58,
                                                    4.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.301,
                                                    0.526
                                                ],
                                                [
                                                    0.476,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.475,
                                                    -0.276
                                                ],
                                                [
                                                    0.3,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.539
                                                ],
                                                [
                                                    -0.476,
                                                    -0.288
                                                ],
                                                [
                                                    -0.539,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.275
                                                ],
                                                [
                                                    -0.288,
                                                    0.526
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.526
                                                ],
                                                [
                                                    -0.476,
                                                    -0.276
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.263
                                                ],
                                                [
                                                    -0.288,
                                                    0.514
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.3,
                                                    0.538
                                                ],
                                                [
                                                    0.488,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.276
                                                ],
                                                [
                                                    0.301,
                                                    -0.538
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.747,
                                                    1.982
                                                ],
                                                [
                                                    -27.198,
                                                    0.122
                                                ],
                                                [
                                                    -28.344,
                                                    -1.08
                                                ],
                                                [
                                                    -29.884,
                                                    -1.493
                                                ],
                                                [
                                                    -31.424,
                                                    -1.08
                                                ],
                                                [
                                                    -32.589,
                                                    0.103
                                                ],
                                                [
                                                    -33.021,
                                                    1.944
                                                ],
                                                [
                                                    -32.589,
                                                    3.823
                                                ],
                                                [
                                                    -31.424,
                                                    5.063
                                                ],
                                                [
                                                    -29.884,
                                                    5.476
                                                ],
                                                [
                                                    -28.344,
                                                    5.063
                                                ],
                                                [
                                                    -27.198,
                                                    3.86
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.288
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    -0.426
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.313,
                                                    -0.526
                                                ],
                                                [
                                                    0.526,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.839,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0.426
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -19.632,
                                                    -1.681
                                                ],
                                                [
                                                    -18.393,
                                                    -2.902
                                                ],
                                                [
                                                    -16.533,
                                                    -3.353
                                                ],
                                                [
                                                    -16.533,
                                                    -1.136
                                                ],
                                                [
                                                    -17.078,
                                                    -1.136
                                                ],
                                                [
                                                    -18.994,
                                                    -0.498
                                                ],
                                                [
                                                    -19.632,
                                                    1.719
                                                ],
                                                [
                                                    -19.632,
                                                    7.166
                                                ],
                                                [
                                                    -21.774,
                                                    7.166
                                                ],
                                                [
                                                    -21.774,
                                                    -3.184
                                                ],
                                                [
                                                    -19.632,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.176,
                                                    -0.176
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    0.451
                                                ],
                                                [
                                                    0,
                                                    1.015
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.389
                                                ],
                                                [
                                                    0.188,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.964,
                                                    0
                                                ],
                                                [
                                                    -0.514,
                                                    -0.451
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.066,
                                                    -1.437
                                                ],
                                                [
                                                    -12.066,
                                                    4.292
                                                ],
                                                [
                                                    -11.803,
                                                    5.138
                                                ],
                                                [
                                                    -10.864,
                                                    5.382
                                                ],
                                                [
                                                    -9.549,
                                                    5.382
                                                ],
                                                [
                                                    -9.549,
                                                    7.166
                                                ],
                                                [
                                                    -11.24,
                                                    7.166
                                                ],
                                                [
                                                    -13.456,
                                                    6.49
                                                ],
                                                [
                                                    -14.226,
                                                    4.292
                                                ],
                                                [
                                                    -14.226,
                                                    -1.437
                                                ],
                                                [
                                                    -15.447,
                                                    -1.437
                                                ],
                                                [
                                                    -15.447,
                                                    -3.184
                                                ],
                                                [
                                                    -14.226,
                                                    -3.184
                                                ],
                                                [
                                                    -14.226,
                                                    -5.758
                                                ],
                                                [
                                                    -12.066,
                                                    -5.758
                                                ],
                                                [
                                                    -12.066,
                                                    -3.184
                                                ],
                                                [
                                                    -9.549,
                                                    -3.184
                                                ],
                                                [
                                                    -9.549,
                                                    -1.437
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.426,
                                                    0.801
                                                ],
                                                [
                                                    -0.777,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.425,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.977,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.911,
                                                    1.738
                                                ],
                                                [
                                                    1.836,
                                                    2.79
                                                ],
                                                [
                                                    -6.073,
                                                    2.79
                                                ],
                                                [
                                                    -5.152,
                                                    4.781
                                                ],
                                                [
                                                    -3.123,
                                                    5.532
                                                ],
                                                [
                                                    -0.681,
                                                    4.086
                                                ],
                                                [
                                                    1.629,
                                                    4.086
                                                ],
                                                [
                                                    -0.08,
                                                    6.434
                                                ],
                                                [
                                                    -3.123,
                                                    7.336
                                                ],
                                                [
                                                    -5.791,
                                                    6.678
                                                ],
                                                [
                                                    -7.632,
                                                    4.8
                                                ],
                                                [
                                                    -8.289,
                                                    1.982
                                                ],
                                                [
                                                    -7.65,
                                                    -0.817
                                                ],
                                                [
                                                    -5.828,
                                                    -2.696
                                                ],
                                                [
                                                    -3.123,
                                                    -3.353
                                                ],
                                                [
                                                    -0.512,
                                                    -2.714
                                                ],
                                                [
                                                    1.272,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.013,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.525,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.324,
                                                    1.061
                                                ],
                                                [
                                                    -1.17,
                                                    -0.836
                                                ],
                                                [
                                                    -3.217,
                                                    -1.55
                                                ],
                                                [
                                                    -5.115,
                                                    -0.836
                                                ],
                                                [
                                                    -6.054,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    1.04
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.739,
                                                    0.438
                                                ],
                                                [
                                                    -0.915,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    -0.301
                                                ],
                                                [
                                                    -0.389,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.627,
                                                    -0.325
                                                ],
                                                [
                                                    0.801,
                                                    0
                                                ],
                                                [
                                                    0.752,
                                                    0.451
                                                ],
                                                [
                                                    0.439,
                                                    0.814
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -1.039
                                                ],
                                                [
                                                    0.439,
                                                    -0.802
                                                ],
                                                [
                                                    0.752,
                                                    -0.451
                                                ],
                                                [
                                                    0.676,
                                                    0
                                                ],
                                                [
                                                    0.664,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.501
                                                ],
                                                [
                                                    -0.613,
                                                    0.326
                                                ],
                                                [
                                                    -0.902,
                                                    0
                                                ],
                                                [
                                                    -0.739,
                                                    -0.463
                                                ],
                                                [
                                                    -0.425,
                                                    -0.826
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.305,
                                                    1.944
                                                ],
                                                [
                                                    3.943,
                                                    -0.817
                                                ],
                                                [
                                                    5.709,
                                                    -2.677
                                                ],
                                                [
                                                    8.208,
                                                    -3.353
                                                ],
                                                [
                                                    10.199,
                                                    -2.902
                                                ],
                                                [
                                                    11.777,
                                                    -1.738
                                                ],
                                                [
                                                    11.777,
                                                    -6.734
                                                ],
                                                [
                                                    13.937,
                                                    -6.734
                                                ],
                                                [
                                                    13.937,
                                                    7.166
                                                ],
                                                [
                                                    11.777,
                                                    7.166
                                                ],
                                                [
                                                    11.777,
                                                    5.607
                                                ],
                                                [
                                                    10.311,
                                                    6.847
                                                ],
                                                [
                                                    8.189,
                                                    7.336
                                                ],
                                                [
                                                    5.709,
                                                    6.659
                                                ],
                                                [
                                                    3.943,
                                                    4.743
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.3,
                                                    0.526
                                                ],
                                                [
                                                    0.476,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.276
                                                ],
                                                [
                                                    0.3,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.539
                                                ],
                                                [
                                                    -0.476,
                                                    -0.288
                                                ],
                                                [
                                                    -0.539,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.275
                                                ],
                                                [
                                                    -0.288,
                                                    0.526
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.714
                                                ],
                                                [
                                                    -0.288,
                                                    -0.526
                                                ],
                                                [
                                                    -0.476,
                                                    -0.276
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.263
                                                ],
                                                [
                                                    -0.288,
                                                    0.514
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    0.3,
                                                    0.538
                                                ],
                                                [
                                                    0.489,
                                                    0.275
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.276
                                                ],
                                                [
                                                    0.3,
                                                    -0.538
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.777,
                                                    1.982
                                                ],
                                                [
                                                    11.326,
                                                    0.122
                                                ],
                                                [
                                                    10.18,
                                                    -1.08
                                                ],
                                                [
                                                    8.64,
                                                    -1.493
                                                ],
                                                [
                                                    7.099,
                                                    -1.08
                                                ],
                                                [
                                                    5.935,
                                                    0.103
                                                ],
                                                [
                                                    5.503,
                                                    1.944
                                                ],
                                                [
                                                    5.935,
                                                    3.823
                                                ],
                                                [
                                                    7.099,
                                                    5.063
                                                ],
                                                [
                                                    8.64,
                                                    5.476
                                                ],
                                                [
                                                    10.18,
                                                    5.063
                                                ],
                                                [
                                                    11.326,
                                                    3.86
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.626,
                                                    0.539
                                                ],
                                                [
                                                    -1.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    -0.251
                                                ],
                                                [
                                                    0,
                                                    -0.601
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.189
                                                ],
                                                [
                                                    0.638,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    0.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.969,
                                                    -1.437
                                                ],
                                                [
                                                    24.053,
                                                    -1.437
                                                ],
                                                [
                                                    24.053,
                                                    7.166
                                                ],
                                                [
                                                    21.892,
                                                    7.166
                                                ],
                                                [
                                                    21.892,
                                                    -1.437
                                                ],
                                                [
                                                    20.671,
                                                    -1.437
                                                ],
                                                [
                                                    20.671,
                                                    -3.184
                                                ],
                                                [
                                                    21.892,
                                                    -3.184
                                                ],
                                                [
                                                    21.892,
                                                    -3.917
                                                ],
                                                [
                                                    22.832,
                                                    -6.509
                                                ],
                                                [
                                                    25.818,
                                                    -7.336
                                                ],
                                                [
                                                    25.818,
                                                    -5.551
                                                ],
                                                [
                                                    24.447,
                                                    -5.175
                                                ],
                                                [
                                                    24.053,
                                                    -3.917
                                                ],
                                                [
                                                    24.053,
                                                    -3.184
                                                ],
                                                [
                                                    25.969,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.99,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.464,
                                                    0.814
                                                ],
                                                [
                                                    -0.802,
                                                    0.439
                                                ],
                                                [
                                                    -0.989,
                                                    0
                                                ],
                                                [
                                                    -0.801,
                                                    -0.438
                                                ],
                                                [
                                                    -0.464,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0.476,
                                                    -0.814
                                                ],
                                                [
                                                    0.827,
                                                    -0.451
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.977,
                                                    0
                                                ],
                                                [
                                                    -0.789,
                                                    -0.451
                                                ],
                                                [
                                                    -0.451,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0.463,
                                                    -0.814
                                                ],
                                                [
                                                    0.801,
                                                    -0.438
                                                ],
                                                [
                                                    0.99,
                                                    0
                                                ],
                                                [
                                                    0.802,
                                                    0.439
                                                ],
                                                [
                                                    0.463,
                                                    0.814
                                                ],
                                                [
                                                    0,
                                                    1.052
                                                ],
                                                [
                                                    -0.476,
                                                    0.814
                                                ],
                                                [
                                                    -0.814,
                                                    0.438
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.356,
                                                    7.336
                                                ],
                                                [
                                                    29.708,
                                                    6.678
                                                ],
                                                [
                                                    27.848,
                                                    4.8
                                                ],
                                                [
                                                    27.172,
                                                    1.982
                                                ],
                                                [
                                                    27.867,
                                                    -0.817
                                                ],
                                                [
                                                    29.764,
                                                    -2.696
                                                ],
                                                [
                                                    32.45,
                                                    -3.353
                                                ],
                                                [
                                                    35.136,
                                                    -2.696
                                                ],
                                                [
                                                    37.034,
                                                    -0.817
                                                ],
                                                [
                                                    37.729,
                                                    1.982
                                                ],
                                                [
                                                    37.015,
                                                    4.781
                                                ],
                                                [
                                                    35.061,
                                                    6.678
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.263
                                                ],
                                                [
                                                    -0.3,
                                                    0.526
                                                ],
                                                [
                                                    0,
                                                    0.751
                                                ],
                                                [
                                                    0.288,
                                                    0.513
                                                ],
                                                [
                                                    0.476,
                                                    0.263
                                                ],
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    -0.263
                                                ],
                                                [
                                                    0.275,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    -0.564,
                                                    -0.613
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.551,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.263
                                                ],
                                                [
                                                    0.301,
                                                    -0.526
                                                ],
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    -0.288,
                                                    -0.526
                                                ],
                                                [
                                                    -0.476,
                                                    -0.263
                                                ],
                                                [
                                                    -0.551,
                                                    0
                                                ],
                                                [
                                                    -0.463,
                                                    0.263
                                                ],
                                                [
                                                    -0.276,
                                                    0.513
                                                ],
                                                [
                                                    0,
                                                    1.114
                                                ],
                                                [
                                                    0.576,
                                                    0.601
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.356,
                                                    5.476
                                                ],
                                                [
                                                    33.897,
                                                    5.081
                                                ],
                                                [
                                                    35.08,
                                                    3.898
                                                ],
                                                [
                                                    35.531,
                                                    1.982
                                                ],
                                                [
                                                    35.099,
                                                    0.085
                                                ],
                                                [
                                                    33.953,
                                                    -1.099
                                                ],
                                                [
                                                    32.413,
                                                    -1.493
                                                ],
                                                [
                                                    30.872,
                                                    -1.099
                                                ],
                                                [
                                                    29.764,
                                                    0.085
                                                ],
                                                [
                                                    29.351,
                                                    1.982
                                                ],
                                                [
                                                    30.196,
                                                    4.574
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.288
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.426
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.313,
                                                    -0.526
                                                ],
                                                [
                                                    0.526,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.839,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0.426
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    41.987,
                                                    -1.681
                                                ],
                                                [
                                                    43.227,
                                                    -2.902
                                                ],
                                                [
                                                    45.087,
                                                    -3.353
                                                ],
                                                [
                                                    45.087,
                                                    -1.136
                                                ],
                                                [
                                                    44.542,
                                                    -1.136
                                                ],
                                                [
                                                    42.626,
                                                    -0.498
                                                ],
                                                [
                                                    41.987,
                                                    1.719
                                                ],
                                                [
                                                    41.987,
                                                    7.166
                                                ],
                                                [
                                                    39.846,
                                                    7.166
                                                ],
                                                [
                                                    39.846,
                                                    -3.184
                                                ],
                                                [
                                                    41.987,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.626,
                                                    0.539
                                                ],
                                                [
                                                    -1.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    -0.251
                                                ],
                                                [
                                                    0,
                                                    -0.601
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.189
                                                ],
                                                [
                                                    0.639,
                                                    -0.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    0.238
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    56.274,
                                                    -1.437
                                                ],
                                                [
                                                    54.358,
                                                    -1.437
                                                ],
                                                [
                                                    54.358,
                                                    7.166
                                                ],
                                                [
                                                    52.198,
                                                    7.166
                                                ],
                                                [
                                                    52.198,
                                                    -1.437
                                                ],
                                                [
                                                    50.977,
                                                    -1.437
                                                ],
                                                [
                                                    50.977,
                                                    -3.184
                                                ],
                                                [
                                                    52.198,
                                                    -3.184
                                                ],
                                                [
                                                    52.198,
                                                    -3.917
                                                ],
                                                [
                                                    53.137,
                                                    -6.509
                                                ],
                                                [
                                                    56.124,
                                                    -7.336
                                                ],
                                                [
                                                    56.124,
                                                    -5.551
                                                ],
                                                [
                                                    54.753,
                                                    -5.175
                                                ],
                                                [
                                                    54.358,
                                                    -3.917
                                                ],
                                                [
                                                    54.358,
                                                    -3.184
                                                ],
                                                [
                                                    56.274,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    0.288
                                                ],
                                                [
                                                    -0.714,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.439,
                                                    -0.426
                                                ],
                                                [
                                                    0,
                                                    -1.052
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.313,
                                                    -0.526
                                                ],
                                                [
                                                    0.526,
                                                    -0.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.839,
                                                    0
                                                ],
                                                [
                                                    -0.425,
                                                    0.426
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    60.314,
                                                    -1.681
                                                ],
                                                [
                                                    61.553,
                                                    -2.902
                                                ],
                                                [
                                                    63.413,
                                                    -3.353
                                                ],
                                                [
                                                    63.413,
                                                    -1.136
                                                ],
                                                [
                                                    62.868,
                                                    -1.136
                                                ],
                                                [
                                                    60.952,
                                                    -0.498
                                                ],
                                                [
                                                    60.314,
                                                    1.719
                                                ],
                                                [
                                                    60.314,
                                                    7.166
                                                ],
                                                [
                                                    58.172,
                                                    7.166
                                                ],
                                                [
                                                    58.172,
                                                    -3.184
                                                ],
                                                [
                                                    60.314,
                                                    -3.184
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.777,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.425,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.439,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.976,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    74.868,
                                                    1.738
                                                ],
                                                [
                                                    74.793,
                                                    2.79
                                                ],
                                                [
                                                    66.884,
                                                    2.79
                                                ],
                                                [
                                                    67.805,
                                                    4.781
                                                ],
                                                [
                                                    69.834,
                                                    5.532
                                                ],
                                                [
                                                    72.276,
                                                    4.086
                                                ],
                                                [
                                                    74.586,
                                                    4.086
                                                ],
                                                [
                                                    72.877,
                                                    6.434
                                                ],
                                                [
                                                    69.834,
                                                    7.336
                                                ],
                                                [
                                                    67.166,
                                                    6.678
                                                ],
                                                [
                                                    65.325,
                                                    4.8
                                                ],
                                                [
                                                    64.668,
                                                    1.982
                                                ],
                                                [
                                                    65.306,
                                                    -0.817
                                                ],
                                                [
                                                    67.129,
                                                    -2.696
                                                ],
                                                [
                                                    69.834,
                                                    -3.353
                                                ],
                                                [
                                                    72.445,
                                                    -2.714
                                                ],
                                                [
                                                    74.229,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.013,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.526,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    72.633,
                                                    1.061
                                                ],
                                                [
                                                    71.787,
                                                    -0.836
                                                ],
                                                [
                                                    69.74,
                                                    -1.55
                                                ],
                                                [
                                                    67.842,
                                                    -0.836
                                                ],
                                                [
                                                    66.903,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -1.002
                                                ],
                                                [
                                                    0.05,
                                                    -0.314
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.501
                                                ],
                                                [
                                                    -0.802,
                                                    0
                                                ],
                                                [
                                                    -0.476,
                                                    0.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.826,
                                                    -0.614
                                                ],
                                                [
                                                    1.214,
                                                    0
                                                ],
                                                [
                                                    0.789,
                                                    0.438
                                                ],
                                                [
                                                    0.451,
                                                    0.801
                                                ],
                                                [
                                                    0,
                                                    1.064
                                                ],
                                                [
                                                    -0.425,
                                                    0.801
                                                ],
                                                [
                                                    -0.776,
                                                    0.439
                                                ],
                                                [
                                                    -1.015,
                                                    0
                                                ],
                                                [
                                                    -0.764,
                                                    -0.426
                                                ],
                                                [
                                                    -0.426,
                                                    -0.777
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.063,
                                                    0.826
                                                ],
                                                [
                                                    0.551,
                                                    0.501
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.952
                                                ],
                                                [
                                                    -0.814,
                                                    0.601
                                                ],
                                                [
                                                    -0.99,
                                                    0
                                                ],
                                                [
                                                    -0.776,
                                                    -0.451
                                                ],
                                                [
                                                    -0.438,
                                                    -0.814
                                                ],
                                                [
                                                    0,
                                                    -1.065
                                                ],
                                                [
                                                    0.439,
                                                    -0.814
                                                ],
                                                [
                                                    0.789,
                                                    -0.438
                                                ],
                                                [
                                                    0.976,
                                                    0
                                                ],
                                                [
                                                    0.764,
                                                    0.425
                                                ],
                                                [
                                                    0.426,
                                                    0.764
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    86.462,
                                                    1.738
                                                ],
                                                [
                                                    86.387,
                                                    2.79
                                                ],
                                                [
                                                    78.478,
                                                    2.79
                                                ],
                                                [
                                                    79.399,
                                                    4.781
                                                ],
                                                [
                                                    81.428,
                                                    5.532
                                                ],
                                                [
                                                    83.87,
                                                    4.086
                                                ],
                                                [
                                                    86.18,
                                                    4.086
                                                ],
                                                [
                                                    84.471,
                                                    6.434
                                                ],
                                                [
                                                    81.428,
                                                    7.336
                                                ],
                                                [
                                                    78.76,
                                                    6.678
                                                ],
                                                [
                                                    76.919,
                                                    4.8
                                                ],
                                                [
                                                    76.262,
                                                    1.982
                                                ],
                                                [
                                                    76.9,
                                                    -0.817
                                                ],
                                                [
                                                    78.722,
                                                    -2.696
                                                ],
                                                [
                                                    81.428,
                                                    -3.353
                                                ],
                                                [
                                                    84.039,
                                                    -2.714
                                                ],
                                                [
                                                    85.823,
                                                    -0.911
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.551,
                                                    0.476
                                                ],
                                                [
                                                    0.814,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    -0.476
                                                ],
                                                [
                                                    0.1,
                                                    -0.801
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.012,
                                                    -0.789
                                                ],
                                                [
                                                    -0.551,
                                                    -0.476
                                                ],
                                                [
                                                    -0.739,
                                                    0
                                                ],
                                                [
                                                    -0.526,
                                                    0.463
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    84.226,
                                                    1.061
                                                ],
                                                [
                                                    83.381,
                                                    -0.836
                                                ],
                                                [
                                                    81.334,
                                                    -1.55
                                                ],
                                                [
                                                    79.436,
                                                    -0.836
                                                ],
                                                [
                                                    78.497,
                                                    1.061
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    91.256,
                                                    -5.889
                                                ],
                                                [
                                                    91.011,
                                                    3.222
                                                ],
                                                [
                                                    89.227,
                                                    3.222
                                                ],
                                                [
                                                    88.983,
                                                    -5.889
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.376,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    0.263
                                                ],
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    -0.263,
                                                    0.263
                                                ],
                                                [
                                                    -0.388,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    -0.263
                                                ],
                                                [
                                                    0,
                                                    -0.389
                                                ],
                                                [
                                                    0.263,
                                                    -0.262
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.388,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    -0.262
                                                ],
                                                [
                                                    0,
                                                    -0.389
                                                ],
                                                [
                                                    0.263,
                                                    -0.263
                                                ],
                                                [
                                                    0.376,
                                                    0
                                                ],
                                                [
                                                    0.263,
                                                    0.263
                                                ],
                                                [
                                                    0,
                                                    0.388
                                                ],
                                                [
                                                    -0.263,
                                                    0.263
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    90.185,
                                                    7.298
                                                ],
                                                [
                                                    89.208,
                                                    6.903
                                                ],
                                                [
                                                    88.814,
                                                    5.927
                                                ],
                                                [
                                                    89.208,
                                                    4.95
                                                ],
                                                [
                                                    90.185,
                                                    4.555
                                                ],
                                                [
                                                    91.143,
                                                    4.95
                                                ],
                                                [
                                                    91.537,
                                                    5.927
                                                ],
                                                [
                                                    91.143,
                                                    6.903
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            112.465,
                                            32.465
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -8.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    8.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    8.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -8.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -8.509
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -117.731,
                                                    -158.072
                                                ],
                                                [
                                                    117.731,
                                                    -158.072
                                                ],
                                                [
                                                    133.137,
                                                    -142.666
                                                ],
                                                [
                                                    133.137,
                                                    142.666
                                                ],
                                                [
                                                    117.731,
                                                    158.072
                                                ],
                                                [
                                                    -117.731,
                                                    158.072
                                                ],
                                                [
                                                    -133.137,
                                                    142.666
                                                ],
                                                [
                                                    -133.137,
                                                    -142.666
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9608,
                                            0.9608,
                                            0.9608
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            133.137,
                                            158.072
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Button .svg",
            "id": "12",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Button .svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "639",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                113,
                                19
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                113,
                                19
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.517,
                                                    -0.263
                                                ],
                                                [
                                                    -0.253,
                                                    -0.442
                                                ],
                                                [
                                                    0,
                                                    -0.545
                                                ],
                                                [
                                                    0.376,
                                                    -0.526
                                                ],
                                                [
                                                    0.77,
                                                    -0.188
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.751,
                                                    0
                                                ],
                                                [
                                                    0.526,
                                                    0.263
                                                ],
                                                [
                                                    0.263,
                                                    0.441
                                                ],
                                                [
                                                    0,
                                                    0.639
                                                ],
                                                [
                                                    -0.366,
                                                    0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.041,
                                                    3.508
                                                ],
                                                [
                                                    -25.296,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    -0.409
                                                ],
                                                [
                                                    -26.521,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    3.508
                                                ],
                                                [
                                                    -28.127,
                                                    -6.284
                                                ],
                                                [
                                                    -24.746,
                                                    -6.284
                                                ],
                                                [
                                                    -22.844,
                                                    -5.889
                                                ],
                                                [
                                                    -21.675,
                                                    -4.832
                                                ],
                                                [
                                                    -21.28,
                                                    -3.353
                                                ],
                                                [
                                                    -21.844,
                                                    -1.606
                                                ],
                                                [
                                                    -23.548,
                                                    -0.549
                                                ],
                                                [
                                                    -21.125,
                                                    3.508
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    0.301
                                                ],
                                                [
                                                    0,
                                                    0.507
                                                ],
                                                [
                                                    0.3,
                                                    0.282
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    -0.507
                                                ],
                                                [
                                                    -0.301,
                                                    -0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.521,
                                                    -1.691
                                                ],
                                                [
                                                    -24.746,
                                                    -1.691
                                                ],
                                                [
                                                    -23.394,
                                                    -2.142
                                                ],
                                                [
                                                    -22.929,
                                                    -3.353
                                                ],
                                                [
                                                    -23.379,
                                                    -4.537
                                                ],
                                                [
                                                    -24.746,
                                                    -4.973
                                                ],
                                                [
                                                    -26.521,
                                                    -4.973
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    0.037,
                                                    -0.234
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.376
                                                ],
                                                [
                                                    -0.602,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.62,
                                                    -0.461
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.592,
                                                    0.329
                                                ],
                                                [
                                                    0.338,
                                                    0.601
                                                ],
                                                [
                                                    0,
                                                    0.798
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.583,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.573,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.375
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.713
                                                ],
                                                [
                                                    -0.611,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.582,
                                                    -0.338
                                                ],
                                                [
                                                    -0.329,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.799
                                                ],
                                                [
                                                    0.329,
                                                    -0.61
                                                ],
                                                [
                                                    0.591,
                                                    -0.328
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.32
                                                ],
                                                [
                                                    0.32,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.111,
                                                    -0.563
                                                ],
                                                [
                                                    -12.167,
                                                    0.225
                                                ],
                                                [
                                                    -18.098,
                                                    0.225
                                                ],
                                                [
                                                    -17.408,
                                                    1.719
                                                ],
                                                [
                                                    -15.886,
                                                    2.282
                                                ],
                                                [
                                                    -14.055,
                                                    1.198
                                                ],
                                                [
                                                    -12.322,
                                                    1.198
                                                ],
                                                [
                                                    -13.604,
                                                    2.959
                                                ],
                                                [
                                                    -15.886,
                                                    3.635
                                                ],
                                                [
                                                    -17.887,
                                                    3.142
                                                ],
                                                [
                                                    -19.268,
                                                    1.733
                                                ],
                                                [
                                                    -19.761,
                                                    -0.38
                                                ],
                                                [
                                                    -19.282,
                                                    -2.48
                                                ],
                                                [
                                                    -17.915,
                                                    -3.889
                                                ],
                                                [
                                                    -15.886,
                                                    -4.382
                                                ],
                                                [
                                                    -13.928,
                                                    -3.903
                                                ],
                                                [
                                                    -12.59,
                                                    -2.55
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.357
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.01,
                                                    -0.592
                                                ],
                                                [
                                                    -0.414,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.787,
                                                    -1.071
                                                ],
                                                [
                                                    -14.421,
                                                    -2.494
                                                ],
                                                [
                                                    -15.957,
                                                    -3.029
                                                ],
                                                [
                                                    -17.38,
                                                    -2.494
                                                ],
                                                [
                                                    -18.084,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.676,
                                                    0
                                                ],
                                                [
                                                    -0.46,
                                                    -0.244
                                                ],
                                                [
                                                    -0.263,
                                                    -0.357
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    -0.554
                                                ],
                                                [
                                                    0.573,
                                                    -0.319
                                                ],
                                                [
                                                    0.788,
                                                    0
                                                ],
                                                [
                                                    0.695,
                                                    0.498
                                                ],
                                                [
                                                    0.093,
                                                    0.845
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.244
                                                ],
                                                [
                                                    -0.555,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.394
                                                ],
                                                [
                                                    0,
                                                    0.751
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    -0.254
                                                ],
                                                [
                                                    0.592,
                                                    0
                                                ],
                                                [
                                                    0.563,
                                                    0.338
                                                ],
                                                [
                                                    0.329,
                                                    0.61
                                                ],
                                                [
                                                    0,
                                                    0.78
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.555,
                                                    0.328
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.714
                                                ],
                                                [
                                                    -0.301,
                                                    0.563
                                                ],
                                                [
                                                    -0.563,
                                                    0.32
                                                ],
                                                [
                                                    -1.052,
                                                    0
                                                ],
                                                [
                                                    -0.695,
                                                    -0.488
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.122,
                                                    0.404
                                                ],
                                                [
                                                    0.404,
                                                    0.254
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.404,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.272,
                                                    0.366
                                                ],
                                                [
                                                    -0.46,
                                                    0.244
                                                ],
                                                [
                                                    -0.676,
                                                    0
                                                ],
                                                [
                                                    -0.555,
                                                    -0.348
                                                ],
                                                [
                                                    -0.319,
                                                    -0.62
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    0.329,
                                                    -0.601
                                                ],
                                                [
                                                    0.563,
                                                    -0.338
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.403,
                                                    -4.382
                                                ],
                                                [
                                                    -5.811,
                                                    -4.015
                                                ],
                                                [
                                                    -4.712,
                                                    -3.128
                                                ],
                                                [
                                                    -4.712,
                                                    -4.255
                                                ],
                                                [
                                                    -3.092,
                                                    -4.255
                                                ],
                                                [
                                                    -3.092,
                                                    3.635
                                                ],
                                                [
                                                    -3.542,
                                                    5.537
                                                ],
                                                [
                                                    -4.853,
                                                    6.861
                                                ],
                                                [
                                                    -6.881,
                                                    7.34
                                                ],
                                                [
                                                    -9.502,
                                                    6.593
                                                ],
                                                [
                                                    -10.685,
                                                    4.593
                                                ],
                                                [
                                                    -9.093,
                                                    4.593
                                                ],
                                                [
                                                    -8.319,
                                                    5.565
                                                ],
                                                [
                                                    -6.881,
                                                    5.945
                                                ],
                                                [
                                                    -5.318,
                                                    5.354
                                                ],
                                                [
                                                    -4.712,
                                                    3.635
                                                ],
                                                [
                                                    -4.712,
                                                    2.339
                                                ],
                                                [
                                                    -5.825,
                                                    3.269
                                                ],
                                                [
                                                    -7.403,
                                                    3.635
                                                ],
                                                [
                                                    -9.262,
                                                    3.128
                                                ],
                                                [
                                                    -10.587,
                                                    1.691
                                                ],
                                                [
                                                    -11.066,
                                                    -0.409
                                                ],
                                                [
                                                    -10.587,
                                                    -2.48
                                                ],
                                                [
                                                    -9.262,
                                                    -3.874
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.535
                                                ],
                                                [
                                                    0.225,
                                                    0.394
                                                ],
                                                [
                                                    0.357,
                                                    0.207
                                                ],
                                                [
                                                    0.414,
                                                    0
                                                ],
                                                [
                                                    0.357,
                                                    -0.206
                                                ],
                                                [
                                                    0.225,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    -0.535
                                                ],
                                                [
                                                    -0.216,
                                                    -0.404
                                                ],
                                                [
                                                    -0.357,
                                                    -0.216
                                                ],
                                                [
                                                    -0.404,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.207
                                                ],
                                                [
                                                    -0.216,
                                                    0.395
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.536
                                                ],
                                                [
                                                    -0.216,
                                                    -0.395
                                                ],
                                                [
                                                    -0.357,
                                                    -0.206
                                                ],
                                                [
                                                    -0.413,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.197
                                                ],
                                                [
                                                    -0.216,
                                                    0.385
                                                ],
                                                [
                                                    0,
                                                    0.536
                                                ],
                                                [
                                                    0.225,
                                                    0.404
                                                ],
                                                [
                                                    0.366,
                                                    0.207
                                                ],
                                                [
                                                    0.414,
                                                    0
                                                ],
                                                [
                                                    0.357,
                                                    -0.206
                                                ],
                                                [
                                                    0.225,
                                                    -0.403
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.712,
                                                    -0.38
                                                ],
                                                [
                                                    -5.05,
                                                    -1.775
                                                ],
                                                [
                                                    -5.909,
                                                    -2.677
                                                ],
                                                [
                                                    -7.065,
                                                    -2.987
                                                ],
                                                [
                                                    -8.22,
                                                    -2.677
                                                ],
                                                [
                                                    -9.093,
                                                    -1.789
                                                ],
                                                [
                                                    -9.417,
                                                    -0.409
                                                ],
                                                [
                                                    -9.093,
                                                    1
                                                ],
                                                [
                                                    -8.22,
                                                    1.93
                                                ],
                                                [
                                                    -7.065,
                                                    2.24
                                                ],
                                                [
                                                    -5.909,
                                                    1.93
                                                ],
                                                [
                                                    -5.05,
                                                    1.028
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.282,
                                                    0
                                                ],
                                                [
                                                    0.198,
                                                    0.197
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.197,
                                                    0.197
                                                ],
                                                [
                                                    -0.291,
                                                    0
                                                ],
                                                [
                                                    -0.198,
                                                    -0.198
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.197,
                                                    -0.197
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.291,
                                                    0
                                                ],
                                                [
                                                    -0.197,
                                                    -0.197
                                                ],
                                                [
                                                    0,
                                                    -0.291
                                                ],
                                                [
                                                    0.198,
                                                    -0.198
                                                ],
                                                [
                                                    0.282,
                                                    0
                                                ],
                                                [
                                                    0.197,
                                                    0.197
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    -0.198,
                                                    0.197
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.165,
                                                    -5.283
                                                ],
                                                [
                                                    -0.898,
                                                    -5.579
                                                ],
                                                [
                                                    -1.193,
                                                    -6.312
                                                ],
                                                [
                                                    -0.898,
                                                    -7.044
                                                ],
                                                [
                                                    -0.165,
                                                    -7.34
                                                ],
                                                [
                                                    0.554,
                                                    -7.044
                                                ],
                                                [
                                                    0.85,
                                                    -6.312
                                                ],
                                                [
                                                    0.554,
                                                    -5.579
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.624,
                                                    -4.255
                                                ],
                                                [
                                                    0.624,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    3.508
                                                ],
                                                [
                                                    -0.982,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.601,
                                                    0
                                                ],
                                                [
                                                    0.489,
                                                    0.216
                                                ],
                                                [
                                                    0.282,
                                                    0.376
                                                ],
                                                [
                                                    0.019,
                                                    0.47
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.282,
                                                    -0.225
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.244,
                                                    0.169
                                                ],
                                                [
                                                    0,
                                                    0.272
                                                ],
                                                [
                                                    0.281,
                                                    0.141
                                                ],
                                                [
                                                    0.602,
                                                    0.169
                                                ],
                                                [
                                                    0.367,
                                                    0.15
                                                ],
                                                [
                                                    0.273,
                                                    0.31
                                                ],
                                                [
                                                    0,
                                                    0.508
                                                ],
                                                [
                                                    -0.244,
                                                    0.338
                                                ],
                                                [
                                                    -0.451,
                                                    0.197
                                                ],
                                                [
                                                    -0.592,
                                                    0
                                                ],
                                                [
                                                    -0.535,
                                                    -0.451
                                                ],
                                                [
                                                    -0.038,
                                                    -0.77
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.253,
                                                    0.207
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.226,
                                                    -0.159
                                                ],
                                                [
                                                    0,
                                                    -0.263
                                                ],
                                                [
                                                    -0.151,
                                                    -0.141
                                                ],
                                                [
                                                    -0.216,
                                                    -0.085
                                                ],
                                                [
                                                    -0.423,
                                                    -0.122
                                                ],
                                                [
                                                    -0.357,
                                                    -0.16
                                                ],
                                                [
                                                    -0.263,
                                                    -0.301
                                                ],
                                                [
                                                    -0.009,
                                                    -0.497
                                                ],
                                                [
                                                    0.244,
                                                    -0.348
                                                ],
                                                [
                                                    0.451,
                                                    -0.197
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.611,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    -0.226
                                                ],
                                                [
                                                    -0.282,
                                                    -0.385
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.329
                                                ],
                                                [
                                                    0.291,
                                                    0.216
                                                ],
                                                [
                                                    0.451,
                                                    0
                                                ],
                                                [
                                                    0.254,
                                                    -0.179
                                                ],
                                                [
                                                    0,
                                                    -0.292
                                                ],
                                                [
                                                    -0.273,
                                                    -0.14
                                                ],
                                                [
                                                    -0.582,
                                                    -0.16
                                                ],
                                                [
                                                    -0.366,
                                                    -0.151
                                                ],
                                                [
                                                    -0.263,
                                                    -0.31
                                                ],
                                                [
                                                    0,
                                                    -0.413
                                                ],
                                                [
                                                    0.244,
                                                    -0.347
                                                ],
                                                [
                                                    0.46,
                                                    -0.197
                                                ],
                                                [
                                                    0.883,
                                                    0
                                                ],
                                                [
                                                    0.545,
                                                    0.441
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.029,
                                                    -0.347
                                                ],
                                                [
                                                    -0.254,
                                                    -0.207
                                                ],
                                                [
                                                    -0.422,
                                                    0
                                                ],
                                                [
                                                    -0.225,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.207
                                                ],
                                                [
                                                    0.15,
                                                    0.141
                                                ],
                                                [
                                                    0.216,
                                                    0.075
                                                ],
                                                [
                                                    0.564,
                                                    0.15
                                                ],
                                                [
                                                    0.366,
                                                    0.15
                                                ],
                                                [
                                                    0.263,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0.442
                                                ],
                                                [
                                                    -0.244,
                                                    0.347
                                                ],
                                                [
                                                    -0.441,
                                                    0.197
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.551,
                                                    3.635
                                                ],
                                                [
                                                    3.902,
                                                    3.311
                                                ],
                                                [
                                                    2.761,
                                                    2.409
                                                ],
                                                [
                                                    2.31,
                                                    1.127
                                                ],
                                                [
                                                    3.973,
                                                    1.127
                                                ],
                                                [
                                                    4.438,
                                                    1.958
                                                ],
                                                [
                                                    5.522,
                                                    2.282
                                                ],
                                                [
                                                    6.565,
                                                    2.029
                                                ],
                                                [
                                                    6.945,
                                                    1.353
                                                ],
                                                [
                                                    6.523,
                                                    0.704
                                                ],
                                                [
                                                    5.212,
                                                    0.24
                                                ],
                                                [
                                                    3.789,
                                                    -0.225
                                                ],
                                                [
                                                    2.831,
                                                    -0.916
                                                ],
                                                [
                                                    2.437,
                                                    -2.142
                                                ],
                                                [
                                                    2.803,
                                                    -3.269
                                                ],
                                                [
                                                    3.846,
                                                    -4.086
                                                ],
                                                [
                                                    5.424,
                                                    -4.382
                                                ],
                                                [
                                                    7.551,
                                                    -3.705
                                                ],
                                                [
                                                    8.425,
                                                    -1.888
                                                ],
                                                [
                                                    6.819,
                                                    -1.888
                                                ],
                                                [
                                                    6.396,
                                                    -2.719
                                                ],
                                                [
                                                    5.367,
                                                    -3.029
                                                ],
                                                [
                                                    4.395,
                                                    -2.79
                                                ],
                                                [
                                                    4.057,
                                                    -2.156
                                                ],
                                                [
                                                    4.283,
                                                    -1.634
                                                ],
                                                [
                                                    4.832,
                                                    -1.296
                                                ],
                                                [
                                                    5.79,
                                                    -1
                                                ],
                                                [
                                                    7.171,
                                                    -0.535
                                                ],
                                                [
                                                    8.115,
                                                    0.141
                                                ],
                                                [
                                                    8.523,
                                                    1.338
                                                ],
                                                [
                                                    8.157,
                                                    2.522
                                                ],
                                                [
                                                    7.114,
                                                    3.339
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.132,
                                                    -0.131
                                                ],
                                                [
                                                    -0.329,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.385,
                                                    0.338
                                                ],
                                                [
                                                    0,
                                                    0.76
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0.141,
                                                    0.123
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.723,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    -0.338
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.132,
                                                    -2.944
                                                ],
                                                [
                                                    12.132,
                                                    1.353
                                                ],
                                                [
                                                    12.33,
                                                    1.986
                                                ],
                                                [
                                                    13.034,
                                                    2.17
                                                ],
                                                [
                                                    14.02,
                                                    2.17
                                                ],
                                                [
                                                    14.02,
                                                    3.508
                                                ],
                                                [
                                                    12.752,
                                                    3.508
                                                ],
                                                [
                                                    11.09,
                                                    3.001
                                                ],
                                                [
                                                    10.512,
                                                    1.353
                                                ],
                                                [
                                                    10.512,
                                                    -2.944
                                                ],
                                                [
                                                    9.597,
                                                    -2.944
                                                ],
                                                [
                                                    9.597,
                                                    -4.255
                                                ],
                                                [
                                                    10.512,
                                                    -4.255
                                                ],
                                                [
                                                    10.512,
                                                    -6.185
                                                ],
                                                [
                                                    12.132,
                                                    -6.185
                                                ],
                                                [
                                                    12.132,
                                                    -4.255
                                                ],
                                                [
                                                    14.02,
                                                    -4.255
                                                ],
                                                [
                                                    14.02,
                                                    -2.944
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.752
                                                ],
                                                [
                                                    0.038,
                                                    -0.234
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.413,
                                                    -0.376
                                                ],
                                                [
                                                    -0.601,
                                                    0
                                                ],
                                                [
                                                    -0.357,
                                                    0.723
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.62,
                                                    -0.461
                                                ],
                                                [
                                                    0.911,
                                                    0
                                                ],
                                                [
                                                    0.592,
                                                    0.329
                                                ],
                                                [
                                                    0.339,
                                                    0.601
                                                ],
                                                [
                                                    0,
                                                    0.798
                                                ],
                                                [
                                                    -0.319,
                                                    0.601
                                                ],
                                                [
                                                    -0.582,
                                                    0.329
                                                ],
                                                [
                                                    -0.761,
                                                    0
                                                ],
                                                [
                                                    -0.573,
                                                    -0.319
                                                ],
                                                [
                                                    -0.319,
                                                    -0.582
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.291
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.047,
                                                    0.62
                                                ],
                                                [
                                                    0.413,
                                                    0.375
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.713
                                                ],
                                                [
                                                    -0.61,
                                                    0.451
                                                ],
                                                [
                                                    -0.742,
                                                    0
                                                ],
                                                [
                                                    -0.582,
                                                    -0.338
                                                ],
                                                [
                                                    -0.328,
                                                    -0.611
                                                ],
                                                [
                                                    0,
                                                    -0.799
                                                ],
                                                [
                                                    0.329,
                                                    -0.61
                                                ],
                                                [
                                                    0.592,
                                                    -0.328
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.573,
                                                    0.32
                                                ],
                                                [
                                                    0.32,
                                                    0.573
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.616,
                                                    -0.563
                                                ],
                                                [
                                                    22.559,
                                                    0.225
                                                ],
                                                [
                                                    16.628,
                                                    0.225
                                                ],
                                                [
                                                    17.318,
                                                    1.719
                                                ],
                                                [
                                                    18.84,
                                                    2.282
                                                ],
                                                [
                                                    20.671,
                                                    1.198
                                                ],
                                                [
                                                    22.404,
                                                    1.198
                                                ],
                                                [
                                                    21.122,
                                                    2.959
                                                ],
                                                [
                                                    18.84,
                                                    3.635
                                                ],
                                                [
                                                    16.839,
                                                    3.142
                                                ],
                                                [
                                                    15.458,
                                                    1.733
                                                ],
                                                [
                                                    14.965,
                                                    -0.38
                                                ],
                                                [
                                                    15.444,
                                                    -2.48
                                                ],
                                                [
                                                    16.811,
                                                    -3.889
                                                ],
                                                [
                                                    18.84,
                                                    -4.382
                                                ],
                                                [
                                                    20.798,
                                                    -3.903
                                                ],
                                                [
                                                    22.136,
                                                    -2.55
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.413,
                                                    0.357
                                                ],
                                                [
                                                    0.611,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.357
                                                ],
                                                [
                                                    0.075,
                                                    -0.601
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.009,
                                                    -0.592
                                                ],
                                                [
                                                    -0.413,
                                                    -0.357
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.939,
                                                    -1.071
                                                ],
                                                [
                                                    20.305,
                                                    -2.494
                                                ],
                                                [
                                                    18.769,
                                                    -3.029
                                                ],
                                                [
                                                    17.346,
                                                    -2.494
                                                ],
                                                [
                                                    16.642,
                                                    -1.071
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    0.216
                                                ],
                                                [
                                                    -0.536,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.329,
                                                    -0.319
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.235,
                                                    -0.394
                                                ],
                                                [
                                                    0.395,
                                                    -0.226
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.629,
                                                    0
                                                ],
                                                [
                                                    -0.319,
                                                    0.319
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.802,
                                                    -3.128
                                                ],
                                                [
                                                    26.732,
                                                    -4.043
                                                ],
                                                [
                                                    28.127,
                                                    -4.382
                                                ],
                                                [
                                                    28.127,
                                                    -2.719
                                                ],
                                                [
                                                    27.718,
                                                    -2.719
                                                ],
                                                [
                                                    26.281,
                                                    -2.24
                                                ],
                                                [
                                                    25.802,
                                                    -0.578
                                                ],
                                                [
                                                    25.802,
                                                    3.508
                                                ],
                                                [
                                                    24.196,
                                                    3.508
                                                ],
                                                [
                                                    24.196,
                                                    -4.255
                                                ],
                                                [
                                                    25.802,
                                                    -4.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.3804,
                                            0.3804,
                                            0.3804
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            112.147,
                                            19.71
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.593
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.593,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.593
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -108.014,
                                                    -18.785
                                                ],
                                                [
                                                    108.014,
                                                    -18.785
                                                ],
                                                [
                                                    112.71,
                                                    -14.089
                                                ],
                                                [
                                                    112.71,
                                                    14.089
                                                ],
                                                [
                                                    108.014,
                                                    18.785
                                                ],
                                                [
                                                    -108.014,
                                                    18.785
                                                ],
                                                [
                                                    -112.71,
                                                    14.089
                                                ],
                                                [
                                                    -112.71,
                                                    -14.089
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.7529,
                                            0.7529,
                                            0.7529
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            112.71,
                                            18.785
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "isometric",
            "id": "13",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "svg 1.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "610",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                95,
                                85.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                80,
                                80
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                392,
                                632
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 190,
                    "h": 171,
                    "refId": "14",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "SVG 2.svg 2",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "626",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                43,
                                44
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        369.506,
                                        596.295
                                    ],
                                    "t": 0
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        347.536,
                                        558.17
                                    ],
                                    "t": 45
                                },
                                {
                                    "s": [
                                        368.859,
                                        596.295
                                    ],
                                    "t": 99.999
                                }
                            ],
                            "x": "var $bm_rt;\n$bm_rt = loopOut();"
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 86,
                    "h": 88,
                    "refId": "15",
                    "ind": 2
                }
            ]
        },
        {
            "nm": "svg 1.svg",
            "id": "14",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "svg 1.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "609",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                95,
                                85.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                95,
                                85.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.289,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.289,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.001,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    -0.001,
                                                    -2.331
                                                ],
                                                [
                                                    -2.33,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            140.803,
                                            57.932
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.286
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.286
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.33
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.33
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77.007,
                                            113.033
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.288,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.288,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.33,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            124.833,
                                            85.624
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            93.025,
                                            85.395
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            77.16,
                                            57.961
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            124.608,
                                            30.468
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.289,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.289,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.001,
                                                    2.33
                                                ],
                                                [
                                                    2.331,
                                                    -0.001
                                                ],
                                                [
                                                    -0.001,
                                                    -2.331
                                                ],
                                                [
                                                    -2.33,
                                                    -0.001
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            140.803,
                                            168.016
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    2.331
                                                ],
                                                [
                                                    2.33,
                                                    0
                                                ],
                                                [
                                                    0.001,
                                                    -2.331
                                                ],
                                                [
                                                    -2.33,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            108.619,
                                            167.99
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.288
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0.001
                                                ],
                                                [
                                                    0,
                                                    -2.33
                                                ],
                                                [
                                                    -2.331,
                                                    0.001
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            28.958,
                                            140.729
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            45.2,
                                            167.99
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.33
                                                ],
                                                [
                                                    2.331,
                                                    -0.001
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    -0.001
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            76.774,
                                            168.016
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.288
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.33
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            124.608,
                                            140.212
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.288,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.288
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.288,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0.001,
                                                    -2.33
                                                ],
                                                [
                                                    -2.33,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            156.622,
                                            140.212
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 14",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0.001,
                                                    -2.331
                                                ],
                                                [
                                                    -2.33,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            171.953,
                                            112.982
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 15",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.001,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0.001,
                                                    -2.331
                                                ],
                                                [
                                                    -2.33,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            171.953,
                                            57.961
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 16",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            156.525,
                                            30.442
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 17",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.289,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.289,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.286,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.001,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    -0.001,
                                                    -2.331
                                                ],
                                                [
                                                    -2.33,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            140.803,
                                            2.831
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 18",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            108.73,
                                            2.831
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 19",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.105,
                                                    0.246
                                                ],
                                                [
                                                    -0.123,
                                                    0.301
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.152,
                                                    -0.263
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.144,
                                                    -0.255
                                                ],
                                                [
                                                    0.22,
                                                    0.005
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.026,
                                                    0.207
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    71.621,
                                                    -13.723
                                                ],
                                                [
                                                    62.069,
                                                    2.756
                                                ],
                                                [
                                                    55.747,
                                                    13.782
                                                ],
                                                [
                                                    24.058,
                                                    13.791
                                                ],
                                                [
                                                    7.96,
                                                    -13.656
                                                ],
                                                [
                                                    -24.012,
                                                    -13.656
                                                ],
                                                [
                                                    -22.385,
                                                    -10.838
                                                ],
                                                [
                                                    -7.355,
                                                    15.049
                                                ],
                                                [
                                                    -2.948,
                                                    22.719
                                                ],
                                                [
                                                    7.65,
                                                    40.831
                                                ],
                                                [
                                                    7.735,
                                                    40.983
                                                ],
                                                [
                                                    -8.202,
                                                    68.76
                                                ],
                                                [
                                                    -16.144,
                                                    55.086
                                                ],
                                                [
                                                    -23.796,
                                                    41.869
                                                ],
                                                [
                                                    -39.78,
                                                    14.054
                                                ],
                                                [
                                                    -39.166,
                                                    19.372
                                                ],
                                                [
                                                    -33.437,
                                                    58.044
                                                ],
                                                [
                                                    -39.967,
                                                    68.76
                                                ],
                                                [
                                                    -71.621,
                                                    68.786
                                                ],
                                                [
                                                    -39.865,
                                                    13.753
                                                ],
                                                [
                                                    -38.721,
                                                    11.897
                                                ],
                                                [
                                                    -30.097,
                                                    -3.1
                                                ],
                                                [
                                                    -28.902,
                                                    -5.219
                                                ],
                                                [
                                                    -24.478,
                                                    -12.973
                                                ],
                                                [
                                                    -24.139,
                                                    -13.834
                                                ],
                                                [
                                                    -23.593,
                                                    -14.266
                                                ],
                                                [
                                                    -7.554,
                                                    -42.187
                                                ],
                                                [
                                                    7.786,
                                                    -68.761
                                                ],
                                                [
                                                    39.703,
                                                    -68.786
                                                ],
                                                [
                                                    39.53,
                                                    -68.176
                                                ],
                                                [
                                                    25.639,
                                                    -44.213
                                                ],
                                                [
                                                    23.952,
                                                    -41.268
                                                ],
                                                [
                                                    7.985,
                                                    -13.694
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            116.822,
                                            99.229
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 20",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.051,
                                                    -0.233
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.898,
                                                    -13.679
                                                ],
                                                [
                                                    -18.062,
                                                    -13.73
                                                ],
                                                [
                                                    7.969,
                                                    -13.819
                                                ],
                                                [
                                                    23.898,
                                                    13.793
                                                ],
                                                [
                                                    -8.019,
                                                    13.819
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.627,
                                            16.649
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 21",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.195,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.204,
                                                    0.199
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.917,
                                                    -13.757
                                                ],
                                                [
                                                    8.577,
                                                    12.816
                                                ],
                                                [
                                                    -7.462,
                                                    40.738
                                                ],
                                                [
                                                    -7.958,
                                                    41.255
                                                ],
                                                [
                                                    -23.917,
                                                    13.774
                                                ],
                                                [
                                                    8.039,
                                                    -41.255
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            100.691,
                                            44.225
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 22",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.818,
                                                    13.757
                                                ],
                                                [
                                                    -31.817,
                                                    13.787
                                                ],
                                                [
                                                    -15.85,
                                                    -13.787
                                                ],
                                                [
                                                    15.859,
                                                    -13.774
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            156.624,
                                            71.748
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 23",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.992,
                                                    5.82
                                                ],
                                                [
                                                    -0.644,
                                                    20.215
                                                ],
                                                [
                                                    -1.648,
                                                    21.995
                                                ],
                                                [
                                                    -7.378,
                                                    -16.677
                                                ],
                                                [
                                                    -7.992,
                                                    -21.995
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            85.034,
                                            135.278
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 24",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            61.112,
                                            85.624
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 25",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.941,
                                                    2.743
                                                ],
                                                [
                                                    38.55,
                                                    -13.836
                                                ],
                                                [
                                                    -23.459,
                                                    -13.836
                                                ],
                                                [
                                                    -38.55,
                                                    13.815
                                                ],
                                                [
                                                    22.58,
                                                    13.836
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.743
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            55.073,
                                            99.228
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 26",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.506,
                                                    -0.254
                                                ],
                                                [
                                                    0.591,
                                                    27.918
                                                ],
                                                [
                                                    -15.506,
                                                    -0.254
                                                ],
                                                [
                                                    -0.468,
                                                    -27.918
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.743
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            15.932,
                                            85.264
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 27",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    39.079,
                                                    14.022
                                                ],
                                                [
                                                    -23.485,
                                                    13.718
                                                ],
                                                [
                                                    -39.079,
                                                    -14.022
                                                ],
                                                [
                                                    23.024,
                                                    -13.676
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 0.743
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            54.544,
                                            71.368
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 28",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.034,
                                                    -0.06
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.25,
                                                    -8.941
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.288,
                                                    8.916
                                                ],
                                                [
                                                    0.034,
                                                    0.059
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    24.044,
                                                    -14.232
                                                ],
                                                [
                                                    23.955,
                                                    -13.838
                                                ],
                                                [
                                                    -7.801,
                                                    41.195
                                                ],
                                                [
                                                    -8.878,
                                                    39.564
                                                ],
                                                [
                                                    -13.611,
                                                    31.499
                                                ],
                                                [
                                                    -24.044,
                                                    13.447
                                                ],
                                                [
                                                    -14.37,
                                                    -3.061
                                                ],
                                                [
                                                    8.132,
                                                    -41.196
                                                ],
                                                [
                                                    23.942,
                                                    -14.406
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            53.002,
                                            126.82
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 29",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.144,
                                                    -0.254
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.034,
                                                    0.06
                                                ],
                                                [
                                                    5.288,
                                                    8.915
                                                ],
                                                [
                                                    -0.327,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.034,
                                                    -0.059
                                                ],
                                                [
                                                    -5.25,
                                                    -8.941
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.105,
                                                    0.246
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.44,
                                                    -12.933
                                                ],
                                                [
                                                    11.015,
                                                    -5.178
                                                ],
                                                [
                                                    9.821,
                                                    -3.059
                                                ],
                                                [
                                                    1.197,
                                                    11.937
                                                ],
                                                [
                                                    0.053,
                                                    13.793
                                                ],
                                                [
                                                    0.142,
                                                    13.399
                                                ],
                                                [
                                                    0.04,
                                                    13.225
                                                ],
                                                [
                                                    -15.77,
                                                    -13.564
                                                ],
                                                [
                                                    -15.558,
                                                    -13.793
                                                ],
                                                [
                                                    15.779,
                                                    -13.793
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.7216,
                                            0.7216
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            76.904,
                                            99.189
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 30",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.233,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    0.293
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    24.118,
                                                    -13.4
                                                ],
                                                [
                                                    8.414,
                                                    13.623
                                                ],
                                                [
                                                    7.41,
                                                    13.844
                                                ],
                                                [
                                                    -24.118,
                                                    13.861
                                                ],
                                                [
                                                    -8.18,
                                                    -13.917
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.738,
                                            154.129
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 31",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.097,
                                                    -0.517
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.023,
                                                    27.578
                                                ],
                                                [
                                                    -0.276,
                                                    27.061
                                                ],
                                                [
                                                    -10.958,
                                                    8.797
                                                ],
                                                [
                                                    -15.366,
                                                    1.128
                                                ],
                                                [
                                                    -30.396,
                                                    -24.76
                                                ],
                                                [
                                                    -32.023,
                                                    -27.578
                                                ],
                                                [
                                                    -0.051,
                                                    -27.578
                                                ],
                                                [
                                                    16.048,
                                                    -0.131
                                                ],
                                                [
                                                    16.997,
                                                    1.539
                                                ],
                                                [
                                                    22.243,
                                                    10.467
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            124.832,
                                            113.151
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "SVG 2.svg 2",
            "id": "15",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "SVG 2.svg 2",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "625",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                43,
                                44
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                43,
                                44
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.49,
                                                    2.58
                                                ],
                                                [
                                                    2.023,
                                                    1.168
                                                ],
                                                [
                                                    1.489,
                                                    -2.58
                                                ],
                                                [
                                                    -2.023,
                                                    -1.168
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.489,
                                                    -2.581
                                                ],
                                                [
                                                    -2.023,
                                                    -1.168
                                                ],
                                                [
                                                    -1.49,
                                                    2.581
                                                ],
                                                [
                                                    2.023,
                                                    1.168
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.663,
                                                    2.115
                                                ],
                                                [
                                                    2.697,
                                                    -4.672
                                                ],
                                                [
                                                    -3.662,
                                                    -2.115
                                                ],
                                                [
                                                    -2.697,
                                                    4.672
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            59.003,
                                            71.794
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            66.492,
                                            85.002
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            82.56,
                                            58.046
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            50.999,
                                            57.771
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.095,
                                            85.002
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            2.831,
                                            30.273
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            18.857,
                                            2.848
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ],
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.287
                                                ],
                                                [
                                                    -1.287,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.287
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    2.331
                                                ],
                                                [
                                                    2.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.331
                                                ],
                                                [
                                                    -2.331,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            50.919,
                                            2.831
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.012,
                                                    -0.148
                                                ],
                                                [
                                                    -0.157,
                                                    -1.059
                                                ],
                                                [
                                                    1.796,
                                                    -6.246
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.077,
                                                    0.081
                                                ],
                                                [
                                                    -0.085,
                                                    1.076
                                                ],
                                                [
                                                    0.966,
                                                    6.475
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.413,
                                                    11.535
                                                ],
                                                [
                                                    -4.214,
                                                    0.123
                                                ],
                                                [
                                                    2.54,
                                                    -11.535
                                                ],
                                                [
                                                    2.685,
                                                    -11.183
                                                ],
                                                [
                                                    2.947,
                                                    -8.094
                                                ],
                                                [
                                                    2.418,
                                                    11.53
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            7.046,
                                            30.273
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.729,
                                                    -1.504
                                                ],
                                                [
                                                    2.386,
                                                    -1.466
                                                ],
                                                [
                                                    0.351,
                                                    -0.009
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.097,
                                                    1.962
                                                ],
                                                [
                                                    -2.115,
                                                    1.839
                                                ],
                                                [
                                                    -0.339,
                                                    0.208
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    8.998,
                                                    -5.305
                                                ],
                                                [
                                                    4.706,
                                                    -0.144
                                                ],
                                                [
                                                    -1.939,
                                                    4.771
                                                ],
                                                [
                                                    -2.875,
                                                    5.31
                                                ],
                                                [
                                                    -9.003,
                                                    -5.288
                                                ],
                                                [
                                                    9.003,
                                                    -5.31
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            27.865,
                                            8.136
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.568,
                                                    -2.737
                                                ],
                                                [
                                                    1.682,
                                                    -1.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.305,
                                                    0.144
                                                ],
                                                [
                                                    0.009,
                                                    0.067
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.674,
                                                    4.297
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -5.191,
                                                    1.267
                                                ],
                                                [
                                                    -2,
                                                    1.199
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.165,
                                                    -0.284
                                                ],
                                                [
                                                    0.047,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.14,
                                                    -2.721
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    14.806,
                                                    -3.238
                                                ],
                                                [
                                                    13.289,
                                                    -3.055
                                                ],
                                                [
                                                    -1.288,
                                                    3.034
                                                ],
                                                [
                                                    -6.797,
                                                    6.996
                                                ],
                                                [
                                                    -9.602,
                                                    9.662
                                                ],
                                                [
                                                    -14.209,
                                                    1.797
                                                ],
                                                [
                                                    -14.806,
                                                    1.119
                                                ],
                                                [
                                                    -14.747,
                                                    0.958
                                                ],
                                                [
                                                    -14.675,
                                                    0.64
                                                ],
                                                [
                                                    -3.437,
                                                    -9.293
                                                ],
                                                [
                                                    -2.869,
                                                    -9.662
                                                ],
                                                [
                                                    11.056,
                                                    -9.649
                                                ],
                                                [
                                                    14.806,
                                                    -3.242
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            39.733,
                                            12.484
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -3.75,
                                                    1.174
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2,
                                                    1.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.428,
                                                    -3.865
                                                ],
                                                [
                                                    -0.407,
                                                    -3.615
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.873,
                                                    1.136
                                                ],
                                                [
                                                    -2.83,
                                                    -1.759
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.818,
                                                    0.157
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.335,
                                                    -4.225
                                                ],
                                                [
                                                    -2.759,
                                                    2.411
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.924,
                                                    -2.882
                                                ],
                                                [
                                                    3.145,
                                                    -1.242
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.309,
                                                    2.056
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.522,
                                                    -5.159
                                                ],
                                                [
                                                    14.204,
                                                    -0.439
                                                ],
                                                [
                                                    19.027,
                                                    7.943
                                                ],
                                                [
                                                    10.768,
                                                    4.363
                                                ],
                                                [
                                                    7.602,
                                                    1.278
                                                ],
                                                [
                                                    -7.428,
                                                    1.473
                                                ],
                                                [
                                                    -11.039,
                                                    10.749
                                                ],
                                                [
                                                    -19.027,
                                                    -2.562
                                                ],
                                                [
                                                    -18.984,
                                                    -2.731
                                                ],
                                                [
                                                    -12.069,
                                                    -9.507
                                                ],
                                                [
                                                    -2.653,
                                                    -8.562
                                                ],
                                                [
                                                    0.551,
                                                    -6.575
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            57.038,
                                            38.437
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.271,
                                                    0.081
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.31,
                                                    3.238
                                                ],
                                                [
                                                    -2.047,
                                                    3.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.869,
                                                    2.466
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.903,
                                                    2.649
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.445,
                                                    -4.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.157,
                                                    0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.64,
                                                    -3.352
                                                ],
                                                [
                                                    1.39,
                                                    -3.441
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.826,
                                                    -2.539
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.737,
                                                    -2.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.437,
                                                    4.06
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.051,
                                                    -11.244
                                                ],
                                                [
                                                    9.975,
                                                    -2.71
                                                ],
                                                [
                                                    -5.831,
                                                    24.241
                                                ],
                                                [
                                                    -6.263,
                                                    24.546
                                                ],
                                                [
                                                    -8.92,
                                                    20.139
                                                ],
                                                [
                                                    -9.975,
                                                    18.245
                                                ],
                                                [
                                                    -6.975,
                                                    8.49
                                                ],
                                                [
                                                    -1.712,
                                                    -1.15
                                                ],
                                                [
                                                    1.153,
                                                    -5.125
                                                ],
                                                [
                                                    1.199,
                                                    -13.147
                                                ],
                                                [
                                                    -1.492,
                                                    -16.69
                                                ],
                                                [
                                                    -2.932,
                                                    -24.559
                                                ],
                                                [
                                                    -2.619,
                                                    -24.627
                                                ],
                                                [
                                                    4.704,
                                                    -12.422
                                                ],
                                                [
                                                    5.051,
                                                    -11.249
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            40.944,
                                            60.43
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 14",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.174,
                                                    0.004
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.043,
                                                    -2.208
                                                ],
                                                [
                                                    -0.411,
                                                    -1.83
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.144,
                                                    -3.56
                                                ],
                                                [
                                                    1.441,
                                                    -1.763
                                                ],
                                                [
                                                    0.05,
                                                    -0.271
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.008,
                                                    6.814
                                                ],
                                                [
                                                    -0.102,
                                                    0.471
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.131,
                                                    0.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.386,
                                                    1.733
                                                ],
                                                [
                                                    -0.033,
                                                    1.882
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.898,
                                                    4.017
                                                ],
                                                [
                                                    -1.17,
                                                    1.941
                                                ],
                                                [
                                                    -0.195,
                                                    0.237
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.763,
                                                    -6.814
                                                ],
                                                [
                                                    0.008,
                                                    -0.474
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.715,
                                                    -13.526
                                                ],
                                                [
                                                    7.655,
                                                    -13.365
                                                ],
                                                [
                                                    4.583,
                                                    -10.246
                                                ],
                                                [
                                                    2.307,
                                                    -4.365
                                                ],
                                                [
                                                    2.587,
                                                    1.199
                                                ],
                                                [
                                                    3.757,
                                                    6.437
                                                ],
                                                [
                                                    2.079,
                                                    18.069
                                                ],
                                                [
                                                    -1.977,
                                                    23.434
                                                ],
                                                [
                                                    -2.434,
                                                    24.124
                                                ],
                                                [
                                                    -7.812,
                                                    14.831
                                                ],
                                                [
                                                    -7.888,
                                                    13.954
                                                ],
                                                [
                                                    -7.854,
                                                    -6.823
                                                ],
                                                [
                                                    -7.689,
                                                    -8.238
                                                ],
                                                [
                                                    1.587,
                                                    -24.124
                                                ],
                                                [
                                                    2.053,
                                                    -23.925
                                                ],
                                                [
                                                    7.888,
                                                    -13.84
                                                ],
                                                [
                                                    7.719,
                                                    -13.526
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            17.272,
                                            26.972
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 15",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.305,
                                                    -0.008
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.267,
                                                    -1.915
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.487,
                                                    -2.886
                                                ],
                                                [
                                                    1.733,
                                                    -8.678
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.377,
                                                    3.937
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.89,
                                                    3.119
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.293,
                                                    0.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.572,
                                                    2.242
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.61,
                                                    2.751
                                                ],
                                                [
                                                    -5.06,
                                                    6.831
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.924,
                                                    -3.399
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.526,
                                                    -4.224
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.932,
                                                    -14.776
                                                ],
                                                [
                                                    2.89,
                                                    -14.607
                                                ],
                                                [
                                                    3.009,
                                                    -13.946
                                                ],
                                                [
                                                    4.216,
                                                    -7.416
                                                ],
                                                [
                                                    7.386,
                                                    -3.204
                                                ],
                                                [
                                                    7.679,
                                                    4.293
                                                ],
                                                [
                                                    -3.674,
                                                    27.349
                                                ],
                                                [
                                                    -4.157,
                                                    28.197
                                                ],
                                                [
                                                    -6.687,
                                                    23.866
                                                ],
                                                [
                                                    -4.106,
                                                    10.496
                                                ],
                                                [
                                                    -5.034,
                                                    0.784
                                                ],
                                                [
                                                    -5.899,
                                                    -3.822
                                                ],
                                                [
                                                    -7.441,
                                                    -10.958
                                                ],
                                                [
                                                    -8.64,
                                                    -16.76
                                                ],
                                                [
                                                    -4.966,
                                                    -28.197
                                                ],
                                                [
                                                    2.932,
                                                    -14.772
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            35.121,
                                            50.482
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 16",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.496,
                                                    -3.895
                                                ],
                                                [
                                                    -1.14,
                                                    -5.856
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.584,
                                                    -2.458
                                                ],
                                                [
                                                    0.661,
                                                    -0.814
                                                ],
                                                [
                                                    0.173,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.606,
                                                    6.357
                                                ],
                                                [
                                                    -0.979,
                                                    2.564
                                                ],
                                                [
                                                    -1.708,
                                                    1.513
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.186,
                                                    -0.322
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.118,
                                                    -0.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.568,
                                                    2.971
                                                ],
                                                [
                                                    1.263,
                                                    5.835
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    2.526
                                                ],
                                                [
                                                    -0.267,
                                                    1.123
                                                ],
                                                [
                                                    -0.118,
                                                    0.144
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.873,
                                                    -5.692
                                                ],
                                                [
                                                    -0.322,
                                                    -2.686
                                                ],
                                                [
                                                    0.818,
                                                    -2.14
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.343,
                                                    -0.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.036,
                                                    -21.701
                                                ],
                                                [
                                                    7.062,
                                                    -21.565
                                                ],
                                                [
                                                    6.926,
                                                    -20.955
                                                ],
                                                [
                                                    3.689,
                                                    -10.174
                                                ],
                                                [
                                                    7.295,
                                                    7.365
                                                ],
                                                [
                                                    8.287,
                                                    18.001
                                                ],
                                                [
                                                    7.486,
                                                    25.523
                                                ],
                                                [
                                                    5.82,
                                                    30.252
                                                ],
                                                [
                                                    5.346,
                                                    30.493
                                                ],
                                                [
                                                    -8.257,
                                                    7.25
                                                ],
                                                [
                                                    -8.367,
                                                    6.772
                                                ],
                                                [
                                                    -5.303,
                                                    2.971
                                                ],
                                                [
                                                    -3.583,
                                                    -15.853
                                                ],
                                                [
                                                    -3.206,
                                                    -24.366
                                                ],
                                                [
                                                    1.46,
                                                    -30.299
                                                ],
                                                [
                                                    1.833,
                                                    -30.243
                                                ],
                                                [
                                                    2.557,
                                                    -29.947
                                                ],
                                                [
                                                    7.206,
                                                    -22.014
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            23.094,
                                            43.85
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 17",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.11,
                                                    -0.191
                                                ],
                                                [
                                                    0.246,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.229,
                                                    2.225
                                                ],
                                                [
                                                    -4.949,
                                                    -3.644
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.725,
                                                    -0.081
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.123,
                                                    0.199
                                                ],
                                                [
                                                    -0.03,
                                                    -0.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.085,
                                                    -3.107
                                                ],
                                                [
                                                    4.318,
                                                    -4.309
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.042,
                                                    1.741
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.244,
                                                    -0.231
                                                ],
                                                [
                                                    18.787,
                                                    10.939
                                                ],
                                                [
                                                    18.707,
                                                    11.435
                                                ],
                                                [
                                                    18.372,
                                                    11.134
                                                ],
                                                [
                                                    -12.901,
                                                    11.109
                                                ],
                                                [
                                                    -13.236,
                                                    11.138
                                                ],
                                                [
                                                    -17.999,
                                                    2.888
                                                ],
                                                [
                                                    -17.825,
                                                    2.579
                                                ],
                                                [
                                                    -14.986,
                                                    -6.397
                                                ],
                                                [
                                                    0.269,
                                                    -7.791
                                                ],
                                                [
                                                    4.566,
                                                    -3.68
                                                ],
                                                [
                                                    11.893,
                                                    -0.523
                                                ],
                                                [
                                                    12.24,
                                                    -0.227
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            63.821,
                                            46.611
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 18",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.081,
                                                    -0.08
                                                ],
                                                [
                                                    0.085,
                                                    -0.029
                                                ],
                                                [
                                                    4.242,
                                                    2.792
                                                ],
                                                [
                                                    2.573,
                                                    -5.717
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.568,
                                                    4.399
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.483,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.022,
                                                    2.076
                                                ],
                                                [
                                                    -4.326,
                                                    1.271
                                                ],
                                                [
                                                    -0.255,
                                                    -0.373
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.059,
                                                    0.097
                                                ],
                                                [
                                                    -0.076,
                                                    0.077
                                                ],
                                                [
                                                    -5.411,
                                                    1.716
                                                ],
                                                [
                                                    -5.717,
                                                    -3.365
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.593,
                                                    -4.386
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.301,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.953,
                                                    -3.242
                                                ],
                                                [
                                                    4.021,
                                                    -2.076
                                                ],
                                                [
                                                    0.411,
                                                    -0.119
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.437,
                                                    -13.079
                                                ],
                                                [
                                                    7.581,
                                                    -9.482
                                                ],
                                                [
                                                    19.459,
                                                    10.952
                                                ],
                                                [
                                                    19.251,
                                                    11.227
                                                ],
                                                [
                                                    19.014,
                                                    11.401
                                                ],
                                                [
                                                    4.725,
                                                    7.575
                                                ],
                                                [
                                                    -10.645,
                                                    13.16
                                                ],
                                                [
                                                    -11.047,
                                                    13.384
                                                ],
                                                [
                                                    -11.365,
                                                    13.448
                                                ],
                                                [
                                                    -19.103,
                                                    0.269
                                                ],
                                                [
                                                    -18.95,
                                                    -0.036
                                                ],
                                                [
                                                    -18.976,
                                                    -0.172
                                                ],
                                                [
                                                    -19.056,
                                                    -0.515
                                                ],
                                                [
                                                    -8.03,
                                                    -8.634
                                                ],
                                                [
                                                    3.856,
                                                    -13.189
                                                ],
                                                [
                                                    5.433,
                                                    -13.075
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            49.102,
                                            22.325
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 19",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.038,
                                                    0.145
                                                ],
                                                [
                                                    -5.377,
                                                    9.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.11,
                                                    -0.266
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.237,
                                                    0
                                                ],
                                                [
                                                    5.212,
                                                    -9.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.284,
                                                    0.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.866,
                                                    -13.276
                                                ],
                                                [
                                                    8.073,
                                                    13.912
                                                ],
                                                [
                                                    -23.629,
                                                    13.891
                                                ],
                                                [
                                                    -23.976,
                                                    13.653
                                                ],
                                                [
                                                    -8.094,
                                                    -13.598
                                                ],
                                                [
                                                    -7.738,
                                                    -13.607
                                                ],
                                                [
                                                    -7.632,
                                                    -13.912
                                                ],
                                                [
                                                    23.544,
                                                    -13.886
                                                ],
                                                [
                                                    23.866,
                                                    -13.281
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            58.662,
                                            71.323
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        }
    ]
};

//# sourceMappingURL=qa-automation.78e7ea17.js.map
